var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeReporting
    ? _c(
        "div",
        { staticClass: "section-reporting" },
        [
          !_vm.hideToPdf
            ? _c(
                "div",
                {
                  staticClass: "pages-sidebar",
                  class: { contract: _vm.tabsIsMinimize },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-title",
                      on: { click: _vm.toggleExpandTabs },
                    },
                    [_c("p", [_vm._v(_vm._s(_vm.$t("dash.tab.reporting")))])]
                  ),
                  _c("div", { staticClass: "show-setting" }, [
                    !_vm.tabsIsMinimize
                      ? _c(
                          "i",
                          {
                            staticClass: "material-icons expand-btn minimize",
                            on: { click: _vm.toggleExpandTabs },
                          },
                          [_vm._v("navigate_before")]
                        )
                      : _vm._e(),
                    _vm.tabsIsMinimize
                      ? _c(
                          "i",
                          {
                            staticClass: "material-icons expand-btn maximize",
                            on: { click: _vm.toggleExpandTabs },
                          },
                          [_vm._v("navigate_next")]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "search-page" },
                    [
                      _c("vs-input", {
                        staticClass: "inputx",
                        class: { input: true },
                        attrs: {
                          color: "#B20564",
                          "icon-after": "true",
                          icon: "search",
                          placeholder: _vm.$t(
                            "dash.settings.user.label.page_filter"
                          ),
                        },
                        model: {
                          value: _vm.pageFilter,
                          callback: function ($$v) {
                            _vm.pageFilter = $$v
                          },
                          expression: "pageFilter",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.groups && _vm.pages
                    ? _c(
                        "ul",
                        [
                          _vm._l(_vm.groups, function (group) {
                            return _c(
                              "li",
                              {
                                key: `page-sidebar-group-${group.id}`,
                                staticClass: "group",
                                class: [
                                  {
                                    show: group.show,
                                    hide:
                                      !_vm.checkPagesInGroup(group) ||
                                      _vm.checkGroupFilter(group),
                                  },
                                ],
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "group-wrapper",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleShowGroup(group)
                                      },
                                    },
                                  },
                                  [
                                    !group.show
                                      ? _c("img", {
                                          staticClass: "show-group",
                                          attrs: {
                                            alt: "show group",
                                            src: require("../../../assets/img/icon-show-group.svg"),
                                          },
                                        })
                                      : _c("img", {
                                          staticClass: "hide-group",
                                          attrs: {
                                            alt: "hide group",
                                            src: require("../../../assets/img/icon-hide-group.svg"),
                                          },
                                        }),
                                    _c(
                                      "div",
                                      { staticClass: "group-content" },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: group.name,
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "group-name messagedefilant",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      "data-text": group.name,
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(group.name)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "ul",
                                  _vm._l(group.pages, function (item) {
                                    return _c(
                                      "div",
                                      { key: `page-ingroup-sidebar-${item}` },
                                      [
                                        _vm.findPage(item)
                                          ? _c(
                                              "li",
                                              {
                                                staticClass: "page",
                                                class: [
                                                  {
                                                    disabled:
                                                      !_vm.checkLock(
                                                        _vm.findPage(item)
                                                          .network
                                                      ) ||
                                                      _vm.accessNotActived(
                                                        _vm.findPage(item)
                                                      ) ||
                                                      _vm.findPage(item)
                                                        .bot_status == 0,
                                                    hide: !_vm.checkPageFilter(
                                                      _vm.findPage(item)
                                                    ),
                                                  },
                                                ],
                                                on: {
                                                  click: function ($event) {
                                                    _vm.accessNotActived(
                                                      _vm.findPage(item)
                                                    )
                                                      ? _vm.confirmActiveAccess(
                                                          _vm.findPage(item)
                                                        )
                                                      : null
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "page-wrapper",
                                                    class: {
                                                      disabled:
                                                        !_vm.checkLock(
                                                          _vm.findPage(item)
                                                            .network
                                                        ) ||
                                                        _vm.accessNotActived(
                                                          _vm.findPage(item)
                                                        ) ||
                                                        _vm.findPage(item)
                                                          .bot_status == 0,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "checkbox",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.selectedTab,
                                                              expression:
                                                                "selectedTab",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            id: `pages-${
                                                              _vm.findPage(item)
                                                                .id
                                                            }`,
                                                            "data-qa": `reporting-selector-list-page-${
                                                              _vm.findPage(item)
                                                                .name
                                                            }`,
                                                            name: "pages[]",
                                                            disabled:
                                                              !_vm.checkLock(
                                                                _vm.findPage(
                                                                  item
                                                                ).network
                                                              ) ||
                                                              _vm.accessNotActived(
                                                                _vm.findPage(
                                                                  item
                                                                )
                                                              ) ||
                                                              _vm.findPage(item)
                                                                .bot_status ==
                                                                0,
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.pages.findIndex(
                                                                (p) =>
                                                                  p.id ==
                                                                  _vm.findPage(
                                                                    item
                                                                  ).id
                                                              ),
                                                            checked: _vm._q(
                                                              _vm.selectedTab,
                                                              _vm.pages.findIndex(
                                                                (p) =>
                                                                  p.id ==
                                                                  _vm.findPage(
                                                                    item
                                                                  ).id
                                                              )
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.updateSelected(
                                                                _vm.pages.findIndex(
                                                                  (p) =>
                                                                    p.id ==
                                                                    _vm.findPage(
                                                                      item
                                                                    ).id
                                                                )
                                                              )
                                                            },
                                                            change: function (
                                                              $event
                                                            ) {
                                                              _vm.selectedTab =
                                                                _vm.pages.findIndex(
                                                                  (p) =>
                                                                    p.id ==
                                                                    _vm.findPage(
                                                                      item
                                                                    ).id
                                                                )
                                                            },
                                                          },
                                                        }),
                                                        _vm._m(0, true),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "page-content",
                                                      },
                                                      [
                                                        _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.findPage(
                                                                item
                                                              ).name,
                                                              position: "top",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "page-image-avatar",
                                                              {
                                                                attrs: {
                                                                  page: _vm.findPage(
                                                                    item
                                                                  ),
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "page-name messagedefilant",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      "data-text":
                                                                        _vm.findPage(
                                                                          item
                                                                        ).name,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.findPage(
                                                                            item
                                                                          ).name
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          }),
                          _vm._l(_vm.pages, function (item, index) {
                            return _c(
                              "li",
                              {
                                key: `page-sidebar-${item.id}`,
                                staticClass: "page",
                                class: [
                                  {
                                    current: _vm.selectedTab == index,
                                    disabled:
                                      !_vm.checkLock(item.network) ||
                                      _vm.accessNotActived(item) ||
                                      item.bot_status == 0,
                                    hide:
                                      !_vm.checkPageFilter(item) ||
                                      _vm.pageInGroup(item),
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    _vm.accessNotActived(item)
                                      ? _vm.confirmActiveAccess(item)
                                      : null
                                  },
                                },
                              },
                              [
                                !_vm.pageInGroup(item)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "page-wrapper",
                                        class: {
                                          disabled:
                                            !_vm.checkLock(item.network) ||
                                            _vm.accessNotActived(item) ||
                                            item.bot_status == 0,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "page-content" },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: item.name,
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("page-image-avatar", {
                                                  attrs: { page: item },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "page-name messagedefilant",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          "data-text":
                                                            item.name,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "checkbox" }, [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.selectedTab,
                                                expression: "selectedTab",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: `pages-${item.id}`,
                                              "data-qa": `reporting-selector-list-page-${item.name}`,
                                              name: "pages[]",
                                              disabled:
                                                !_vm.checkLock(item.network) ||
                                                _vm.accessNotActived(item) ||
                                                item.bot_status == 0,
                                            },
                                            domProps: {
                                              value: index,
                                              checked: _vm._q(
                                                _vm.selectedTab,
                                                index
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateSelected(index)
                                              },
                                              change: function ($event) {
                                                _vm.selectedTab = index
                                              },
                                            },
                                          }),
                                          _vm._m(1, true),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          (_vm.progressFunction && _vm.showLoader) ||
          !_vm.groups ||
          _vm.pages.length == 0
            ? _c(
                "div",
                { staticClass: "progress-bar" },
                [
                  _c("component-loader", {
                    attrs: {
                      progress: _vm.progress,
                      unlimitedProgress:
                        !_vm.groups ||
                        _vm.pages.length == 0 ||
                        _vm.unlimitedProgress,
                      activeClose: true,
                    },
                    on: {
                      close: function ($event) {
                        _vm.showLoader = false
                      },
                    },
                  }),
                ],
                1
              )
            : _vm.updateCountDayLoader != null && _vm.updateCountDayLoader >= 0
            ? _c(
                "div",
                { staticClass: "progress-bar" },
                [
                  _c("component-loader", {
                    attrs: {
                      detail: this.updateDayLoader
                        ? _vm.$t("dash.reporting.day.load") +
                          this.updateDayLoader
                        : "",
                      progress:
                        Math.round(
                          (_vm.updateCountDayLoader /
                            _vm.updateTotalDayLoader) *
                            100
                        ) > 100
                          ? 100
                          : Math.round(
                              (_vm.updateCountDayLoader /
                                _vm.updateTotalDayLoader) *
                                100
                            ),
                      activeClose: true,
                    },
                    on: {
                      close: function ($event) {
                        _vm.updateCountDayLoader = null
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          !_vm.hideToPdf
            ? _c(
                "div",
                {
                  staticClass: "vs-con-loading__container",
                  attrs: { id: "pageReportingLoading" },
                },
                [
                  !_vm.currentPage
                    ? _c("h2", [
                        _vm._v(_vm._s(_vm.$t("dash.reporting.no_page"))),
                      ])
                    : _vm._e(),
                  _vm.currentPage
                    ? _c(
                        "div",
                        { staticClass: "reporting-date" },
                        [
                          _vm.currentPage.network == "pinterest" && _vm.boards
                            ? _c(
                                "vs-select",
                                {
                                  staticClass: "board-select",
                                  model: {
                                    value: _vm.boardSelected,
                                    callback: function ($$v) {
                                      _vm.boardSelected = $$v
                                    },
                                    expression: "boardSelected",
                                  },
                                },
                                _vm._l(
                                  _vm.boards.board.items,
                                  function (item, index) {
                                    return _c("vs-select-item", {
                                      key: `board-${index}`,
                                      attrs: { value: item, text: item.name },
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "frequency-wrapper" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.frequency.refresh"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.refresh.frequency,
                                          expression: "refresh.frequency",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.refresh,
                                            "frequency",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.refresh.allowed,
                                      function (freq, key) {
                                        return _c(
                                          "option",
                                          {
                                            key: `freq-${key}`,
                                            domProps: { value: freq },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                freq
                                                  ? freq + "sec"
                                                  : _vm.$t(
                                                      "dash.posts.no_refresh"
                                                    )
                                              )
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedTime,
                                  expression: "selectedTime",
                                },
                              ],
                              staticClass: "date-select",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedTime = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c("option", { domProps: { value: -1 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.reporting.period_custom"))
                                ),
                              ]),
                              _vm._l(_vm.selectTime, function (freq, key) {
                                return _c(
                                  "option",
                                  {
                                    key: `board-${key}`,
                                    domProps: { value: key },
                                  },
                                  [_vm._v(_vm._s(freq))]
                                )
                              }),
                            ],
                            2
                          ),
                          _c("component-datepicker", {
                            staticClass: "date",
                            attrs: {
                              from: this.disabledDate.fromStart,
                              to: this.disabledDate.toStart,
                              date: _vm.dateStart,
                            },
                            on: {
                              picked: _vm.setDateStart,
                              errorFormat: _vm.checkErrorFormatDateStart,
                            },
                          }),
                          _c("component-datepicker", {
                            staticClass: "date",
                            attrs: {
                              from: this.disabledDate.fromEnd,
                              to: this.disabledDate.toEnd,
                              date: _vm.dateEnd,
                            },
                            on: {
                              picked: _vm.setDateEnd,
                              errorFormat: _vm.checkErrorFormatDateEnd,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.popupUrlExportApi
                    ? _c(
                        "vs-popup",
                        {
                          staticClass: "overlay groups export-api-reporting",
                          attrs: {
                            title: _vm.$t(
                              "dash.reporting.export_api.overlay.title"
                            ),
                            active: _vm.popupUrlExportApi,
                          },
                          on: {
                            "update:active": function ($event) {
                              _vm.popupUrlExportApi = $event
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "link_to_copy",
                              on: {
                                click: function ($event) {
                                  return _vm.copyUrlExportApi()
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.urlExportApi.substr(0, 50)) +
                                    " ..."
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/img/copy_icon.svg"),
                                  alt: "unlock",
                                },
                              }),
                            ]
                          ),
                          _c("br"),
                          _c(
                            "vs-button",
                            {
                              staticClass: "btnx",
                              attrs: { type: "filled" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.copyUrlExportApi()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.$t("dash.button.copy")) +
                                  "\n      "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.activeReportingV2 &&
                  _vm.currentPage &&
                  ["facebook", "instagram", "linkedin", "tiktok"].includes(
                    _vm.currentPage.network
                  ) &&
                  !_vm.currentPage.isGroup
                    ? _c(
                        "Tooltip",
                        {
                          staticClass: "update-button one-button",
                          attrs: { text: _vm.$t("dash.reporting.update_data") },
                        },
                        [
                          _c(
                            "vs-button",
                            {
                              attrs: {
                                disabled:
                                  !_vm.pageStats ||
                                  _vm.updateCountDayLoader != null,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getPageStat(true)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("sync"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentPage &&
                  (_vm.currentPage.network != "pinterest" ||
                    (_vm.currentPage.network == "pinterest" && _vm.boards)) &&
                  !_vm.errorFormatDateStart &&
                  !_vm.errorFormatDateEnd
                    ? _c(
                        "vs-button",
                        {
                          staticClass: "search-button",
                          class: [
                            {
                              "one-button":
                                _vm.activeReportingV2 &&
                                _vm.currentPage &&
                                ["facebook", "instagram", "linkedin"].includes(
                                  _vm.currentPage.network
                                ) &&
                                !_vm.currentPage.isGroup,
                            },
                          ],
                          attrs: { "data-qa": `reporting-run-search` },
                          on: {
                            click: function ($event) {
                              return _vm.getPageStat()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("dash.reporting.search")))]
                      )
                    : _vm._e(),
                  _vm.refresh.last
                    ? _c(
                        "span",
                        {
                          staticClass: "last-update",
                          class: [
                            {
                              "more-buttons one-button":
                                _vm.activeReportingV2 &&
                                _vm.currentPage &&
                                ["facebook", "instagram", "linkedin"].includes(
                                  _vm.currentPage.network
                                ) &&
                                !_vm.currentPage.isGroup,
                            },
                          ],
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("dash.reporting.last-update")) +
                              " : " +
                              _vm._s(_vm.formatDate(_vm.refresh.last))
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.lastPage
                    ? _c(
                        "div",
                        { staticClass: "current-page" },
                        [
                          _c("page-image-avatar", {
                            attrs: { page: _vm.lastPage },
                          }),
                          _c(
                            "a",
                            { attrs: { href: _vm.linkPage, target: "_blank" } },
                            [
                              _c("h1", { staticClass: "title-page" }, [
                                _vm._v(_vm._s(_vm.lastPage.name)),
                              ]),
                            ]
                          ),
                          _c("span", { staticClass: "date-print" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("dash.reporting.from")) +
                                " " +
                                _vm._s(_vm.formatDate(_vm.dateStart, false)) +
                                " " +
                                _vm._s(_vm.$t("dash.reporting.to")) +
                                " " +
                                _vm._s(_vm.formatDate(_vm.dateEnd, false)) +
                                " "
                            ),
                          ]),
                          _vm.pageStats
                            ? _c(
                                "vs-button",
                                {
                                  staticClass: "btn-img exportBtn",
                                  attrs: {
                                    size: "small",
                                    color: "#2F1937",
                                    "vs-type": "filled",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.popupActivo2 = true
                                    },
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("dash.button.exportGraphs"))
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/icon_export.svg"),
                                      alt: "unlock",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "vs-popup",
                            {
                              attrs: {
                                title: "Export",
                                active: _vm.popupActivo2,
                              },
                              on: {
                                "update:active": function ($event) {
                                  _vm.popupActivo2 = $event
                                },
                              },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("dash.export.selectformat")) +
                                    "\n        "
                                ),
                              ]),
                              _vm.checkLock("conciergerie")
                                ? [
                                    [
                                      "facebook",
                                      "instagram",
                                      "linkedin",
                                      "tiktok",
                                    ].includes(_vm.lastPage.network)
                                      ? _c(
                                          "vs-button",
                                          {
                                            staticClass: "btnFormat",
                                            attrs: {
                                              disabled:
                                                !_vm.pageStats ||
                                                _vm.updateCountDayLoader !=
                                                  null ||
                                                !(
                                                  _vm.pageStats &&
                                                  _vm.pageStats.page &&
                                                  _vm.pageStats.page
                                                    .previous_period
                                                ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.getPDF()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n            pdf\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    [
                                      "facebook",
                                      "instagram",
                                      "linkedin",
                                      "tiktok",
                                    ].includes(_vm.lastPage.network)
                                      ? _c(
                                          "vs-button",
                                          {
                                            staticClass: "btnFormat",
                                            staticStyle: {
                                              "margin-top": "10px",
                                              "margin-right": "10px",
                                              "margin-left": "10px",
                                            },
                                            attrs: {
                                              disabled:
                                                !_vm.pageStats ||
                                                _vm.updateCountDayLoader !=
                                                  null,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.getExportApiUrl()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n            api\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: _vm.$t(
                                            "dash.plan.active_conciergerie_to_get_features.content_export_reporting"
                                          ),
                                        },
                                      },
                                      [
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                          "tiktok",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "vs-button",
                                              {
                                                staticClass: "btnFormat",
                                                attrs: {
                                                  disabled:
                                                    !_vm.pageStats ||
                                                    _vm.updateCountDayLoader !=
                                                      null,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goToSettings()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n              pdf\n            "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: _vm.$t(
                                            "dash.plan.active_conciergerie_to_get_features.content_export_reporting"
                                          ),
                                        },
                                      },
                                      [
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                          "tiktok",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "vs-button",
                                              {
                                                staticClass: "btnFormat",
                                                staticStyle: {
                                                  "margin-top": "10px",
                                                  "margin-right": "10px",
                                                  "margin-left": "10px",
                                                },
                                                attrs: {
                                                  disabled:
                                                    !_vm.pageStats ||
                                                    _vm.updateCountDayLoader !=
                                                      null,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goToSettings()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n              api\n            "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                              _vm._l(_vm.formats, function (format) {
                                return _c(
                                  "vs-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.pageStats &&
                                          _vm.pageStats.page.nb_posts > 0,
                                        expression:
                                          "pageStats && pageStats.page.nb_posts > 0",
                                      },
                                    ],
                                    key: `format-${format.value}`,
                                    staticClass: "btnFormat",
                                    staticStyle: {
                                      "margin-top": "10px",
                                      "margin-right": "10px",
                                      "margin-left": "10px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportData(
                                          format.value,
                                          "graphs"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(format.value) + "\n        ")]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.pageStats && !_vm.progressFunction
                    ? _c("h2", [
                        _vm._v(_vm._s(_vm.$t("dash.reporting.select_page"))),
                      ])
                    : _vm._e(),
                  _vm.pageStats
                    ? _c(
                        "div",
                        { staticClass: "informations" },
                        [
                          _vm.pageStats
                            ? _c(
                                "div",
                                { staticClass: "main-numbers" },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-user-group",
                                  }),
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          ["linkedin", "facebook"].includes(
                                            _vm.lastPage.network
                                          )
                                            ? "dash.label.fb.page_follows"
                                            : "dash.reporting.nb_fans"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    staticClass: "icon fan-ico",
                                    attrs: {
                                      src: require("../../../assets/img/reporting_icons/fans.svg"),
                                      alt: "",
                                    },
                                  }),
                                  _vm.pageStats.page.page_fans >= 1000000
                                    ? _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.numberSpacing(
                                              _vm.pageStats.page.page_fans
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "big-number" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.numberSpacing(
                                                    Number(
                                                      _vm.pageStats.page
                                                        .page_fans / 1000000
                                                    ).toLocaleString(
                                                      _vm.$i18n.locale,
                                                      {
                                                        maximumFractionDigits: 1,
                                                      }
                                                    )
                                                  )
                                                )
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "percent" },
                                                [_vm._v("M")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm.pageStats.page.page_fans >= 1000
                                    ? _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.numberSpacing(
                                              _vm.pageStats.page.page_fans
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "big-number" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.numberSpacing(
                                                    Number(
                                                      _vm.pageStats.page
                                                        .page_fans / 1000
                                                    ).toLocaleString(
                                                      _vm.$i18n.locale,
                                                      {
                                                        maximumFractionDigits: 1,
                                                      }
                                                    )
                                                  )
                                                )
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "percent" },
                                                [_vm._v("k")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.numberSpacing(
                                              _vm.pageStats.page.page_fans
                                            )
                                          )
                                        ),
                                      ]),
                                  _vm.activeReportingV2 &&
                                  !_vm.pageStats.page.previous_period &&
                                  [
                                    "facebook",
                                    "instagram",
                                    "linkedin",
                                  ].includes(_vm.lastPage.network)
                                    ? _c(
                                        "div",
                                        { staticClass: "compare wait" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../assets/img/status-waiting.gif"),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm.pageStats.page.previous_period &&
                                      _vm.pageStats.page.previous_period
                                        .page_fans
                                    ? _c(
                                        "div",
                                        { staticClass: "compare" },
                                        [
                                          _vm.pageStats.page.page_fans <
                                          _vm.pageStats.page.previous_period
                                            .page_fans
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  staticClass: "trending_down",
                                                  attrs: {
                                                    text:
                                                      _vm.$t(
                                                        "dash.reporting.previous_period"
                                                      ) +
                                                      " (" +
                                                      _vm.$t(
                                                        "dash.reporting.from"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .start,
                                                        false
                                                      ) +
                                                      " " +
                                                      _vm.$t(
                                                        "dash.reporting.to"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .end,
                                                        false
                                                      ) +
                                                      ") : " +
                                                      _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_fans
                                                      ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "negative" },
                                                    [
                                                      _vm._v(
                                                        "-" +
                                                          _vm._s(
                                                            _vm.formatPercentageChange(
                                                              100 -
                                                                (_vm.pageStats
                                                                  .page
                                                                  .page_fans /
                                                                  _vm.pageStats
                                                                    .page
                                                                    .previous_period
                                                                    .page_fans) *
                                                                  100
                                                            )
                                                          ) +
                                                          "%"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("trending_up")]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-arrow-right negative",
                                                    staticStyle: {
                                                      transform:
                                                        "rotate(45deg)",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.pageStats.page.page_fans != 0 &&
                                          _vm.pageStats.page.page_fans ==
                                            _vm.pageStats.page.previous_period
                                              .page_fans
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  staticClass: "trending_flat",
                                                  attrs: {
                                                    text:
                                                      _vm.$t(
                                                        "dash.reporting.previous_period"
                                                      ) +
                                                      " (" +
                                                      _vm.$t(
                                                        "dash.reporting.from"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .start,
                                                        false
                                                      ) +
                                                      " " +
                                                      _vm.$t(
                                                        "dash.reporting.to"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .end,
                                                        false
                                                      ) +
                                                      ") : " +
                                                      _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_fans
                                                      ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("trending_up")]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-arrow-right",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.pageStats.page.page_fans >
                                          _vm.pageStats.page.previous_period
                                            .page_fans
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  staticClass: "trending_up",
                                                  attrs: {
                                                    text:
                                                      _vm.$t(
                                                        "dash.reporting.previous_period"
                                                      ) +
                                                      " (" +
                                                      _vm.$t(
                                                        "dash.reporting.from"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .start,
                                                        false
                                                      ) +
                                                      " " +
                                                      _vm.$t(
                                                        "dash.reporting.to"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .end,
                                                        false
                                                      ) +
                                                      ") : " +
                                                      _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_fans
                                                      ),
                                                  },
                                                },
                                                [
                                                  _vm.pageStats.page
                                                    .previous_period.page_fans >
                                                  0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "positive",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "+" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  (_vm.pageStats
                                                                    .page
                                                                    .page_fans /
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .page_fans) *
                                                                    100 -
                                                                    100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("trending_up")]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-arrow-right positive",
                                                    staticStyle: {
                                                      transform:
                                                        "rotate(-45deg)",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c("img", {
                                attrs: {
                                  src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                  alt: "",
                                },
                              }),
                          _vm.pageStats
                            ? _c(
                                "div",
                                { staticClass: "main-numbers" },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-square-plus",
                                  }),
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.capitalize(
                                          _vm.$t("dash.posts.title")
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    staticClass: "icon post-ico",
                                    attrs: {
                                      src: require("../../../assets/img/reporting_icons/posts.svg"),
                                      alt: "",
                                    },
                                  }),
                                  _vm.pageStats.page.nb_posts >= 1000000
                                    ? _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.numberSpacing(
                                              _vm.pageStats.page.nb_posts
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "big-number" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.numberSpacing(
                                                    Number(
                                                      _vm.pageStats.page
                                                        .nb_posts / 1000000
                                                    ).toLocaleString(
                                                      _vm.$i18n.locale,
                                                      {
                                                        maximumFractionDigits: 1,
                                                      }
                                                    )
                                                  )
                                                )
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "percent" },
                                                [_vm._v("M")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm.pageStats.page.nb_posts >= 1000
                                    ? _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.numberSpacing(
                                              _vm.pageStats.page.nb_posts
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "big-number" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.numberSpacing(
                                                    Number(
                                                      _vm.pageStats.page
                                                        .nb_posts / 1000
                                                    ).toLocaleString(
                                                      _vm.$i18n.locale,
                                                      {
                                                        maximumFractionDigits: 1,
                                                      }
                                                    )
                                                  )
                                                )
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "percent" },
                                                [_vm._v("k")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.numberSpacing(
                                              _vm.pageStats.page.nb_posts
                                            )
                                          )
                                        ),
                                      ]),
                                  _vm.activeReportingV2 &&
                                  !_vm.pageStats.page.previous_period &&
                                  [
                                    "facebook",
                                    "instagram",
                                    "linkedin",
                                  ].includes(_vm.lastPage.network)
                                    ? _c(
                                        "div",
                                        { staticClass: "compare wait" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../assets/img/status-waiting.gif"),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm.pageStats.page.previous_period &&
                                      _vm.pageStats.page.previous_period
                                        .nb_posts >= 0
                                    ? _c(
                                        "div",
                                        { staticClass: "compare" },
                                        [
                                          _vm.pageStats.page.nb_posts <
                                          _vm.pageStats.page.previous_period
                                            .nb_posts
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  staticClass: "trending_down",
                                                  attrs: {
                                                    text:
                                                      _vm.$t(
                                                        "dash.reporting.previous_period"
                                                      ) +
                                                      " (" +
                                                      _vm.$t(
                                                        "dash.reporting.from"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .start,
                                                        false
                                                      ) +
                                                      " " +
                                                      _vm.$t(
                                                        "dash.reporting.to"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .end,
                                                        false
                                                      ) +
                                                      ") : " +
                                                      _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .nb_posts
                                                      ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "negative" },
                                                    [
                                                      _vm._v(
                                                        "-" +
                                                          _vm._s(
                                                            _vm.formatPercentageChange(
                                                              100 -
                                                                (_vm.pageStats
                                                                  .page
                                                                  .nb_posts /
                                                                  _vm.pageStats
                                                                    .page
                                                                    .previous_period
                                                                    .nb_posts) *
                                                                  100
                                                            )
                                                          ) +
                                                          "%"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("trending_up")]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-arrow-right negative",
                                                    staticStyle: {
                                                      transform:
                                                        "rotate(45deg)",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.pageStats.page.nb_posts != 0 &&
                                          _vm.pageStats.page.nb_posts ==
                                            _vm.pageStats.page.previous_period
                                              .nb_posts
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  staticClass: "trending_flat",
                                                  attrs: {
                                                    text:
                                                      _vm.$t(
                                                        "dash.reporting.previous_period"
                                                      ) +
                                                      " (" +
                                                      _vm.$t(
                                                        "dash.reporting.from"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .start,
                                                        false
                                                      ) +
                                                      " " +
                                                      _vm.$t(
                                                        "dash.reporting.to"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .end,
                                                        false
                                                      ) +
                                                      ") : " +
                                                      _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .nb_posts
                                                      ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("trending_up")]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-arrow-right",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.pageStats.page.nb_posts >
                                          _vm.pageStats.page.previous_period
                                            .nb_posts
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  staticClass: "trending_up",
                                                  attrs: {
                                                    text:
                                                      _vm.$t(
                                                        "dash.reporting.previous_period"
                                                      ) +
                                                      " (" +
                                                      _vm.$t(
                                                        "dash.reporting.from"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .start,
                                                        false
                                                      ) +
                                                      " " +
                                                      _vm.$t(
                                                        "dash.reporting.to"
                                                      ) +
                                                      " " +
                                                      _vm.formatDate(
                                                        _vm.getPreviousPeriod
                                                          .end,
                                                        false
                                                      ) +
                                                      ") : " +
                                                      _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .nb_posts
                                                      ),
                                                  },
                                                },
                                                [
                                                  _vm.pageStats.page
                                                    .previous_period.nb_posts >
                                                  0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "positive",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "+" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  (_vm.pageStats
                                                                    .page
                                                                    .nb_posts /
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .nb_posts) *
                                                                    100 -
                                                                    100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("trending_up")]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-arrow-right positive",
                                                    staticStyle: {
                                                      transform:
                                                        "rotate(-45deg)",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c("img", {
                                attrs: {
                                  src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                  alt: "",
                                },
                              }),
                          _vm.lastPage.network == "linkedin"
                            ? [
                                _vm.pageStats && !_vm.lastPage.isGroup
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-eye",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.reporting.impression"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon imp-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/impression.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.pageStats.page
                                          .shareImpressionCount === null
                                          ? _c("p", [_vm._v("N/A")])
                                          : _vm.pageStats.page
                                              .shareImpressionCount >= 1000000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .shareImpressionCount
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareImpressionCount /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .shareImpressionCount >= 1000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .shareImpressionCount
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareImpressionCount /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .shareImpressionCount
                                                  )
                                                )
                                              ),
                                            ]),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .shareImpressionCount >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                _vm.pageStats.page
                                                  .shareImpressionCount <
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareImpressionCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareImpressionCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (_vm
                                                                        .pageStats
                                                                        .page
                                                                        .shareImpressionCount /
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .previous_period
                                                                          .shareImpressionCount) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareImpressionCount != 0 &&
                                                _vm.pageStats.page
                                                  .shareImpressionCount ==
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .shareImpressionCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareImpressionCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareImpressionCount >
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareImpressionCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareImpressionCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .shareImpressionCount >
                                                        0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (_vm
                                                                          .pageStats
                                                                          .page
                                                                          .shareImpressionCount /
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .shareImpressionCount) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : !_vm.lastPage.isGroup
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.pageStats && !_vm.lastPage.isGroup
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-eye",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.reporting.impression_unique"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon imp-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/impression.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.pageStats.page
                                          .shareUniqueImpressionCount === null
                                          ? _c("p", [_vm._v("N/A")])
                                          : _vm.pageStats.page
                                              .shareUniqueImpressionCount >=
                                            1000000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .shareUniqueImpressionCount
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareUniqueImpressionCount /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .shareUniqueImpressionCount >=
                                            1000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .shareUniqueImpressionCount
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareUniqueImpressionCount /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .shareUniqueImpressionCount
                                                  )
                                                )
                                              ),
                                            ]),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .shareUniqueImpressionCount >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                _vm.pageStats.page
                                                  .shareUniqueImpressionCount <
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareUniqueImpressionCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareUniqueImpressionCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (_vm
                                                                        .pageStats
                                                                        .page
                                                                        .shareUniqueImpressionCount /
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .previous_period
                                                                          .shareUniqueImpressionCount) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareUniqueImpressionCount !=
                                                  0 &&
                                                _vm.pageStats.page
                                                  .shareUniqueImpressionCount ==
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .shareUniqueImpressionCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareUniqueImpressionCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareUniqueImpressionCount >
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareUniqueImpressionCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareUniqueImpressionCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .shareUniqueImpressionCount >
                                                        0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (_vm
                                                                          .pageStats
                                                                          .page
                                                                          .shareUniqueImpressionCount /
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .shareUniqueImpressionCount) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : !_vm.lastPage.isGroup
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            : [
                                _vm.pageStats && !_vm.lastPage.isGroup
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-eye",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.reporting.impression"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon imp-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/impression.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.pageStats.page.totalImpressions ===
                                        null
                                          ? _c("p", [_vm._v("N/A")])
                                          : _vm.pageStats.page
                                              .totalImpressions >= 1000000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .totalImpressions
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalImpressions /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .totalImpressions >= 1000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .totalImpressions
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalImpressions /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .totalImpressions
                                                  )
                                                )
                                              ),
                                            ]),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .totalImpressions >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                _vm.pageStats.page
                                                  .totalImpressions <
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .totalImpressions
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .totalImpressions
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (_vm
                                                                        .pageStats
                                                                        .page
                                                                        .totalImpressions /
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .previous_period
                                                                          .totalImpressions) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .totalImpressions != 0 &&
                                                _vm.pageStats.page
                                                  .totalImpressions ==
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .totalImpressions
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .totalImpressions
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .totalImpressions >
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .totalImpressions
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .totalImpressions
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .totalImpressions > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (_vm
                                                                          .pageStats
                                                                          .page
                                                                          .totalImpressions /
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .totalImpressions) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : !_vm.lastPage.isGroup
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                          _vm.lastPage.network == "linkedin"
                            ? [
                                _vm.pageStats &&
                                _vm.lastPage.network !== "instagram" &&
                                _vm.lastPage.network !== "tiktok" &&
                                !_vm.lastPage.isGroup
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-arrow-pointer",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.reporting.clic")
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon eng-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/clic.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.pageStats.page.shareClickCount ===
                                        null
                                          ? _c("p", [_vm._v("N/A")])
                                          : _vm.pageStats.page
                                              .shareClickCount >= 1000000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .shareClickCount
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareClickCount /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .shareClickCount >= 1000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .shareClickCount
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareClickCount /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .shareClickCount
                                                  )
                                                )
                                              ),
                                            ]),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .shareClickCount >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                _vm.pageStats.page
                                                  .shareClickCount <
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareClickCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareClickCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (_vm
                                                                        .pageStats
                                                                        .page
                                                                        .shareClickCount /
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .previous_period
                                                                          .shareClickCount) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareClickCount != 0 &&
                                                _vm.pageStats.page
                                                  .shareClickCount ==
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .shareClickCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareClickCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareClickCount >
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareClickCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareClickCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .shareClickCount > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (_vm
                                                                          .pageStats
                                                                          .page
                                                                          .shareClickCount /
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .shareClickCount) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm.lastPage.network !== "instagram" &&
                                    !_vm.lastPage.isGroup
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            : [
                                _vm.pageStats &&
                                _vm.lastPage.network !== "instagram" &&
                                _vm.lastPage.network !== "tiktok" &&
                                !_vm.lastPage.isGroup
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-arrow-pointer",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.reporting.clic")
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon eng-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/clic.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.pageStats.page.totalClicks === null
                                          ? _c("p", [_vm._v("N/A")])
                                          : _vm.pageStats.page.totalClicks >=
                                              1000000 &&
                                            _vm.lastPage.network == "pinterest"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numbersubstring(
                                                    _vm.pageStats.page
                                                      .totalClicksRate
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalClicks /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.pageStats.page.totalClicks >=
                                              1000 &&
                                            _vm.lastPage.network == "pinterest"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text:
                                                    _vm.numberSpacing(
                                                      _vm.pageStats.page
                                                        .totalClicks
                                                    ) +
                                                    "(" +
                                                    _vm.numbersubstring(
                                                      _vm.pageStats.page
                                                        .totalClicksRate
                                                    ) +
                                                    "%)",
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalClicks /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.pageStats.page.totalClicks >=
                                            1000000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .totalClicks
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalClicks /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.pageStats.page.totalClicks >=
                                            1000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .totalClicks
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalClicks /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.lastPage.network == "pinterest"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text:
                                                    _vm.numbersubstring(
                                                      _vm.pageStats.page
                                                        .totalClicksRate
                                                    ) + "%",
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .totalClicks
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .totalClicks
                                                  )
                                                )
                                              ),
                                            ]),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .totalClicks >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                _vm.pageStats.page.totalClicks <
                                                _vm.pageStats.page
                                                  .previous_period.totalClicks
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .totalClicks
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (_vm
                                                                        .pageStats
                                                                        .page
                                                                        .totalClicks /
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .previous_period
                                                                          .totalClicks) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .totalClicks != 0 &&
                                                _vm.pageStats.page
                                                  .totalClicks ==
                                                  _vm.pageStats.page
                                                    .previous_period.totalClicks
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .totalClicks
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page.totalClicks >
                                                _vm.pageStats.page
                                                  .previous_period.totalClicks
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .totalClicks
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .totalClicks > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (_vm
                                                                          .pageStats
                                                                          .page
                                                                          .totalClicks /
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .totalClicks) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm.lastPage.network !== "instagram" &&
                                    _vm.lastPage.network !== "tiktok" &&
                                    !_vm.lastPage.isGroup
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                          _vm.lastPage.network == "linkedin" ||
                          _vm.lastPage.network == "tiktok"
                            ? [
                                _vm.pageStats &&
                                _vm.lastPage.network != "pinterest"
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-hand-point-up",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.reporting.comment")
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon eng-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/clic.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.tooltip_interactionsLI"
                                              ),
                                            },
                                          },
                                          [
                                            _vm.pageStats.page
                                              .shareCommentCount === null
                                              ? _c("p", [_vm._v("N/A")])
                                              : _vm.pageStats.page
                                                  .shareCommentCount >= 1000000
                                              ? _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareCommentCount /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                )
                                              : _vm.pageStats.page
                                                  .shareCommentCount >= 1000
                                              ? _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareCommentCount /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .shareCommentCount
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .shareCommentCount >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                _vm.pageStats.page
                                                  .shareCommentCount <
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareCommentCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareCommentCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (_vm
                                                                        .pageStats
                                                                        .page
                                                                        .shareCommentCount /
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .previous_period
                                                                          .shareCommentCount) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareLikeCount != 0 &&
                                                _vm.pageStats.page
                                                  .shareLikeCount ==
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .shareCommentCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareCommentCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareCommentCount >
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareCommentCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareCommentCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .shareCommentCount > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (_vm
                                                                          .pageStats
                                                                          .page
                                                                          .shareCommentCount /
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .shareCommentCount) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm.lastPage.network !== "instagram" &&
                                    !_vm.lastPage.isGroup &&
                                    _vm.lastPage.network != "pinterest"
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.pageStats &&
                                _vm.lastPage.network != "pinterest"
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-hand-point-up",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.reporting.like")
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon eng-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/clic.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.tooltip_interactionsLI"
                                              ),
                                            },
                                          },
                                          [
                                            _vm.pageStats.page
                                              .shareLikeCount === null
                                              ? _c("p", [_vm._v("N/A")])
                                              : _vm.pageStats.page
                                                  .shareLikeCount >= 1000000
                                              ? _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareLikeCount /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                )
                                              : _vm.pageStats.page
                                                  .shareLikeCount >= 1000
                                              ? _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareLikeCount /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .shareLikeCount
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .shareLikeCount >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                _vm.pageStats.page
                                                  .shareLikeCount <
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareLikeCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareLikeCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (_vm
                                                                        .pageStats
                                                                        .page
                                                                        .shareLikeCount /
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .previous_period
                                                                          .shareLikeCount) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareLikeCount != 0 &&
                                                _vm.pageStats.page
                                                  .shareLikeCount ==
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .shareLikeCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareLikeCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareLikeCount >
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareLikeCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareLikeCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .shareLikeCount > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (_vm
                                                                          .pageStats
                                                                          .page
                                                                          .shareLikeCount /
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .shareLikeCount) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm.lastPage.network !== "instagram" &&
                                    !_vm.lastPage.isGroup &&
                                    _vm.lastPage.network != "pinterest"
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.pageStats &&
                                _vm.lastPage.network != "pinterest"
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-hand-point-up",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.reporting.share")
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon eng-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/clic.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.tooltip_interactionsLI"
                                              ),
                                            },
                                          },
                                          [
                                            _vm.pageStats.page
                                              .shareShareCount === null
                                              ? _c("p", [_vm._v("N/A")])
                                              : _vm.pageStats.page
                                                  .shareShareCount >= 1000000
                                              ? _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareShareCount /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                )
                                              : _vm.pageStats.page
                                                  .shareShareCount >= 1000
                                              ? _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .shareShareCount /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .shareShareCount
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .shareShareCount >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                _vm.pageStats.page
                                                  .shareShareCount <
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareShareCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareShareCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (_vm
                                                                        .pageStats
                                                                        .page
                                                                        .shareShareCount /
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .previous_period
                                                                          .shareShareCount) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareShareCount != 0 &&
                                                _vm.pageStats.page
                                                  .shareShareCount ==
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .shareShareCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareShareCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .shareShareCount >
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .shareShareCount
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .shareShareCount
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .shareShareCount > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (_vm
                                                                          .pageStats
                                                                          .page
                                                                          .shareShareCount /
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .shareShareCount) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm.lastPage.network !== "instagram" &&
                                    !_vm.lastPage.isGroup &&
                                    _vm.lastPage.network != "pinterest"
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            : [
                                _vm.pageStats &&
                                _vm.lastPage.network != "pinterest"
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-hand-point-up",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.reporting.interactions"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon eng-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/clic.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.lastPage.network == "facebook"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: `${_vm.$t(
                                                    "dash.reporting.tooltip_interactionsFB"
                                                  )} : ${_vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .totalInteractions ||
                                                      _vm.pageStats.page
                                                        .totalEngagement
                                                  )}`,
                                                },
                                              },
                                              [
                                                !_vm.pageStats.page
                                                  .totalInteractions &&
                                                !_vm.pageStats.page
                                                  .totalEngagement
                                                  ? _c("p", [_vm._v("N/A")])
                                                  : _vm.pageStats.page
                                                      .totalInteractions >=
                                                    1000000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalInteractions /
                                                                  1000000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("M")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.pageStats.page
                                                      .totalInteractions >= 1000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalInteractions /
                                                                  1000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("k")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.pageStats.page
                                                      .totalInteractions
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .totalInteractions
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.pageStats.page
                                                      .totalEngagement >=
                                                    1000000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalEngagement /
                                                                  1000000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("M")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.pageStats.page
                                                      .totalEngagement >= 1000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalEngagement /
                                                                  1000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("k")]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .totalInteractions ||
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalEngagement
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          : _vm.lastPage.network == "twitter"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.tooltip_interactionsTW"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm.pageStats.page
                                                  .totalInteractions === null
                                                  ? _c("p", [_vm._v("N/A")])
                                                  : _vm.pageStats.page
                                                      .totalInteractions >=
                                                    1000000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalInteractions /
                                                                  1000000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("M")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.pageStats.page
                                                      .totalInteractions >= 1000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalInteractions /
                                                                  1000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("k")]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .totalInteractions
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          : _vm.lastPage.network == "instagram"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.tooltip_interactionsIG"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm.pageStats.page
                                                  .totalInteractions === null
                                                  ? _c("p", [_vm._v("N/A")])
                                                  : _vm.pageStats.page
                                                      .totalInteractions >=
                                                    1000000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalInteractions /
                                                                  1000000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("M")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.pageStats.page
                                                      .totalInteractions >= 1000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalInteractions /
                                                                  1000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("k")]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .totalInteractions
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          : _vm.lastPage.network == "linkedin"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.tooltip_interactionsLI"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm.pageStats.page
                                                  .totalInteractions === null
                                                  ? _c("p", [_vm._v("N/A")])
                                                  : _vm.pageStats.page
                                                      .totalInteractions >=
                                                    1000000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalInteractions /
                                                                  1000000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("M")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.pageStats.page
                                                      .totalInteractions >= 1000
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .totalInteractions /
                                                                  1000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("k")]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .totalInteractions
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .totalInteractions >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                _vm.pageStats.page
                                                  .totalInteractions <
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .totalInteractions
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .totalInteractions
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (_vm
                                                                        .pageStats
                                                                        .page
                                                                        .totalInteractions /
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .previous_period
                                                                          .totalInteractions) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .totalInteractions != 0 &&
                                                _vm.pageStats.page
                                                  .totalInteractions ==
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .totalInteractions
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .totalInteractions
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.pageStats.page
                                                  .totalInteractions >
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .totalInteractions
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.numberSpacing(
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .totalInteractions
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .totalInteractions > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (_vm
                                                                          .pageStats
                                                                          .page
                                                                          .totalInteractions /
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .totalInteractions) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm.lastPage.network !== "instagram" &&
                                    !_vm.lastPage.isGroup &&
                                    _vm.lastPage.network != "pinterest"
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                          _vm.lastPage.network == "linkedin"
                            ? [
                                _vm.pageStats && !_vm.lastPage.isGroup
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-handshake-angle",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.reporting.engagemment"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon imp-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/impression.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.pageStats.page.shareEngagement ===
                                        null
                                          ? _c("p", [_vm._v("N/A")])
                                          : _vm.lastPage.network == "pinterest"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .totalEngagements
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        (
                                                          _vm.pageStats.page
                                                            .shareEngagement *
                                                          100
                                                        )
                                                          .toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                          .replace(".", ",")
                                                      ) + " %"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.lastPage.network == "linkedin"
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  (
                                                    ((_vm.pageStats.page
                                                      .shareClickCount +
                                                      _vm.pageStats.page
                                                        .shareCommentCount +
                                                      _vm.pageStats.page
                                                        .shareLikeCount +
                                                      _vm.pageStats.page
                                                        .shareShareCount) /
                                                      _vm.pageStats.page
                                                        .shareImpressionCount) *
                                                    100
                                                  )
                                                    .toLocaleString(
                                                      _vm.$i18n.locale,
                                                      {
                                                        maximumFractionDigits: 1,
                                                      }
                                                    )
                                                    .replace(".", ",")
                                                ) + " %"
                                              ),
                                            ])
                                          : _vm.lastPage.network ==
                                              "facebook" &&
                                            !_vm.lastPage.isGroup
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: `Interactions + Clics / Impressions`,
                                                },
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.pageStats.page.shareEngagement
                                                        .toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 2,
                                                          }
                                                        )
                                                        .replace(".", ",")
                                                    ) + " % "
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pageStats.page.shareEngagement
                                                    .toLocaleString(
                                                      _vm.$i18n.locale,
                                                      {
                                                        maximumFractionDigits: 2,
                                                      }
                                                    )
                                                    .replace(".", ",")
                                                ) + " % "
                                              ),
                                            ]),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .shareEngagement >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .shareEngagement
                                                ) <
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .shareEngagement
                                                )
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.pageStats.page.previous_period.shareEngagement
                                                              .toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 2,
                                                                }
                                                              )
                                                              .replace(
                                                                ".",
                                                                ","
                                                              ) +
                                                            " %",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (parseFloat(
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .shareEngagement
                                                                      ) /
                                                                        parseFloat(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .shareEngagement
                                                                        )) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .shareEngagement
                                                ) != 0 &&
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .shareEngagement
                                                ) ==
                                                  parseFloat(
                                                    _vm.pageStats.page
                                                      .previous_period
                                                      .shareEngagement
                                                  )
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.pageStats.page.previous_period.shareEngagement
                                                              .toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 2,
                                                                }
                                                              )
                                                              .replace(
                                                                ".",
                                                                ","
                                                              ) +
                                                            " %",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .shareEngagement
                                                ) >
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .shareEngagement
                                                )
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.pageStats.page.previous_period.shareEngagement
                                                              .toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 2,
                                                                }
                                                              )
                                                              .replace(
                                                                ".",
                                                                ","
                                                              ) +
                                                            " %",
                                                        },
                                                      },
                                                      [
                                                        parseFloat(
                                                          _vm.pageStats.page
                                                            .previous_period
                                                            .shareEngagement
                                                        ) > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (parseFloat(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .shareEngagement
                                                                        ) /
                                                                          parseFloat(
                                                                            _vm
                                                                              .pageStats
                                                                              .page
                                                                              .previous_period
                                                                              .shareEngagement
                                                                          )) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : !_vm.lastPage.isGroup
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            : [
                                _vm.pageStats && !_vm.lastPage.isGroup
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-handshake-angle",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.reporting.engagemment"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon imp-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/impression.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.pageStats.page.totalReachEngag ===
                                        null
                                          ? _c("p", [_vm._v("N/A")])
                                          : _vm.lastPage.network == "pinterest"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.numberSpacing(
                                                    _vm.pageStats.page
                                                      .totalEngagements
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        (
                                                          _vm.pageStats.page
                                                            .totalReachEngag *
                                                          100
                                                        )
                                                          .toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                          .replace(".", ",")
                                                      ) + " %"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.lastPage.network == "linkedin"
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pageStats.page.totalReachEngag
                                                    .toLocaleString(
                                                      _vm.$i18n.locale,
                                                      {
                                                        maximumFractionDigits: 1,
                                                      }
                                                    )
                                                    .replace(".", ",")
                                                ) + " % "
                                              ),
                                            ])
                                          : _vm.lastPage.network ==
                                              "facebook" &&
                                            !_vm.lastPage.isGroup
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: `Interactions + Clics / Impressions`,
                                                },
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.pageStats.page.totalReachEngag
                                                        .toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 2,
                                                          }
                                                        )
                                                        .replace(".", ",")
                                                    ) + " % "
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pageStats.page.totalReachEngag
                                                    .toLocaleString(
                                                      _vm.$i18n.locale,
                                                      {
                                                        maximumFractionDigits: 2,
                                                      }
                                                    )
                                                    .replace(".", ",")
                                                ) + " % "
                                              ),
                                            ]),
                                        _vm.activeReportingV2 &&
                                        !_vm.pageStats.page.previous_period &&
                                        [
                                          "facebook",
                                          "instagram",
                                          "linkedin",
                                        ].includes(_vm.lastPage.network)
                                          ? _c(
                                              "div",
                                              { staticClass: "compare wait" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/status-waiting.gif"),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .previous_period &&
                                            _vm.pageStats.page.previous_period
                                              .totalReachEngag >= 0
                                          ? _c(
                                              "div",
                                              { staticClass: "compare" },
                                              [
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .totalReachEngag
                                                ) <
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .totalReachEngag
                                                )
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_down",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.pageStats.page.previous_period.totalReachEngag
                                                              .toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 2,
                                                                }
                                                              )
                                                              .replace(
                                                                ".",
                                                                ","
                                                              ) +
                                                            " %",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "negative",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  _vm.formatPercentageChange(
                                                                    100 -
                                                                      (parseFloat(
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .totalReachEngag
                                                                      ) /
                                                                        parseFloat(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .totalReachEngag
                                                                        )) *
                                                                        100
                                                                  )
                                                                ) +
                                                                "%"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right negative",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .totalReachEngag
                                                ) != 0 &&
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .totalReachEngag
                                                ) ==
                                                  parseFloat(
                                                    _vm.pageStats.page
                                                      .previous_period
                                                      .totalReachEngag
                                                  )
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_flat",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.pageStats.page.previous_period.totalReachEngag
                                                              .toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 2,
                                                                }
                                                              )
                                                              .replace(
                                                                ".",
                                                                ","
                                                              ) +
                                                            " %",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .totalReachEngag
                                                ) >
                                                parseFloat(
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .totalReachEngag
                                                )
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass:
                                                          "trending_up",
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.reporting.previous_period"
                                                            ) +
                                                            " (" +
                                                            _vm.$t(
                                                              "dash.reporting.from"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .start,
                                                              false
                                                            ) +
                                                            " " +
                                                            _vm.$t(
                                                              "dash.reporting.to"
                                                            ) +
                                                            " " +
                                                            _vm.formatDate(
                                                              _vm
                                                                .getPreviousPeriod
                                                                .end,
                                                              false
                                                            ) +
                                                            ") : " +
                                                            _vm.pageStats.page.previous_period.totalReachEngag
                                                              .toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 2,
                                                                }
                                                              )
                                                              .replace(
                                                                ".",
                                                                ","
                                                              ) +
                                                            " %",
                                                        },
                                                      },
                                                      [
                                                        parseFloat(
                                                          _vm.pageStats.page
                                                            .previous_period
                                                            .totalReachEngag
                                                        ) > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "positive",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        (parseFloat(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .totalReachEngag
                                                                        ) /
                                                                          parseFloat(
                                                                            _vm
                                                                              .pageStats
                                                                              .page
                                                                              .previous_period
                                                                              .totalReachEngag
                                                                          )) *
                                                                          100 -
                                                                          100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "trending_up"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right positive",
                                                          staticStyle: {
                                                            transform:
                                                              "rotate(-45deg)",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : !_vm.lastPage.isGroup
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                          _vm.lastPage.network == "pinterest"
                            ? [
                                _vm.pageStats &&
                                _vm.lastPage.network == "pinterest"
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-arrow-pointer",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.reporting.outboundclick"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon imp-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/clic.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.pageStats.page
                                          .totalOutboundclick === null
                                          ? _c("p", [_vm._v("N/A")])
                                          : _vm.pageStats.page
                                              .totalOutboundclick >= 1000000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text:
                                                    _vm.numberSpacing(
                                                      _vm.pageStats.page
                                                        .totalOutboundclick
                                                    ) +
                                                    "(" +
                                                    _vm.numbersubstring(
                                                      _vm.pageStats.page
                                                        .totalOutboundclickRate
                                                    ) +
                                                    "%)",
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalOutboundclick /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.pageStats.page
                                              .totalOutboundclick >= 1000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text:
                                                    _vm.numberSpacing(
                                                      _vm.pageStats.page
                                                        .totalOutboundclick
                                                    ) +
                                                    "(" +
                                                    _vm.numbersubstring(
                                                      _vm.pageStats.page
                                                        .totalOutboundclickRate
                                                    ) +
                                                    "%)",
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalOutboundclick /
                                                              1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text:
                                                    _vm.numbersubstring(
                                                      _vm.pageStats.page
                                                        .totalOutboundclickRate
                                                    ) + "%",
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .totalOutboundclick
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.pageStats &&
                                _vm.lastPage.network == "pinterest"
                                  ? _c(
                                      "div",
                                      { staticClass: "main-numbers" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-floppy-disk",
                                        }),
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.reporting.save")
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          staticClass: "icon imp-ico",
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/clic.svg"),
                                            alt: "",
                                          },
                                        }),
                                        _vm.pageStats.page.totalSave === null
                                          ? _c("p", [_vm._v("N/A")])
                                          : _vm.pageStats.page.totalSave >=
                                            1000000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text:
                                                    _vm.numberSpacing(
                                                      _vm.pageStats.page
                                                        .totalSave
                                                    ) +
                                                    "(" +
                                                    _vm.numbersubstring(
                                                      _vm.pageStats.page
                                                        .totalSaveRate
                                                    ) +
                                                    "%)",
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalSave /
                                                              1000000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.pageStats.page.totalSave >= 1000
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text:
                                                    _vm.numberSpacing(
                                                      _vm.pageStats.page
                                                        .totalSave
                                                    ) +
                                                    "(" +
                                                    _vm.numbersubstring(
                                                      _vm.pageStats.page
                                                        .totalSaveRate
                                                    ) +
                                                    "%)",
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          Number(
                                                            _vm.pageStats.page
                                                              .totalSave / 1000
                                                          ).toLocaleString(
                                                            _vm.$i18n.locale,
                                                            {
                                                              maximumFractionDigits: 1,
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "percent",
                                                      },
                                                      [_vm._v("k")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text:
                                                    _vm.numbersubstring(
                                                      _vm.pageStats.page
                                                        .totalSaveRate
                                                    ) + "%",
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "big-number" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .totalSave
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.pageStats
                    ? _c(
                        "div",
                        { staticClass: "graph-wrapper" },
                        [
                          _c("componentGraph", {
                            key: "overview",
                            staticClass: "graph",
                            attrs: {
                              data: _vm.graphData.filter((g) =>
                                _vm.lastPage.network == "linkedin"
                                  ? _vm.linkedinOverview.includes(g.name)
                                  : !_vm.notInOverview.includes(g.name)
                              ),
                              labels: _vm.graphLabels,
                              state: _vm.graphShowed,
                              lang: _vm.$i18n.locale,
                              section: "overview",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "graph-choice" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t(
                                      "dash.reporting.graph.choice.tooltip.posts"
                                    ),
                                    position: "bottom",
                                  },
                                },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticClass: "check",
                                      attrs: {
                                        color: "#E4BAF5",
                                        "vs-value": "0",
                                      },
                                      model: {
                                        value: _vm.graphShowed,
                                        callback: function ($$v) {
                                          _vm.graphShowed = $$v
                                        },
                                        expression: "graphShowed",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.capitalize(
                                            _vm.$t("dash.posts.title")
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._l(
                                _vm.graphNetwork.filter((g) =>
                                  _vm.lastPage.network == "linkedin"
                                    ? _vm.linkedinOverview.includes(g.name)
                                    : !_vm.notInOverview.includes(g.name)
                                ),
                                function (item, idx) {
                                  return _c(
                                    "Tooltip",
                                    {
                                      key: `graph-select-overview-${idx}`,
                                      attrs: {
                                        text: item.description,
                                        position: "bottom",
                                      },
                                    },
                                    [
                                      _c(
                                        "vs-checkbox",
                                        {
                                          staticClass: "check",
                                          attrs: {
                                            color: item.color,
                                            "vs-value": `${idx + 1}`,
                                          },
                                          model: {
                                            value: _vm.graphShowed,
                                            callback: function ($$v) {
                                              _vm.graphShowed = $$v
                                            },
                                            expression: "graphShowed",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(item.text) +
                                              " \n          "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.pageStats && ["linkedin"].includes(_vm.lastPage.network)
                    ? [
                        _c("div", { staticClass: "section-graph audiences" }, [
                          _c("div", { staticClass: "section-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("dash.reporting.section.audience.title")
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "section-subtitle" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "dash.reporting.section.audience.linkedin.subtitle"
                                )
                              )
                            ),
                          ]),
                          _vm.graphData.filter((g) =>
                            [
                              "organicFollowerGain",
                              "paidFollowerGain",
                            ].includes(g.name)
                          ).length > 1
                            ? _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "informations" },
                                  [
                                    _vm.pageStats
                                      ? _c(
                                          "div",
                                          { staticClass: "main-numbers" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-user-group",
                                            }),
                                            _c("h3", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.reporting.organicFollowerGain"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("img", {
                                              staticClass: "icon fan-ico",
                                              attrs: {
                                                src: require("../../../assets/img/reporting_icons/fans.svg"),
                                                alt: "",
                                              },
                                            }),
                                            _vm.pageStats.page
                                              .organicFollowerGain >= 1000000
                                              ? _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .organicFollowerGain
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .organicFollowerGain /
                                                                  1000000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("M")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm.pageStats.page
                                                  .organicFollowerGain >= 1000
                                              ? _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .organicFollowerGain
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .organicFollowerGain /
                                                                  1000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("k")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .organicFollowerGain
                                                      )
                                                    )
                                                  ),
                                                ]),
                                            _vm.activeReportingV2 &&
                                            !_vm.pageStats.page
                                              .previous_period &&
                                            _vm.lastPage.network == "facebook"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "compare wait",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("../../../assets/img/status-waiting.gif"),
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm.pageStats.page
                                                  .previous_period &&
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .organicFollowerGain
                                              ? _c(
                                                  "div",
                                                  { staticClass: "compare" },
                                                  [
                                                    _vm.pageStats.page
                                                      .organicFollowerGain <
                                                    _vm.pageStats.page
                                                      .previous_period
                                                      .organicFollowerGain
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            staticClass:
                                                              "trending_down",
                                                            attrs: {
                                                              text:
                                                                _vm.$t(
                                                                  "dash.reporting.previous_period"
                                                                ) +
                                                                " (" +
                                                                _vm.$t(
                                                                  "dash.reporting.from"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .start,
                                                                  false
                                                                ) +
                                                                " " +
                                                                _vm.$t(
                                                                  "dash.reporting.to"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .end,
                                                                  false
                                                                ) +
                                                                ") : " +
                                                                _vm.numberSpacing(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .previous_period
                                                                    .organicFollowerGain
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "negative",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "-" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        100 -
                                                                          (_vm
                                                                            .pageStats
                                                                            .page
                                                                            .organicFollowerGain /
                                                                            _vm
                                                                              .pageStats
                                                                              .page
                                                                              .previous_period
                                                                              .organicFollowerGain) *
                                                                            100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "trending_up"
                                                                ),
                                                              ]
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-arrow-right negative",
                                                              staticStyle: {
                                                                transform:
                                                                  "rotate(45deg)",
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.pageStats.page
                                                      .organicFollowerGain !=
                                                      0 &&
                                                    _vm.pageStats.page
                                                      .organicFollowerGain ==
                                                      _vm.pageStats.page
                                                        .previous_period
                                                        .organicFollowerGain
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            staticClass:
                                                              "trending_flat",
                                                            attrs: {
                                                              text:
                                                                _vm.$t(
                                                                  "dash.reporting.previous_period"
                                                                ) +
                                                                " (" +
                                                                _vm.$t(
                                                                  "dash.reporting.from"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .start,
                                                                  false
                                                                ) +
                                                                " " +
                                                                _vm.$t(
                                                                  "dash.reporting.to"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .end,
                                                                  false
                                                                ) +
                                                                ") : " +
                                                                _vm.numberSpacing(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .previous_period
                                                                    .organicFollowerGain
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "trending_up"
                                                                ),
                                                              ]
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-arrow-right",
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.pageStats.page
                                                      .organicFollowerGain >
                                                    _vm.pageStats.page
                                                      .previous_period
                                                      .organicFollowerGain
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            staticClass:
                                                              "trending_up",
                                                            attrs: {
                                                              text:
                                                                _vm.$t(
                                                                  "dash.reporting.previous_period"
                                                                ) +
                                                                " (" +
                                                                _vm.$t(
                                                                  "dash.reporting.from"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .start,
                                                                  false
                                                                ) +
                                                                " " +
                                                                _vm.$t(
                                                                  "dash.reporting.to"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .end,
                                                                  false
                                                                ) +
                                                                ") : " +
                                                                _vm.numberSpacing(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .previous_period
                                                                    .organicFollowerGain
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _vm.pageStats.page
                                                              .previous_period
                                                              .organicFollowerGain >
                                                            0
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "positive",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "+" +
                                                                        _vm._s(
                                                                          _vm.formatPercentageChange(
                                                                            (_vm
                                                                              .pageStats
                                                                              .page
                                                                              .organicFollowerGain /
                                                                              _vm
                                                                                .pageStats
                                                                                .page
                                                                                .previous_period
                                                                                .organicFollowerGain) *
                                                                              100 -
                                                                              100
                                                                          )
                                                                        ) +
                                                                        "%"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "trending_up"
                                                                ),
                                                              ]
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-arrow-right positive",
                                                              staticStyle: {
                                                                transform:
                                                                  "rotate(-45deg)",
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _c("img", {
                                          attrs: {
                                            src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                            alt: "",
                                          },
                                        }),
                                    _vm.pageStats
                                      ? _c(
                                          "div",
                                          { staticClass: "main-numbers" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-user-group",
                                            }),
                                            _c("h3", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.reporting.paidFollowerGain"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("img", {
                                              staticClass: "icon fan-ico",
                                              attrs: {
                                                src: require("../../../assets/img/reporting_icons/fans.svg"),
                                                alt: "",
                                              },
                                            }),
                                            _vm.pageStats.page
                                              .paidFollowerGain >= 1000000
                                              ? _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .paidFollowerGain
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .paidFollowerGain /
                                                                  1000000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("M")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm.pageStats.page
                                                  .paidFollowerGain >= 1000
                                              ? _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .paidFollowerGain
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "big-number",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.numberSpacing(
                                                              Number(
                                                                _vm.pageStats
                                                                  .page
                                                                  .paidFollowerGain /
                                                                  1000
                                                              ).toLocaleString(
                                                                _vm.$i18n
                                                                  .locale,
                                                                {
                                                                  maximumFractionDigits: 1,
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "percent",
                                                          },
                                                          [_vm._v("k")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        _vm.pageStats.page
                                                          .paidFollowerGain
                                                      )
                                                    )
                                                  ),
                                                ]),
                                            _vm.activeReportingV2 &&
                                            !_vm.pageStats.page
                                              .previous_period &&
                                            _vm.lastPage.network == "facebook"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "compare wait",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("../../../assets/img/status-waiting.gif"),
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm.pageStats.page
                                                  .previous_period &&
                                                _vm.pageStats.page
                                                  .previous_period
                                                  .paidFollowerGain
                                              ? _c(
                                                  "div",
                                                  { staticClass: "compare" },
                                                  [
                                                    _vm.pageStats.page
                                                      .paidFollowerGain <
                                                    _vm.pageStats.page
                                                      .previous_period
                                                      .paidFollowerGain
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            staticClass:
                                                              "trending_down",
                                                            attrs: {
                                                              text:
                                                                _vm.$t(
                                                                  "dash.reporting.previous_period"
                                                                ) +
                                                                " (" +
                                                                _vm.$t(
                                                                  "dash.reporting.from"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .start,
                                                                  false
                                                                ) +
                                                                " " +
                                                                _vm.$t(
                                                                  "dash.reporting.to"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .end,
                                                                  false
                                                                ) +
                                                                ") : " +
                                                                _vm.numberSpacing(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .previous_period
                                                                    .paidFollowerGain
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "negative",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "-" +
                                                                    _vm._s(
                                                                      _vm.formatPercentageChange(
                                                                        100 -
                                                                          (_vm
                                                                            .pageStats
                                                                            .page
                                                                            .paidFollowerGain /
                                                                            _vm
                                                                              .pageStats
                                                                              .page
                                                                              .previous_period
                                                                              .paidFollowerGain) *
                                                                            100
                                                                      )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "trending_up"
                                                                ),
                                                              ]
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-arrow-right negative",
                                                              staticStyle: {
                                                                transform:
                                                                  "rotate(45deg)",
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.pageStats.page
                                                      .paidFollowerGain != 0 &&
                                                    _vm.pageStats.page
                                                      .paidFollowerGain ==
                                                      _vm.pageStats.page
                                                        .previous_period
                                                        .paidFollowerGain
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            staticClass:
                                                              "trending_flat",
                                                            attrs: {
                                                              text:
                                                                _vm.$t(
                                                                  "dash.reporting.previous_period"
                                                                ) +
                                                                " (" +
                                                                _vm.$t(
                                                                  "dash.reporting.from"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .start,
                                                                  false
                                                                ) +
                                                                " " +
                                                                _vm.$t(
                                                                  "dash.reporting.to"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .end,
                                                                  false
                                                                ) +
                                                                ") : " +
                                                                _vm.numberSpacing(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .previous_period
                                                                    .paidFollowerGain
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "trending_up"
                                                                ),
                                                              ]
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-arrow-right",
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.pageStats.page
                                                      .paidFollowerGain >
                                                    _vm.pageStats.page
                                                      .previous_period
                                                      .paidFollowerGain
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            staticClass:
                                                              "trending_up",
                                                            attrs: {
                                                              text:
                                                                _vm.$t(
                                                                  "dash.reporting.previous_period"
                                                                ) +
                                                                " (" +
                                                                _vm.$t(
                                                                  "dash.reporting.from"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .start,
                                                                  false
                                                                ) +
                                                                " " +
                                                                _vm.$t(
                                                                  "dash.reporting.to"
                                                                ) +
                                                                " " +
                                                                _vm.formatDate(
                                                                  _vm
                                                                    .getPreviousPeriod
                                                                    .end,
                                                                  false
                                                                ) +
                                                                ") : " +
                                                                _vm.numberSpacing(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .previous_period
                                                                    .paidFollowerGain
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _vm.pageStats.page
                                                              .previous_period
                                                              .paidFollowerGain >
                                                            0
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "positive",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "+" +
                                                                        _vm._s(
                                                                          _vm.formatPercentageChange(
                                                                            (_vm
                                                                              .pageStats
                                                                              .page
                                                                              .paidFollowerGain /
                                                                              _vm
                                                                                .pageStats
                                                                                .page
                                                                                .previous_period
                                                                                .paidFollowerGain) *
                                                                              100 -
                                                                              100
                                                                          )
                                                                        ) +
                                                                        "%"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "trending_up"
                                                                ),
                                                              ]
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-arrow-right positive",
                                                              staticStyle: {
                                                                transform:
                                                                  "rotate(-45deg)",
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _c("img", {
                                          attrs: {
                                            src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                            alt: "",
                                          },
                                        }),
                                    _c("componentGraph", {
                                      key: "audiences",
                                      staticClass: "graph",
                                      attrs: {
                                        data: _vm.graphData.filter((g) =>
                                          [
                                            "organicFollowerGain",
                                            "paidFollowerGain",
                                          ].includes(g.name)
                                        ),
                                        state: _vm.graphShowedAudience,
                                        labels: _vm.graphLabels,
                                        lang: _vm.$i18n.locale,
                                        section: "audiences",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "graph-choice" },
                                      _vm._l(
                                        _vm.graphNetwork.filter((g) =>
                                          [
                                            "organicFollowerGain",
                                            "paidFollowerGain",
                                          ].includes(g.name)
                                        ),
                                        function (item, idx) {
                                          return _c(
                                            "Tooltip",
                                            {
                                              key: `graph-select-audience-${idx}`,
                                              attrs: {
                                                text: item.description,
                                                position: "bottom",
                                              },
                                            },
                                            [
                                              _c(
                                                "vs-checkbox",
                                                {
                                                  staticClass: "check",
                                                  attrs: {
                                                    color: item.color,
                                                    "vs-value": `${idx}`,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.graphShowedAudience,
                                                    callback: function ($$v) {
                                                      _vm.graphShowedAudience =
                                                        $$v
                                                    },
                                                    expression:
                                                      "graphShowedAudience",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(item.text) +
                                                      " \n                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          { staticClass: "section-graph impressions" },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "dash.reporting.section.impressions.page.linkedin.title"
                                  )
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "section-subtitle" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "dash.reporting.section.impressions.page.linkedin.subtitle"
                                  )
                                )
                              ),
                            ]),
                            _vm.graphData.filter((g) =>
                              [
                                "pageViews",
                                "pageCustomButtonClickCounts",
                              ].includes(g.name)
                            ).length == 2
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "informations" },
                                    [
                                      _vm.pageStats
                                        ? _c(
                                            "div",
                                            { staticClass: "main-numbers" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-solid fa-user-group",
                                              }),
                                              _c("h3", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.pageViews"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("img", {
                                                staticClass: "icon fan-ico",
                                                attrs: {
                                                  src: require("../../../assets/img/reporting_icons/fans.svg"),
                                                  alt: "",
                                                },
                                              }),
                                              _vm.pageStats.page.pageViews >=
                                              1000000
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .pageViews
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "big-number",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                Number(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .pageViews /
                                                                    1000000
                                                                ).toLocaleString(
                                                                  _vm.$i18n
                                                                    .locale,
                                                                  {
                                                                    maximumFractionDigits: 1,
                                                                  }
                                                                )
                                                              )
                                                            )
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "percent",
                                                            },
                                                            [_vm._v("M")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm.pageStats.page
                                                    .pageViews >= 1000
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .pageViews
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "big-number",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                Number(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .pageViews /
                                                                    1000
                                                                ).toLocaleString(
                                                                  _vm.$i18n
                                                                    .locale,
                                                                  {
                                                                    maximumFractionDigits: 1,
                                                                  }
                                                                )
                                                              )
                                                            )
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "percent",
                                                            },
                                                            [_vm._v("k")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .pageViews
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                              _vm.activeReportingV2 &&
                                              !_vm.pageStats.page
                                                .previous_period &&
                                              _vm.lastPage.network == "facebook"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "compare wait",
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: require("../../../assets/img/status-waiting.gif"),
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm.pageStats.page
                                                    .previous_period &&
                                                  _vm.pageStats.page
                                                    .previous_period.pageViews
                                                ? _c(
                                                    "div",
                                                    { staticClass: "compare" },
                                                    [
                                                      _vm.pageStats.page
                                                        .pageViews <
                                                      _vm.pageStats.page
                                                        .previous_period
                                                        .pageViews
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              staticClass:
                                                                "trending_down",
                                                              attrs: {
                                                                text:
                                                                  _vm.$t(
                                                                    "dash.reporting.previous_period"
                                                                  ) +
                                                                  " (" +
                                                                  _vm.$t(
                                                                    "dash.reporting.from"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .start,
                                                                    false
                                                                  ) +
                                                                  " " +
                                                                  _vm.$t(
                                                                    "dash.reporting.to"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .end,
                                                                    false
                                                                  ) +
                                                                  ") : " +
                                                                  _vm.numberSpacing(
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .pageViews
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "negative",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "-" +
                                                                      _vm._s(
                                                                        _vm.formatPercentageChange(
                                                                          100 -
                                                                            (_vm
                                                                              .pageStats
                                                                              .page
                                                                              .pageViews /
                                                                              _vm
                                                                                .pageStats
                                                                                .page
                                                                                .previous_period
                                                                                .pageViews) *
                                                                              100
                                                                        )
                                                                      ) +
                                                                      "%"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "trending_up"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-arrow-right negative",
                                                                staticStyle: {
                                                                  transform:
                                                                    "rotate(45deg)",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.pageStats.page
                                                        .pageViews != 0 &&
                                                      _vm.pageStats.page
                                                        .pageViews ==
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .pageViews
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              staticClass:
                                                                "trending_flat",
                                                              attrs: {
                                                                text:
                                                                  _vm.$t(
                                                                    "dash.reporting.previous_period"
                                                                  ) +
                                                                  " (" +
                                                                  _vm.$t(
                                                                    "dash.reporting.from"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .start,
                                                                    false
                                                                  ) +
                                                                  " " +
                                                                  _vm.$t(
                                                                    "dash.reporting.to"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .end,
                                                                    false
                                                                  ) +
                                                                  ") : " +
                                                                  _vm.numberSpacing(
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .pageViews
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "trending_up"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-arrow-right",
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.pageStats.page
                                                        .pageViews >
                                                      _vm.pageStats.page
                                                        .previous_period
                                                        .pageViews
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              staticClass:
                                                                "trending_up",
                                                              attrs: {
                                                                text:
                                                                  _vm.$t(
                                                                    "dash.reporting.previous_period"
                                                                  ) +
                                                                  " (" +
                                                                  _vm.$t(
                                                                    "dash.reporting.from"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .start,
                                                                    false
                                                                  ) +
                                                                  " " +
                                                                  _vm.$t(
                                                                    "dash.reporting.to"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .end,
                                                                    false
                                                                  ) +
                                                                  ") : " +
                                                                  _vm.numberSpacing(
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .pageViews
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .pageViews > 0
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "positive",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "+" +
                                                                          _vm._s(
                                                                            _vm.formatPercentageChange(
                                                                              (_vm
                                                                                .pageStats
                                                                                .page
                                                                                .pageViews /
                                                                                _vm
                                                                                  .pageStats
                                                                                  .page
                                                                                  .previous_period
                                                                                  .pageViews) *
                                                                                100 -
                                                                                100
                                                                            )
                                                                          ) +
                                                                          "%"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "trending_up"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-arrow-right positive",
                                                                staticStyle: {
                                                                  transform:
                                                                    "rotate(-45deg)",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _c("img", {
                                            attrs: {
                                              src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                              alt: "",
                                            },
                                          }),
                                      _vm.pageStats
                                        ? _c(
                                            "div",
                                            { staticClass: "main-numbers" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-solid fa-user-group",
                                              }),
                                              _c("h3", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.pageCustomButtonClickCounts"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("img", {
                                                staticClass: "icon fan-ico",
                                                attrs: {
                                                  src: require("../../../assets/img/reporting_icons/fans.svg"),
                                                  alt: "",
                                                },
                                              }),
                                              _vm.pageStats.page
                                                .pageCustomButtonClickCounts >=
                                              1000000
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .pageCustomButtonClickCounts
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "big-number",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                Number(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .pageCustomButtonClickCounts /
                                                                    1000000
                                                                ).toLocaleString(
                                                                  _vm.$i18n
                                                                    .locale,
                                                                  {
                                                                    maximumFractionDigits: 1,
                                                                  }
                                                                )
                                                              )
                                                            )
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "percent",
                                                            },
                                                            [_vm._v("M")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm.pageStats.page
                                                    .pageCustomButtonClickCounts >=
                                                  1000
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .pageCustomButtonClickCounts
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "big-number",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                Number(
                                                                  _vm.pageStats
                                                                    .page
                                                                    .pageCustomButtonClickCounts /
                                                                    1000
                                                                ).toLocaleString(
                                                                  _vm.$i18n
                                                                    .locale,
                                                                  {
                                                                    maximumFractionDigits: 1,
                                                                  }
                                                                )
                                                              )
                                                            )
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "percent",
                                                            },
                                                            [_vm._v("k")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberSpacing(
                                                          _vm.pageStats.page
                                                            .pageCustomButtonClickCounts
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                              _vm.activeReportingV2 &&
                                              !_vm.pageStats.page
                                                .previous_period &&
                                              _vm.lastPage.network == "facebook"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "compare wait",
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: require("../../../assets/img/status-waiting.gif"),
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm.pageStats.page
                                                    .previous_period &&
                                                  _vm.pageStats.page
                                                    .previous_period
                                                    .pageCustomButtonClickCounts
                                                ? _c(
                                                    "div",
                                                    { staticClass: "compare" },
                                                    [
                                                      _vm.pageStats.page
                                                        .pageCustomButtonClickCounts <
                                                      _vm.pageStats.page
                                                        .previous_period
                                                        .pageCustomButtonClickCounts
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              staticClass:
                                                                "trending_down",
                                                              attrs: {
                                                                text:
                                                                  _vm.$t(
                                                                    "dash.reporting.previous_period"
                                                                  ) +
                                                                  " (" +
                                                                  _vm.$t(
                                                                    "dash.reporting.from"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .start,
                                                                    false
                                                                  ) +
                                                                  " " +
                                                                  _vm.$t(
                                                                    "dash.reporting.to"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .end,
                                                                    false
                                                                  ) +
                                                                  ") : " +
                                                                  _vm.numberSpacing(
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .pageCustomButtonClickCounts
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "negative",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "-" +
                                                                      _vm._s(
                                                                        _vm.formatPercentageChange(
                                                                          100 -
                                                                            (_vm
                                                                              .pageStats
                                                                              .page
                                                                              .pageCustomButtonClickCounts /
                                                                              _vm
                                                                                .pageStats
                                                                                .page
                                                                                .previous_period
                                                                                .pageCustomButtonClickCounts) *
                                                                              100
                                                                        )
                                                                      ) +
                                                                      "%"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "trending_up"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-arrow-right negative",
                                                                staticStyle: {
                                                                  transform:
                                                                    "rotate(45deg)",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.pageStats.page
                                                        .pageCustomButtonClickCounts !=
                                                        0 &&
                                                      _vm.pageStats.page
                                                        .pageCustomButtonClickCounts ==
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .pageCustomButtonClickCounts
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              staticClass:
                                                                "trending_flat",
                                                              attrs: {
                                                                text:
                                                                  _vm.$t(
                                                                    "dash.reporting.previous_period"
                                                                  ) +
                                                                  " (" +
                                                                  _vm.$t(
                                                                    "dash.reporting.from"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .start,
                                                                    false
                                                                  ) +
                                                                  " " +
                                                                  _vm.$t(
                                                                    "dash.reporting.to"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .end,
                                                                    false
                                                                  ) +
                                                                  ") : " +
                                                                  _vm.numberSpacing(
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .pageCustomButtonClickCounts
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "trending_up"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-arrow-right",
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.pageStats.page
                                                        .pageCustomButtonClickCounts >
                                                      _vm.pageStats.page
                                                        .previous_period
                                                        .pageCustomButtonClickCounts
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              staticClass:
                                                                "trending_up",
                                                              attrs: {
                                                                text:
                                                                  _vm.$t(
                                                                    "dash.reporting.previous_period"
                                                                  ) +
                                                                  " (" +
                                                                  _vm.$t(
                                                                    "dash.reporting.from"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .start,
                                                                    false
                                                                  ) +
                                                                  " " +
                                                                  _vm.$t(
                                                                    "dash.reporting.to"
                                                                  ) +
                                                                  " " +
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .getPreviousPeriod
                                                                      .end,
                                                                    false
                                                                  ) +
                                                                  ") : " +
                                                                  _vm.numberSpacing(
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .pageCustomButtonClickCounts
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .pageCustomButtonClickCounts >
                                                              0
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "positive",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "+" +
                                                                          _vm._s(
                                                                            _vm.formatPercentageChange(
                                                                              (_vm
                                                                                .pageStats
                                                                                .page
                                                                                .pageCustomButtonClickCounts /
                                                                                _vm
                                                                                  .pageStats
                                                                                  .page
                                                                                  .previous_period
                                                                                  .pageCustomButtonClickCounts) *
                                                                                100 -
                                                                                100
                                                                            )
                                                                          ) +
                                                                          "%"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "trending_up"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-arrow-right positive",
                                                                staticStyle: {
                                                                  transform:
                                                                    "rotate(-45deg)",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _c("img", {
                                            attrs: {
                                              src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                              alt: "",
                                            },
                                          }),
                                      _c("componentGraph", {
                                        key: "impressions",
                                        staticClass: "graph",
                                        attrs: {
                                          data: _vm.graphData.filter((g) =>
                                            [
                                              "pageViews",
                                              "pageCustomButtonClickCounts",
                                            ].includes(g.name)
                                          ),
                                          state: _vm.graphShowedImpressions,
                                          labels: _vm.graphLabels,
                                          lang: _vm.$i18n.locale,
                                          section: "impressions",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "graph-choice" },
                                        _vm._l(
                                          _vm.graphNetwork.filter((g) =>
                                            [
                                              "pageViews",
                                              "pageCustomButtonClickCounts",
                                            ].includes(g.name)
                                          ),
                                          function (item, idx) {
                                            return _c(
                                              "Tooltip",
                                              {
                                                key: `graph-select-impressions-${idx}`,
                                                attrs: {
                                                  text: item.description,
                                                  position: "bottom",
                                                },
                                              },
                                              [
                                                _c(
                                                  "vs-checkbox",
                                                  {
                                                    staticClass: "check",
                                                    attrs: {
                                                      color: item.color,
                                                      "vs-value": `${idx}`,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.graphShowedImpressions,
                                                      callback: function ($$v) {
                                                        _vm.graphShowedImpressions =
                                                          $$v
                                                      },
                                                      expression:
                                                        "graphShowedImpressions",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.text) +
                                                        " \n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "section-graph demographie" },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    `dash.reporting.section.demographie.title.${_vm.lastPage.network}`
                                  )
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "section-subtitle" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    `dash.reporting.section.demographie.subtitle.${_vm.lastPage.network}`
                                  )
                                )
                              ),
                            ]),
                            _vm.graphData.filter(
                              (g) =>
                                g.data &&
                                [
                                  "fans_country",
                                  "fans_city",
                                  "fans_male_age",
                                  "fans_female_age",
                                  "fans_undifined_age",
                                ].includes(g.name)
                            ).length >= 1
                              ? _c(
                                  "div",
                                  [
                                    _c("MapChart", {
                                      attrs: {
                                        countryData: _vm.graphData.filter((g) =>
                                          ["fans_country"].includes(g.name)
                                        )[0].data,
                                        highColor: "rgba(106, 31, 76, 1)",
                                        lowColor: "rgba(106, 31, 76, 0.1)",
                                        countryStrokeColor: "#ffffff",
                                        defaultCountryFillColor: "#dadada",
                                        LangUser: _vm.$i18n.locale,
                                        currencyAdd: false,
                                      },
                                    }),
                                    _c("ul", { staticClass: "bar" }, [
                                      _c(
                                        "li",
                                        [
                                          _c("componentGraph", {
                                            key: "demographie_city",
                                            staticClass: "graph",
                                            attrs: {
                                              data: _vm.graphData
                                                .filter((g) =>
                                                  ["fans_city"].includes(g.name)
                                                )
                                                .slice(0, 10),
                                              state: [
                                                "0",
                                                "1",
                                                "2",
                                                "3",
                                                "4",
                                                "5",
                                                "6",
                                                "7",
                                                "8",
                                                "9",
                                              ],
                                              labels: _vm.graphData
                                                .find((g) =>
                                                  ["fans_city"].includes(g.name)
                                                )
                                                .labels.slice(0, 10)
                                                .map((n) =>
                                                  n
                                                    .replace(
                                                      /\b(Greater|Metropolitan|region|area)\b/gi,
                                                      ""
                                                    )
                                                    .replace(/\s\s+/g, " ")
                                                    .trim()
                                                ),
                                              lang: _vm.$i18n.locale,
                                              section: "demographie_city",
                                              size: _vm.sizeHorizontalGraph,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "li",
                                        { staticClass: "small" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "graph_name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.reporting.graph.linkedin.seniority"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("componentGraph", {
                                            key: "demographie_seniority",
                                            staticClass: "graph",
                                            attrs: {
                                              data: _vm.graphData.filter((g) =>
                                                [
                                                  "followerCountsBySeniority",
                                                ].includes(g.name)
                                              ),
                                              state: Array.from(
                                                {
                                                  length:
                                                    _vm.pageStats.page
                                                      .followerCountsBySeniority
                                                      .length,
                                                },
                                                (_, i) => `${i}`
                                              ),
                                              labels:
                                                _vm.pageStats.page.followerCountsBySeniority.map(
                                                  (f) => f.name
                                                ),
                                              lang: _vm.$i18n.locale,
                                              section: "demographie_seniority",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "li",
                                        { staticClass: "small" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "graph_name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.reporting.graph.linkedin.function"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("componentGraph", {
                                            key: "demographie_function",
                                            staticClass: "graph",
                                            attrs: {
                                              data: _vm.graphData.filter((g) =>
                                                [
                                                  "followerCountsByFunction",
                                                ].includes(g.name)
                                              ),
                                              state: Array.from(
                                                {
                                                  length:
                                                    _vm.pageStats.page
                                                      .followerCountsByFunction
                                                      .length,
                                                },
                                                (_, i) => `${i}`
                                              ),
                                              labels:
                                                _vm.pageStats.page.followerCountsByFunction.map(
                                                  (f) => f.name
                                                ),
                                              lang: _vm.$i18n.locale,
                                              section: "demographie_function",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "li",
                                        { staticClass: "small" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "graph_name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.reporting.graph.linkedin.industry"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("componentGraph", {
                                            key: "demographie_industry",
                                            staticClass: "graph",
                                            attrs: {
                                              data: _vm.graphData.filter((g) =>
                                                [
                                                  "followerCountsByIndustry",
                                                ].includes(g.name)
                                              ),
                                              state: Array.from(
                                                {
                                                  length:
                                                    _vm.pageStats.page
                                                      .followerCountsByIndustry
                                                      .length,
                                                },
                                                (_, i) => `${i}`
                                              ),
                                              labels:
                                                _vm.pageStats.page.followerCountsByIndustry.map(
                                                  (f) => f.name
                                                ),
                                              lang: _vm.$i18n.locale,
                                              section: "demographie_industry",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "li",
                                        { staticClass: "small" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "graph_name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.reporting.graph.linkedin.StaffCount"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("componentGraph", {
                                            key: "demographie_StaffCount",
                                            staticClass: "graph",
                                            attrs: {
                                              data: _vm.graphData.filter((g) =>
                                                [
                                                  "followerCountsByStaffCountRange",
                                                ].includes(g.name)
                                              ),
                                              state: Array.from(
                                                {
                                                  length:
                                                    _vm.pageStats.page
                                                      .followerCountsByStaffCountRange
                                                      .length,
                                                },
                                                (_, i) => `${i}`
                                              ),
                                              labels:
                                                _vm.pageStats.page.followerCountsByStaffCountRange
                                                  .map((f) => f.name)
                                                  .map((n) =>
                                                    n
                                                      .replace("SIZE_", "")
                                                      .replace("_TO_", " à ")
                                                      .replace(
                                                        "_OR_MORE",
                                                        " ou plus"
                                                      )
                                                  ),
                                              lang: _vm.$i18n.locale,
                                              section: "demographie_StaffCount",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    : _vm.pageStats &&
                      ["facebook", "instagram", "tiktok"].includes(
                        _vm.lastPage.network
                      )
                    ? [
                        _vm.lastPage.network == "instagram"
                          ? _c(
                              "div",
                              { staticClass: "section-graph audiences" },
                              [
                                _c("div", { staticClass: "section-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.reporting.section.audience.title"
                                      )
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "section-subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.reporting.section.audience.subtitle"
                                      )
                                    )
                                  ),
                                ]),
                                _vm.graphData.filter((g) =>
                                  [
                                    "impressions_graph",
                                    "reach_graph",
                                    "follower_count_graph",
                                  ].includes(g.name)
                                ).length > 1
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "informations" },
                                          [
                                            _vm.pageStats
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-user-group",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.reporting.nb_fans"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon fan-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/fans.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm.pageStats.page
                                                      .page_fans >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.pageStats
                                                                  .page
                                                                  .page_fans
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .page_fans /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .page_fans >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.pageStats
                                                                  .page
                                                                  .page_fans
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .page_fans /
                                                                          1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                _vm.pageStats
                                                                  .page
                                                                  .page_fans
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "facebook"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_fans
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.pageStats.page
                                                              .page_fans <
                                                            _vm.pageStats.page
                                                              .previous_period
                                                              .page_fans
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .page_fans
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm
                                                                                    .pageStats
                                                                                    .page
                                                                                    .page_fans /
                                                                                    _vm
                                                                                      .pageStats
                                                                                      .page
                                                                                      .previous_period
                                                                                      .page_fans) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.pageStats.page
                                                              .page_fans != 0 &&
                                                            _vm.pageStats.page
                                                              .page_fans ==
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .page_fans
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .page_fans
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.pageStats.page
                                                              .page_fans >
                                                            _vm.pageStats.page
                                                              .previous_period
                                                              .page_fans
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .page_fans
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .page_fans >
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm
                                                                                      .pageStats
                                                                                      .page
                                                                                      .page_fans /
                                                                                      _vm
                                                                                        .pageStats
                                                                                        .page
                                                                                        .previous_period
                                                                                        .page_fans) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                }),
                                            _vm.pageStats &&
                                            !_vm.lastPage.isGroup
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-eye",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.label.fb.page_views"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon imp-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/impression.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm.graphData.find(
                                                      (g) =>
                                                        g.name ==
                                                        "impression_posts_graph"
                                                    ) === null
                                                      ? _c("p", [_vm._v("N/A")])
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "impression_posts_graph"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impression_posts_graph"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "impression_posts_graph"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "impression_posts_graph"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impression_posts_graph"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "impression_posts_graph"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impression_posts_graph"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "instagram"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .impression_posts_graph
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impression_posts_graph"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) <
                                                            _vm.pageStats.page.previous_period.impression_posts_graph
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.impression_posts_graph
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm.graphData
                                                                                    .find(
                                                                                      (
                                                                                        g
                                                                                      ) =>
                                                                                        g.name ==
                                                                                        "impression_posts_graph"
                                                                                    )
                                                                                    .data.reduce(
                                                                                      (
                                                                                        prev,
                                                                                        curr
                                                                                      ) =>
                                                                                        prev +
                                                                                        curr
                                                                                    ) /
                                                                                    _vm.pageStats.page.previous_period.impression_posts_graph
                                                                                      .map(
                                                                                        (
                                                                                          v
                                                                                        ) =>
                                                                                          v.total
                                                                                      )
                                                                                      .reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      )) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impression_posts_graph"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) != 0 &&
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impression_posts_graph"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) ==
                                                              _vm.pageStats.page.previous_period.impression_posts_graph
                                                                .map(
                                                                  (v) => v.total
                                                                )
                                                                .reduce(
                                                                  (
                                                                    prev,
                                                                    curr
                                                                  ) =>
                                                                    prev + curr
                                                                )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.impression_posts_graph
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impression_posts_graph"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) >
                                                            _vm.pageStats.page.previous_period.impression_posts_graph
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.impression_posts_graph
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.pageStats.page.previous_period.impression_posts_graph
                                                                      .map(
                                                                        (v) =>
                                                                          v.total
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) > 0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm.graphData
                                                                                      .find(
                                                                                        (
                                                                                          g
                                                                                        ) =>
                                                                                          g.name ==
                                                                                          "impression_posts_graph"
                                                                                      )
                                                                                      .data.reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      ) /
                                                                                      _vm.pageStats.page.previous_period.impression_posts_graph
                                                                                        .map(
                                                                                          (
                                                                                            v
                                                                                          ) =>
                                                                                            v.total
                                                                                        )
                                                                                        .reduce(
                                                                                          (
                                                                                            prev,
                                                                                            curr
                                                                                          ) =>
                                                                                            prev +
                                                                                            curr
                                                                                        )) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : !_vm.lastPage.isGroup
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm.pageStats &&
                                            !_vm.lastPage.isGroup
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-eye",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.label.fb.impressions_reach"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon imp-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/impression.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm.graphData.find(
                                                      (g) =>
                                                        g.name == "reach_graph"
                                                    ) === null
                                                      ? _c("p", [_vm._v("N/A")])
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "reach_graph"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "reach_graph"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "reach_graph"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "reach_graph"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "reach_graph"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "reach_graph"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "reach_graph"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "instagram"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .daily_reach_graph
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "reach_graph"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) <
                                                            _vm.pageStats.page.previous_period.daily_reach_graph
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.daily_reach_graph
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm.graphData
                                                                                    .find(
                                                                                      (
                                                                                        g
                                                                                      ) =>
                                                                                        g.name ==
                                                                                        "reach_graph"
                                                                                    )
                                                                                    .data.reduce(
                                                                                      (
                                                                                        prev,
                                                                                        curr
                                                                                      ) =>
                                                                                        prev +
                                                                                        curr
                                                                                    ) /
                                                                                    _vm.pageStats.page.previous_period.daily_reach_graph
                                                                                      .map(
                                                                                        (
                                                                                          v
                                                                                        ) =>
                                                                                          v.total
                                                                                      )
                                                                                      .reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      )) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "reach_graph"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) != 0 &&
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "reach_graph"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) ==
                                                              _vm.pageStats.page.previous_period.daily_reach_graph
                                                                .map(
                                                                  (v) => v.total
                                                                )
                                                                .reduce(
                                                                  (
                                                                    prev,
                                                                    curr
                                                                  ) =>
                                                                    prev + curr
                                                                )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.daily_reach_graph
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "reach_graph"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) >
                                                            _vm.pageStats.page.previous_period.daily_reach_graph
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.daily_reach_graph
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.pageStats.page.previous_period.daily_reach_graph
                                                                      .map(
                                                                        (v) =>
                                                                          v.total
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) > 0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm.graphData
                                                                                      .find(
                                                                                        (
                                                                                          g
                                                                                        ) =>
                                                                                          g.name ==
                                                                                          "reach_graph"
                                                                                      )
                                                                                      .data.reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      ) /
                                                                                      _vm.pageStats.page.previous_period.daily_reach_graph
                                                                                        .map(
                                                                                          (
                                                                                            v
                                                                                          ) =>
                                                                                            v.total
                                                                                        )
                                                                                        .reduce(
                                                                                          (
                                                                                            prev,
                                                                                            curr
                                                                                          ) =>
                                                                                            prev +
                                                                                            curr
                                                                                        )) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : !_vm.lastPage.isGroup
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c("componentGraph", {
                                          key: "audiences",
                                          staticClass: "graph",
                                          attrs: {
                                            data: _vm.graphData.filter((g) =>
                                              [
                                                "impressions_graph",
                                                "reach_graph",
                                                "follower_count_graph",
                                              ].includes(g.name)
                                            ),
                                            state: _vm.graphShowedAudience,
                                            labels: _vm.graphLabels,
                                            lang: _vm.$i18n.locale,
                                            section: "audiences",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "graph-choice" },
                                          _vm._l(
                                            _vm.graphNetwork.filter((g) =>
                                              [
                                                "impressions_graph",
                                                "reach_graph",
                                                "follower_count_graph",
                                              ].includes(g.name)
                                            ),
                                            function (item, idx) {
                                              return _c(
                                                "Tooltip",
                                                {
                                                  key: `graph-select-audience-${idx}`,
                                                  attrs: {
                                                    text: item.description,
                                                    position: "bottom",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "vs-checkbox",
                                                    {
                                                      staticClass: "check",
                                                      attrs: {
                                                        color: item.color,
                                                        "vs-value": `${idx}`,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.graphShowedAudience,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.graphShowedAudience =
                                                            $$v
                                                        },
                                                        expression:
                                                          "graphShowedAudience",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(item.text) +
                                                          " \n              "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        ["facebook", "tiktok"].includes(_vm.lastPage.network)
                          ? _c(
                              "div",
                              { staticClass: "section-graph audiences" },
                              [
                                _c("div", { staticClass: "section-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.reporting.section.audience.title"
                                      )
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "section-subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.reporting.section.audience.subtitle"
                                      )
                                    )
                                  ),
                                ]),
                                _vm.graphData.filter((g) =>
                                  [
                                    "fans_evol",
                                    "fans_adds",
                                    "fans_paids_adds",
                                    "fans_removes",
                                    "page_follows",
                                    "page_daily_follows",
                                    "page_daily_unfollows",
                                  ].includes(g.name)
                                ).length > 1
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "informations" },
                                          [
                                            _vm.pageStats &&
                                            _vm.lastPage.network == "facebook"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-user-group",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.label.fb.page_follows"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon fan-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/fans.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm.pageStats.page
                                                      .page_fans >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.pageStats
                                                                  .page
                                                                  .page_fans
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .page_fans /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .page_fans >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.pageStats
                                                                  .page
                                                                  .page_fans
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm
                                                                          .pageStats
                                                                          .page
                                                                          .page_fans /
                                                                          1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                _vm.pageStats
                                                                  .page
                                                                  .page_fans
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "facebook"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_fans
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.pageStats.page
                                                              .page_fans <
                                                            _vm.pageStats.page
                                                              .previous_period
                                                              .page_fans
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .page_fans
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm
                                                                                    .pageStats
                                                                                    .page
                                                                                    .page_fans /
                                                                                    _vm
                                                                                      .pageStats
                                                                                      .page
                                                                                      .previous_period
                                                                                      .page_fans) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.pageStats.page
                                                              .page_fans != 0 &&
                                                            _vm.pageStats.page
                                                              .page_fans ==
                                                              _vm.pageStats.page
                                                                .previous_period
                                                                .page_fans
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .page_fans
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.pageStats.page
                                                              .page_fans >
                                                            _vm.pageStats.page
                                                              .previous_period
                                                              .page_fans
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm
                                                                            .pageStats
                                                                            .page
                                                                            .previous_period
                                                                            .page_fans
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm
                                                                      .pageStats
                                                                      .page
                                                                      .previous_period
                                                                      .page_fans >
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm
                                                                                      .pageStats
                                                                                      .page
                                                                                      .page_fans /
                                                                                      _vm
                                                                                        .pageStats
                                                                                        .page
                                                                                        .previous_period
                                                                                        .page_fans) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm.lastPage.network ==
                                                "facebook"
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm.pageStats &&
                                            _vm.lastPage.network == "facebook"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-user-group",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.label.fb.page_daily_follows"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon fan-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/fans.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm.graphData
                                                      .find(
                                                        (g) =>
                                                          g.name == "fans_adds"
                                                      )
                                                      .data.reduce(
                                                        (prev, curr) =>
                                                          prev + curr
                                                      ) >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "fans_adds"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "fans_adds"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "fans_adds"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "fans_adds"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "fans_adds"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "fans_adds"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "facebook"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_fan_adds_unique
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "fans_adds"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) <
                                                            _vm.pageStats.page.previous_period.page_fan_adds_unique
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_fan_adds_unique
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm.graphData
                                                                                    .find(
                                                                                      (
                                                                                        g
                                                                                      ) =>
                                                                                        g.name ==
                                                                                        "fans_adds"
                                                                                    )
                                                                                    .data.reduce(
                                                                                      (
                                                                                        prev,
                                                                                        curr
                                                                                      ) =>
                                                                                        prev +
                                                                                        curr
                                                                                    ) /
                                                                                    _vm.pageStats.page.previous_period.page_fan_adds_unique
                                                                                      .map(
                                                                                        (
                                                                                          v
                                                                                        ) =>
                                                                                          v.total
                                                                                      )
                                                                                      .reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      )) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "fans_adds"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) != 0 &&
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "fans_adds"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) ==
                                                              _vm.pageStats.page.previous_period.page_fan_adds_unique
                                                                .map(
                                                                  (v) => v.total
                                                                )
                                                                .reduce(
                                                                  (
                                                                    prev,
                                                                    curr
                                                                  ) =>
                                                                    prev + curr
                                                                )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_fan_adds_unique
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "fans_adds"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) >
                                                            _vm.pageStats.page.previous_period.page_fan_adds_unique
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_fan_adds_unique
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.pageStats.page.previous_period.page_fan_adds_unique
                                                                      .map(
                                                                        (v) =>
                                                                          v.total
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) > 0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm.graphData
                                                                                      .find(
                                                                                        (
                                                                                          g
                                                                                        ) =>
                                                                                          g.name ==
                                                                                          "fans_adds"
                                                                                      )
                                                                                      .data.reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      ) /
                                                                                      _vm.pageStats.page.previous_period.page_fan_adds_unique
                                                                                        .map(
                                                                                          (
                                                                                            v
                                                                                          ) =>
                                                                                            v.total
                                                                                        )
                                                                                        .reduce(
                                                                                          (
                                                                                            prev,
                                                                                            curr
                                                                                          ) =>
                                                                                            prev +
                                                                                            curr
                                                                                        )) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm.lastPage.network ==
                                                "facebook"
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm.pageStats &&
                                            _vm.lastPage.network == "facebook"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-user-group",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.label.fb.page_daily_unfollows"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon fan-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/fans.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    Math.abs(
                                                      _vm.graphData
                                                        .find(
                                                          (g) =>
                                                            g.name ==
                                                            "fans_removes"
                                                        )
                                                        .data.reduce(
                                                          (prev, curr) =>
                                                            prev + curr
                                                        )
                                                    ) >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                Math.abs(
                                                                  _vm.graphData
                                                                    .find(
                                                                      (g) =>
                                                                        g.name ==
                                                                        "fans_removes"
                                                                    )
                                                                    .data.reduce(
                                                                      (
                                                                        prev,
                                                                        curr
                                                                      ) =>
                                                                        prev +
                                                                        curr
                                                                    )
                                                                )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "fans_removes"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : Math.abs(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "fans_removes"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            )
                                                        ) >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                Math.abs(
                                                                  _vm.graphData
                                                                    .find(
                                                                      (g) =>
                                                                        g.name ==
                                                                        "fans_removes"
                                                                    )
                                                                    .data.reduce(
                                                                      (
                                                                        prev,
                                                                        curr
                                                                      ) =>
                                                                        prev +
                                                                        curr
                                                                    )
                                                                )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        Math.abs(
                                                                          _vm.graphData
                                                                            .find(
                                                                              (
                                                                                g
                                                                              ) =>
                                                                                g.name ==
                                                                                "fans_removes"
                                                                            )
                                                                            .data.reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ) / 1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                Math.abs(
                                                                  _vm.graphData
                                                                    .find(
                                                                      (g) =>
                                                                        g.name ==
                                                                        "fans_removes"
                                                                    )
                                                                    .data.reduce(
                                                                      (
                                                                        prev,
                                                                        curr
                                                                      ) =>
                                                                        prev +
                                                                        curr
                                                                    )
                                                                )
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "facebook"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_fan_removes_unique
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "fans_removes"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) <
                                                            _vm.pageStats.page.previous_period.page_fan_removes_unique
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_fan_removes_unique
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm.graphData
                                                                                    .find(
                                                                                      (
                                                                                        g
                                                                                      ) =>
                                                                                        g.name ==
                                                                                        "fans_removes"
                                                                                    )
                                                                                    .data.reduce(
                                                                                      (
                                                                                        prev,
                                                                                        curr
                                                                                      ) =>
                                                                                        prev +
                                                                                        curr
                                                                                    ) /
                                                                                    _vm.pageStats.page.previous_period.page_fan_removes_unique
                                                                                      .map(
                                                                                        (
                                                                                          v
                                                                                        ) =>
                                                                                          v.total
                                                                                      )
                                                                                      .reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      )) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "fans_removes"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) != 0 &&
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "fans_removes"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) ==
                                                              _vm.pageStats.page.previous_period.page_fan_removes_unique
                                                                .map(
                                                                  (v) => v.total
                                                                )
                                                                .reduce(
                                                                  (
                                                                    prev,
                                                                    curr
                                                                  ) =>
                                                                    prev + curr
                                                                )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_fan_removes_unique
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "fans_removes"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) >
                                                            _vm.pageStats.page.previous_period.page_fan_removes_unique
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_fan_removes_unique
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.pageStats.page.previous_period.page_fan_removes_unique
                                                                      .map(
                                                                        (v) =>
                                                                          v.total
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) > 0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm.graphData
                                                                                      .find(
                                                                                        (
                                                                                          g
                                                                                        ) =>
                                                                                          g.name ==
                                                                                          "fans_removes"
                                                                                      )
                                                                                      .data.reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      ) /
                                                                                      _vm.pageStats.page.previous_period.page_fan_removes_unique
                                                                                        .map(
                                                                                          (
                                                                                            v
                                                                                          ) =>
                                                                                            v.total
                                                                                        )
                                                                                        .reduce(
                                                                                          (
                                                                                            prev,
                                                                                            curr
                                                                                          ) =>
                                                                                            prev +
                                                                                            curr
                                                                                        )) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm.lastPage.network ==
                                                "facebook"
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c("componentGraph", {
                                          key: "audiences",
                                          staticClass: "graph",
                                          attrs: {
                                            data: _vm.graphData.filter((g) =>
                                              (_vm.lastPage.network ==
                                              "facebook"
                                                ? [
                                                    "page_follows",
                                                    "page_daily_follows",
                                                    "page_daily_unfollows",
                                                  ]
                                                : [
                                                    "fans_evol",
                                                    "fans_adds",
                                                    "fans_removes",
                                                    "page_follows",
                                                    "page_daily_follows",
                                                    "page_daily_unfollows",
                                                  ]
                                              ).includes(g.name)
                                            ),
                                            state: _vm.graphShowedAudience,
                                            labels: _vm.graphLabels,
                                            lang: _vm.$i18n.locale,
                                            section: "audiences",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "graph-choice" },
                                          _vm._l(
                                            _vm.graphNetwork.filter((g) =>
                                              (_vm.lastPage.network ==
                                              "facebook"
                                                ? [
                                                    "page_follows",
                                                    "page_daily_follows",
                                                    "page_daily_unfollows",
                                                  ]
                                                : [
                                                    "fans_evol",
                                                    "fans_adds",
                                                    "fans_removes",
                                                    "page_follows",
                                                    "page_daily_follows",
                                                    "page_daily_unfollows",
                                                  ]
                                              ).includes(g.name)
                                            ),
                                            function (item, idx) {
                                              return _c(
                                                "Tooltip",
                                                {
                                                  key: `graph-select-audience-${idx}`,
                                                  attrs: {
                                                    text: item.description,
                                                    position: "bottom",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "vs-checkbox",
                                                    {
                                                      staticClass: "check",
                                                      attrs: {
                                                        color: item.color,
                                                        "vs-value": `${idx}`,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.graphShowedAudience,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.graphShowedAudience =
                                                            $$v
                                                        },
                                                        expression:
                                                          "graphShowedAudience",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(item.text) +
                                                          " \n              "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm.lastPage.network == "facebook" &&
                        _vm.graphData.filter((g) =>
                          [
                            "fans_evol",
                            "fans_adds",
                            "fans_paids_adds",
                            "fans_removes",
                            "page_follows",
                            "page_daily_follows",
                            "page_daily_unfollows",
                          ].includes(g.name)
                        ).length > 1
                          ? _c(
                              "div",
                              { staticClass: "section-graph impressions" },
                              [
                                _c("div", { staticClass: "section-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.reporting.section.impressions.title"
                                      )
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "section-subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.reporting.section.impressions.subtitle"
                                      )
                                    )
                                  ),
                                ]),
                                _vm.graphData.filter((g) =>
                                  [
                                    "impressions",
                                    "impressions_paid",
                                    "impressions_viral",
                                  ].includes(g.name)
                                ).length >= 2
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "informations" },
                                          [
                                            _vm.pageStats &&
                                            !_vm.lastPage.isGroup
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-eye",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.label.fb.page_views"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon imp-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/impression.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm.graphData.find(
                                                      (g) =>
                                                        g.name == "page_views"
                                                    ) === null
                                                      ? _c("p", [_vm._v("N/A")])
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "page_views"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "page_views"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "page_views"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "page_views"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "page_views"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "page_views"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "page_views"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "facebook"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_views_total
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "page_views"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) <
                                                            _vm.pageStats.page.previous_period.page_views_total
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_views_total
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm.graphData
                                                                                    .find(
                                                                                      (
                                                                                        g
                                                                                      ) =>
                                                                                        g.name ==
                                                                                        "page_views"
                                                                                    )
                                                                                    .data.reduce(
                                                                                      (
                                                                                        prev,
                                                                                        curr
                                                                                      ) =>
                                                                                        prev +
                                                                                        curr
                                                                                    ) /
                                                                                    _vm.pageStats.page.previous_period.page_views_total
                                                                                      .map(
                                                                                        (
                                                                                          v
                                                                                        ) =>
                                                                                          v.total
                                                                                      )
                                                                                      .reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      )) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "page_views"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) != 0 &&
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "page_views"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) ==
                                                              _vm.pageStats.page.previous_period.page_views_total
                                                                .map(
                                                                  (v) => v.total
                                                                )
                                                                .reduce(
                                                                  (
                                                                    prev,
                                                                    curr
                                                                  ) =>
                                                                    prev + curr
                                                                )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_views_total
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "page_views"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) >
                                                            _vm.pageStats.page.previous_period.page_views_total
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_views_total
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.pageStats.page.previous_period.page_views_total
                                                                      .map(
                                                                        (v) =>
                                                                          v.total
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) > 0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm.graphData
                                                                                      .find(
                                                                                        (
                                                                                          g
                                                                                        ) =>
                                                                                          g.name ==
                                                                                          "page_views"
                                                                                      )
                                                                                      .data.reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      ) /
                                                                                      _vm.pageStats.page.previous_period.page_views_total
                                                                                        .map(
                                                                                          (
                                                                                            v
                                                                                          ) =>
                                                                                            v.total
                                                                                        )
                                                                                        .reduce(
                                                                                          (
                                                                                            prev,
                                                                                            curr
                                                                                          ) =>
                                                                                            prev +
                                                                                            curr
                                                                                        )) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : !_vm.lastPage.isGroup
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm.pageStats &&
                                            !_vm.lastPage.isGroup
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-eye",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.label.fb.impressions_reach"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon imp-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/impression.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm.graphData.find(
                                                      (g) =>
                                                        g.name ==
                                                        "impressions_reach"
                                                    ) === null
                                                      ? _c("p", [_vm._v("N/A")])
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "impressions_reach"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impressions_reach"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "impressions_reach"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "impressions_reach"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impressions_reach"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "impressions_reach"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impressions_reach"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "facebook"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_impressions
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_reach"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) <
                                                            _vm.pageStats.page.previous_period.page_impressions
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_impressions
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm.graphData
                                                                                    .find(
                                                                                      (
                                                                                        g
                                                                                      ) =>
                                                                                        g.name ==
                                                                                        "impressions_reach"
                                                                                    )
                                                                                    .data.reduce(
                                                                                      (
                                                                                        prev,
                                                                                        curr
                                                                                      ) =>
                                                                                        prev +
                                                                                        curr
                                                                                    ) /
                                                                                    _vm.pageStats.page.previous_period.page_impressions
                                                                                      .map(
                                                                                        (
                                                                                          v
                                                                                        ) =>
                                                                                          v.total
                                                                                      )
                                                                                      .reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      )) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_reach"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) != 0 &&
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_reach"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) ==
                                                              _vm.pageStats.page.previous_period.page_impressions
                                                                .map(
                                                                  (v) => v.total
                                                                )
                                                                .reduce(
                                                                  (
                                                                    prev,
                                                                    curr
                                                                  ) =>
                                                                    prev + curr
                                                                )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_impressions
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_reach"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) >
                                                            _vm.pageStats.page.previous_period.page_impressions
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_impressions
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.pageStats.page.previous_period.page_impressions
                                                                      .map(
                                                                        (v) =>
                                                                          v.total
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) > 0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm.graphData
                                                                                      .find(
                                                                                        (
                                                                                          g
                                                                                        ) =>
                                                                                          g.name ==
                                                                                          "impressions_reach"
                                                                                      )
                                                                                      .data.reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      ) /
                                                                                      _vm.pageStats.page.previous_period.page_impressions
                                                                                        .map(
                                                                                          (
                                                                                            v
                                                                                          ) =>
                                                                                            v.total
                                                                                        )
                                                                                        .reduce(
                                                                                          (
                                                                                            prev,
                                                                                            curr
                                                                                          ) =>
                                                                                            prev +
                                                                                            curr
                                                                                        )) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : !_vm.lastPage.isGroup
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm.pageStats &&
                                            !_vm.lastPage.isGroup
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-eye",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.label.fb.impressions_organic"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon imp-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/impression.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm.graphData.find(
                                                      (g) =>
                                                        g.name ==
                                                        "impressions_organic"
                                                    ) === null
                                                      ? _c("p", [_vm._v("N/A")])
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "impressions_organic"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impressions_organic"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "impressions_organic"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "impressions_organic"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impressions_organic"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "impressions_organic"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impressions_organic"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "facebook"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_impressions_organic_v2
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_organic"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) <
                                                            _vm.pageStats.page.previous_period.page_impressions_organic_v2
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_impressions_organic_v2
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm.graphData
                                                                                    .find(
                                                                                      (
                                                                                        g
                                                                                      ) =>
                                                                                        g.name ==
                                                                                        "impressions_organic"
                                                                                    )
                                                                                    .data.reduce(
                                                                                      (
                                                                                        prev,
                                                                                        curr
                                                                                      ) =>
                                                                                        prev +
                                                                                        curr
                                                                                    ) /
                                                                                    _vm.pageStats.page.previous_period.page_impressions_organic_v2
                                                                                      .map(
                                                                                        (
                                                                                          v
                                                                                        ) =>
                                                                                          v.total
                                                                                      )
                                                                                      .reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      )) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_organic"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) != 0 &&
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_organic"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) ==
                                                              _vm.pageStats.page.previous_period.page_impressions_organic_v2
                                                                .map(
                                                                  (v) => v.total
                                                                )
                                                                .reduce(
                                                                  (
                                                                    prev,
                                                                    curr
                                                                  ) =>
                                                                    prev + curr
                                                                )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_impressions_organic_v2
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_organic"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) >
                                                            _vm.pageStats.page.previous_period.page_impressions_organic_v2
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_impressions_organic_v2
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.pageStats.page.previous_period.page_impressions_organic_v2
                                                                      .map(
                                                                        (v) =>
                                                                          v.total
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) > 0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm.graphData
                                                                                      .find(
                                                                                        (
                                                                                          g
                                                                                        ) =>
                                                                                          g.name ==
                                                                                          "impressions_organic"
                                                                                      )
                                                                                      .data.reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      ) /
                                                                                      _vm.pageStats.page.previous_period.page_impressions_organic_v2
                                                                                        .map(
                                                                                          (
                                                                                            v
                                                                                          ) =>
                                                                                            v.total
                                                                                        )
                                                                                        .reduce(
                                                                                          (
                                                                                            prev,
                                                                                            curr
                                                                                          ) =>
                                                                                            prev +
                                                                                            curr
                                                                                        )) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : !_vm.lastPage.isGroup
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm.pageStats &&
                                            !_vm.lastPage.isGroup
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "main-numbers",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-eye",
                                                    }),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.label.fb.impressions_paid"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("img", {
                                                      staticClass:
                                                        "icon imp-ico",
                                                      attrs: {
                                                        src: require("../../../assets/img/reporting_icons/impression.svg"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm.graphData.find(
                                                      (g) =>
                                                        g.name ==
                                                        "impressions_paid"
                                                    ) === null
                                                      ? _c("p", [_vm._v("N/A")])
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "impressions_paid"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impressions_paid"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "impressions_paid"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("M")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.graphData
                                                          .find(
                                                            (g) =>
                                                              g.name ==
                                                              "impressions_paid"
                                                          )
                                                          .data.reduce(
                                                            (prev, curr) =>
                                                              prev + curr
                                                          ) >= 1000
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impressions_paid"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "big-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      Number(
                                                                        _vm.graphData
                                                                          .find(
                                                                            (
                                                                              g
                                                                            ) =>
                                                                              g.name ==
                                                                              "impressions_paid"
                                                                          )
                                                                          .data.reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          ) /
                                                                          1000
                                                                      ).toLocaleString(
                                                                        _vm
                                                                          .$i18n
                                                                          .locale,
                                                                        {
                                                                          maximumFractionDigits: 1,
                                                                        }
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "percent",
                                                                  },
                                                                  [_vm._v("k")]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.numberSpacing(
                                                                _vm.graphData
                                                                  .find(
                                                                    (g) =>
                                                                      g.name ==
                                                                      "impressions_paid"
                                                                  )
                                                                  .data.reduce(
                                                                    (
                                                                      prev,
                                                                      curr
                                                                    ) =>
                                                                      prev +
                                                                      curr
                                                                  )
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    _vm.activeReportingV2 &&
                                                    !_vm.pageStats.page
                                                      .previous_period &&
                                                    _vm.lastPage.network ==
                                                      "facebook"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare wait",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../assets/img/status-waiting.gif"),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm.pageStats.page
                                                          .previous_period &&
                                                        _vm.pageStats.page
                                                          .previous_period
                                                          .page_impressions_paid
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "compare",
                                                          },
                                                          [
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_paid"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) <
                                                            _vm.pageStats.page.previous_period.page_impressions_paid
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_down",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_impressions_paid
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "negative",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              _vm.formatPercentageChange(
                                                                                100 -
                                                                                  (_vm.graphData
                                                                                    .find(
                                                                                      (
                                                                                        g
                                                                                      ) =>
                                                                                        g.name ==
                                                                                        "impressions_paid"
                                                                                    )
                                                                                    .data.reduce(
                                                                                      (
                                                                                        prev,
                                                                                        curr
                                                                                      ) =>
                                                                                        prev +
                                                                                        curr
                                                                                    ) /
                                                                                    _vm.pageStats.page.previous_period.page_impressions_paid
                                                                                      .map(
                                                                                        (
                                                                                          v
                                                                                        ) =>
                                                                                          v.total
                                                                                      )
                                                                                      .reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      )) *
                                                                                    100
                                                                              )
                                                                            ) +
                                                                            "%"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right negative",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_paid"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) != 0 &&
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_paid"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) ==
                                                              _vm.pageStats.page.previous_period.page_impressions_paid
                                                                .map(
                                                                  (v) => v.total
                                                                )
                                                                .reduce(
                                                                  (
                                                                    prev,
                                                                    curr
                                                                  ) =>
                                                                    prev + curr
                                                                )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_flat",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_impressions_paid
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.graphData
                                                              .find(
                                                                (g) =>
                                                                  g.name ==
                                                                  "impressions_paid"
                                                              )
                                                              .data.reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              ) >
                                                            _vm.pageStats.page.previous_period.page_impressions_paid
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                              ? _c(
                                                                  "Tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "trending_up",
                                                                    attrs: {
                                                                      text:
                                                                        _vm.$t(
                                                                          "dash.reporting.previous_period"
                                                                        ) +
                                                                        " (" +
                                                                        _vm.$t(
                                                                          "dash.reporting.from"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .start,
                                                                          false
                                                                        ) +
                                                                        " " +
                                                                        _vm.$t(
                                                                          "dash.reporting.to"
                                                                        ) +
                                                                        " " +
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .getPreviousPeriod
                                                                            .end,
                                                                          false
                                                                        ) +
                                                                        ") : " +
                                                                        _vm.numberSpacing(
                                                                          _vm.pageStats.page.previous_period.page_impressions_paid
                                                                            .map(
                                                                              (
                                                                                v
                                                                              ) =>
                                                                                v.total
                                                                            )
                                                                            .reduce(
                                                                              (
                                                                                prev,
                                                                                curr
                                                                              ) =>
                                                                                prev +
                                                                                curr
                                                                            )
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.pageStats.page.previous_period.page_impressions_paid
                                                                      .map(
                                                                        (v) =>
                                                                          v.total
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) > 0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "positive",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "+" +
                                                                                _vm._s(
                                                                                  _vm.formatPercentageChange(
                                                                                    (_vm.graphData
                                                                                      .find(
                                                                                        (
                                                                                          g
                                                                                        ) =>
                                                                                          g.name ==
                                                                                          "impressions_paid"
                                                                                      )
                                                                                      .data.reduce(
                                                                                        (
                                                                                          prev,
                                                                                          curr
                                                                                        ) =>
                                                                                          prev +
                                                                                          curr
                                                                                      ) /
                                                                                      _vm.pageStats.page.previous_period.page_impressions_paid
                                                                                        .map(
                                                                                          (
                                                                                            v
                                                                                          ) =>
                                                                                            v.total
                                                                                        )
                                                                                        .reduce(
                                                                                          (
                                                                                            prev,
                                                                                            curr
                                                                                          ) =>
                                                                                            prev +
                                                                                            curr
                                                                                        )) *
                                                                                      100 -
                                                                                      100
                                                                                  )
                                                                                ) +
                                                                                "%"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "trending_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-arrow-right positive",
                                                                      staticStyle:
                                                                        {
                                                                          transform:
                                                                            "rotate(-45deg)",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : !_vm.lastPage.isGroup
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c("componentGraph", {
                                          key: "impressions",
                                          staticClass: "graph",
                                          attrs: {
                                            data: _vm.graphData.filter((g) =>
                                              [
                                                "page_views",
                                                "impressions_reach",
                                                "impressions",
                                                "impressions_paid",
                                                "impressions_organic",
                                                "impressions_viral",
                                              ].includes(g.name)
                                            ),
                                            state: _vm.graphShowedImpressions,
                                            labels: _vm.graphLabels,
                                            lang: _vm.$i18n.locale,
                                            section: "impressions",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "graph-choice" },
                                          _vm._l(
                                            _vm.graphNetwork.filter((g) =>
                                              [
                                                "page_views",
                                                "impressions_reach",
                                                "impressions",
                                                "impressions_paid",
                                                "impressions_organic",
                                                "impressions_viral",
                                              ].includes(g.name)
                                            ),
                                            function (item, idx) {
                                              return _c(
                                                "Tooltip",
                                                {
                                                  key: `graph-select-impressions-${idx}`,
                                                  attrs: {
                                                    text: item.description,
                                                    position: "bottom",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "vs-checkbox",
                                                    {
                                                      staticClass: "check",
                                                      attrs: {
                                                        color: item.color,
                                                        "vs-value": `${idx}`,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.graphShowedImpressions,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.graphShowedImpressions =
                                                            $$v
                                                        },
                                                        expression:
                                                          "graphShowedImpressions",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(item.text) +
                                                          " \n              "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm.pageStats &&
                        _vm.pageStats.page &&
                        ((_vm.lastPage.network == "instagram" &&
                          !_vm.pageStats.page.demographicKO) ||
                          _vm.lastPage.network == "facebook" ||
                          _vm.lastPage.network == "tiktok")
                          ? _c(
                              "div",
                              { staticClass: "section-graph demographie" },
                              [
                                _c("div", { staticClass: "section-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        `dash.reporting.section.demographie.title.${_vm.lastPage.network}`
                                      )
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "section-subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        `dash.reporting.section.demographie.subtitle.${_vm.lastPage.network}`
                                      )
                                    )
                                  ),
                                ]),
                                _vm.graphData.filter(
                                  (g) =>
                                    g.data &&
                                    [
                                      "fans_country",
                                      "fans_city",
                                      "fans_male_age",
                                      "fans_female_age",
                                      "fans_undifined_age",
                                    ].includes(g.name)
                                ).length >= 2
                                  ? _c(
                                      "div",
                                      [
                                        _vm.graphData.find(
                                          (g) =>
                                            g.name === "fans_country" && g.data
                                        )
                                          ? [
                                              _c("MapChart", {
                                                attrs: {
                                                  countryData:
                                                    _vm.graphData.filter((g) =>
                                                      ["fans_country"].includes(
                                                        g.name
                                                      )
                                                    )[0].data,
                                                  highColor:
                                                    "rgba(106, 31, 76, 1)",
                                                  lowColor:
                                                    "rgba(106, 31, 76, 0.1)",
                                                  countryStrokeColor: "#ffffff",
                                                  defaultCountryFillColor:
                                                    "#dadada",
                                                  LangUser: _vm.$i18n.locale,
                                                  currencyAdd: false,
                                                },
                                              }),
                                            ]
                                          : _vm._e(),
                                        _c("ul", { staticClass: "bar" }, [
                                          _vm.graphData.find((g) =>
                                            ["fans_locale"].includes(g.name)
                                          )
                                            ? _c(
                                                "li",
                                                [
                                                  _c("componentGraph", {
                                                    key: "demographie_locale",
                                                    staticClass: "graph",
                                                    attrs: {
                                                      data: _vm.graphData
                                                        .filter((g) =>
                                                          [
                                                            "fans_locale",
                                                          ].includes(g.name)
                                                        )
                                                        .slice(0, 10),
                                                      state: [
                                                        "0",
                                                        "1",
                                                        "2",
                                                        "3",
                                                        "4",
                                                        "5",
                                                        "6",
                                                        "7",
                                                        "8",
                                                        "9",
                                                      ],
                                                      labels: _vm.graphData
                                                        .find((g) =>
                                                          [
                                                            "fans_locale",
                                                          ].includes(g.name)
                                                        )
                                                        .labels.slice(0, 10),
                                                      lang: _vm.$i18n.locale,
                                                      section:
                                                        "demographie_locale",
                                                      size: _vm.sizeHorizontalGraph,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.graphData.find((g) =>
                                            ["fans_city"].includes(g.name)
                                          )
                                            ? _c(
                                                "li",
                                                [
                                                  _c("componentGraph", {
                                                    key: "demographie_city",
                                                    staticClass: "graph",
                                                    attrs: {
                                                      data: _vm.graphData
                                                        .filter((g) =>
                                                          [
                                                            "fans_city",
                                                          ].includes(g.name)
                                                        )
                                                        .slice(0, 10),
                                                      state: [
                                                        "0",
                                                        "1",
                                                        "2",
                                                        "3",
                                                        "4",
                                                        "5",
                                                        "6",
                                                        "7",
                                                        "8",
                                                        "9",
                                                      ],
                                                      labels: _vm.graphData
                                                        .find((g) =>
                                                          [
                                                            "fans_city",
                                                          ].includes(g.name)
                                                        )
                                                        .labels.slice(0, 10),
                                                      lang: _vm.$i18n.locale,
                                                      section:
                                                        "demographie_city",
                                                      size: _vm.sizeHorizontalGraph,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                        !_vm.graphData.find((g) =>
                                          ["fans_locale"].includes(g.name)
                                        ) &&
                                        _vm.graphData.find((g) =>
                                          ["fans_age"].includes(g.name)
                                        )
                                          ? _c("ul", { staticClass: "bar" }, [
                                              _c(
                                                "li",
                                                { staticClass: "big" },
                                                [
                                                  _c("componentGraph", {
                                                    key: "demographie_age",
                                                    staticClass: "graph",
                                                    attrs: {
                                                      data: _vm.graphData.filter(
                                                        (g) =>
                                                          ["fans_age"].includes(
                                                            g.name
                                                          )
                                                      ),
                                                      state: ["0"],
                                                      labels:
                                                        _vm.graphData.find(
                                                          (g) =>
                                                            [
                                                              "fans_age",
                                                            ].includes(g.name)
                                                        ).labels,
                                                      lang: _vm.$i18n.locale,
                                                      section:
                                                        "demographie_age",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm.graphData.find((g) =>
                                                ["fans_gender"].includes(g.name)
                                              )
                                                ? _c(
                                                    "li",
                                                    { staticClass: "small" },
                                                    [
                                                      _c("componentGraph", {
                                                        key: "demographie_gender",
                                                        staticClass: "graph",
                                                        attrs: {
                                                          data: _vm.graphData.filter(
                                                            (g) =>
                                                              [
                                                                "fans_gender",
                                                              ].includes(g.name)
                                                          ),
                                                          state: ["0"],
                                                          labels: [
                                                            _vm.$t(
                                                              "page_follows_by_gender_male"
                                                            ),
                                                            _vm.$t(
                                                              "page_follows_by_gender_female"
                                                            ),
                                                            _vm.$t(
                                                              "page_follows_by_gender_undefined"
                                                            ),
                                                          ],
                                                          lang: _vm.$i18n
                                                            .locale,
                                                          section:
                                                            "demographie_gender",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ])
                                          : (_vm.lastPage.network ==
                                              "instagram" ||
                                              _vm.lastPage.network ==
                                                "tiktok") &&
                                            _vm.graphData.find(
                                              (g) =>
                                                g.name == "fans_male_age" &&
                                                g.labels
                                            )
                                          ? _c("ul", { staticClass: "bar" }, [
                                              _c(
                                                "li",
                                                { staticClass: "big" },
                                                [
                                                  _c("componentGraph", {
                                                    key: "demographie_gender_age",
                                                    staticClass: "graph",
                                                    attrs: {
                                                      data: _vm.graphData.filter(
                                                        (g) =>
                                                          [
                                                            "fans_male_age",
                                                            "fans_female_age",
                                                            "fans_undifined_age",
                                                          ].includes(g.name)
                                                      ),
                                                      state: ["0", "1", "2"],
                                                      labels:
                                                        _vm.graphData.find(
                                                          (g) =>
                                                            [
                                                              "fans_male_age",
                                                            ].includes(g.name)
                                                        ).labels,
                                                      lang: _vm.$i18n.locale,
                                                      section:
                                                        "demographie_gender_age",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm.graphData.find(
                                                (g) =>
                                                  g.name == "fans_by_gender"
                                              )
                                                ? _c(
                                                    "li",
                                                    { staticClass: "small" },
                                                    [
                                                      _c("componentGraph", {
                                                        key: "demographie_gender",
                                                        staticClass: "graph",
                                                        attrs: {
                                                          data: _vm.graphData.filter(
                                                            (g) =>
                                                              [
                                                                "fans_by_gender",
                                                              ].includes(g.name)
                                                          ),
                                                          state: [
                                                            "0",
                                                            "1",
                                                            "2",
                                                          ],
                                                          labels: [
                                                            _vm.$t(
                                                              "page_follows_by_gender_male"
                                                            ),
                                                            _vm.$t(
                                                              "page_follows_by_gender_female"
                                                            ),
                                                            _vm.$t(
                                                              "page_follows_by_gender_undefined"
                                                            ),
                                                          ],
                                                          lang: _vm.$i18n
                                                            .locale,
                                                          section:
                                                            "demographie_gender",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm.lastPage &&
                  (_vm.lastPage.network !== "facebook" ||
                    _vm.lastPage.isGroup ||
                    (_vm.lastPage.network === "facebook" &&
                      _vm.graphData.filter((g) =>
                        [
                          "fans_evol",
                          "fans_adds",
                          "fans_removes",
                          "page_follows",
                          "page_daily_follows",
                          "page_daily_unfollows",
                        ].includes(g.name)
                      ).length > 1 &&
                      _vm.graphData.filter((g) =>
                        [
                          "impressions",
                          "impressions_paid",
                          "impressions_viral",
                        ].includes(g.name)
                      ).length == 3 &&
                      _vm.graphData.filter(
                        (g) =>
                          g.data &&
                          ["fans_country", "fans_locale", "fans_city"].includes(
                            g.name
                          )
                      ).length == 3) ||
                    (_vm.pageStats &&
                      _vm.pageStats.page &&
                      _vm.pageStats.page.demographicKO))
                    ? _c(
                        "div",
                        {
                          staticClass: "posts table-wrapper",
                          class: {
                            "on-load":
                              _vm.pageStats &&
                              _vm.pageStats.postsPercentLoader < 100,
                          },
                        },
                        [
                          _vm.lastPage.network === "facebook" &&
                          !_vm.lastPage.isGroup &&
                          _vm.pageStats &&
                          (_vm.pageStats.postsPercentLoader >= 0 ||
                            !_vm.pageStats.postsPercentLoader)
                            ? _c(
                                "span",
                                { staticClass: "loader-posts" },
                                [
                                  _vm.pageStats.postsPercentLoader < 100
                                    ? _c("component-loader", {
                                        attrs: {
                                          progress:
                                            _vm.pageStats.postsPercentLoader,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "vs-table",
                            {
                              staticClass: "content-table",
                              attrs: {
                                hoverFlat: true,
                                search: "",
                                data: _vm.postList,
                                "max-items": "20",
                                pagination: "",
                                noDataText: _vm.$t("dash.noDataText"),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ data }) {
                                      return data
                                        ? _vm._l(data, function (tr, indextr) {
                                            return _c(
                                              "vs-tr",
                                              { key: `data-posts-${indextr}` },
                                              [
                                                _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "t-id",
                                                    attrs: {
                                                      data: data[indextr].id,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.openLink(
                                                              data[indextr]
                                                                .permalink_url ||
                                                                data[indextr]
                                                                  .permalink
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "#" +
                                                            _vm._s(
                                                              data[indextr].id
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "t-date",
                                                    attrs: {
                                                      data:
                                                        data[indextr]
                                                          .created_time ||
                                                        data[indextr].timestamp,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            data[indextr]
                                                              .created_time ||
                                                              data[indextr]
                                                                .timestamp
                                                          )
                                                        ) +
                                                        "\n              "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "t-msg",
                                                    attrs: {
                                                      data: data[indextr]
                                                        .message,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "cell-msg",
                                                      },
                                                      [
                                                        (!data[indextr]
                                                          .attachment_url ||
                                                          data[indextr]
                                                            .attachment_url ===
                                                            "") &&
                                                        !(
                                                          _vm.lastPage
                                                            .network ==
                                                            "linkedin" &&
                                                          [
                                                            "NATIVE_DOCUMENT",
                                                            "VIDEO",
                                                            "MULTI-IMAGE",
                                                          ].includes(
                                                            data[indextr].type
                                                          )
                                                        )
                                                          ? _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "only-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      data[
                                                                        indextr
                                                                      ].message
                                                                        ? _vm.textTruncat(
                                                                            data[
                                                                              indextr
                                                                            ].message
                                                                              .replace(
                                                                                /[^\s]{25,}/,
                                                                                ""
                                                                              )
                                                                              .replace(
                                                                                /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                                ""
                                                                              ),
                                                                            100
                                                                          )
                                                                        : ""
                                                                    ) +
                                                                    "\n                    "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        data[indextr]
                                                          .attachment_url &&
                                                        data[indextr]
                                                          .attachment_url !== ""
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _vm.lastPage
                                                                  .network ==
                                                                  "instagram" &&
                                                                [
                                                                  "video",
                                                                  "VIDEO",
                                                                ].includes(
                                                                  data[indextr]
                                                                    .type
                                                                )
                                                                  ? _c(
                                                                      "video",
                                                                      {
                                                                        attrs: {
                                                                          src: data[
                                                                            indextr
                                                                          ]
                                                                            .attachment_url,
                                                                        },
                                                                      }
                                                                    )
                                                                  : _vm.lastPage
                                                                      .network ==
                                                                      "instagram" &&
                                                                    [
                                                                      "story",
                                                                      "Story",
                                                                    ].includes(
                                                                      data[
                                                                        indextr
                                                                      ].type
                                                                    ) &&
                                                                    data[
                                                                      indextr
                                                                    ].attachment_url.includes(
                                                                      ".mp4"
                                                                    )
                                                                  ? _c(
                                                                      "video",
                                                                      {
                                                                        attrs: {
                                                                          src: data[
                                                                            indextr
                                                                          ]
                                                                            .attachment_url,
                                                                        },
                                                                      }
                                                                    )
                                                                  : _c("img", {
                                                                      ref: `meta-image-${indextr}`,
                                                                      refInFor: true,
                                                                      staticClass:
                                                                        "table-img",
                                                                      attrs: {
                                                                        src: data[
                                                                          indextr
                                                                        ]
                                                                          .attachment_url,
                                                                        alt: "Image",
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.getMetaOgImage(
                                                                              data[
                                                                                indextr
                                                                              ]
                                                                                .unshimmed_url,
                                                                              `meta-image-${indextr}`,
                                                                              indextr
                                                                            )
                                                                          },
                                                                      },
                                                                    }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.lastPage.network ==
                                                          "linkedin" &&
                                                        ["VIDEO"].includes(
                                                          data[indextr].type
                                                        ) &&
                                                        data[indextr].video &&
                                                        (data[indextr].video
                                                          .downloadUrl ||
                                                          data[
                                                            indextr
                                                          ].video.includes(
                                                            ".mp4"
                                                          ))
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("video", {
                                                                  attrs: {
                                                                    src:
                                                                      data[
                                                                        indextr
                                                                      ].video
                                                                        .downloadUrl ||
                                                                      data[
                                                                        indextr
                                                                      ].video,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.lastPage.network ==
                                                          "linkedin" &&
                                                        [
                                                          "MULTI-IMAGE",
                                                        ].includes(
                                                          data[indextr].type
                                                        ) &&
                                                        data[indextr]
                                                          .carrousel &&
                                                        data[indextr].carrousel
                                                          .length &&
                                                        data[indextr]
                                                          .carrousel[0].url
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  ref: `meta-image-${indextr}`,
                                                                  refInFor: true,
                                                                  staticClass:
                                                                    "table-img",
                                                                  attrs: {
                                                                    src: data[
                                                                      indextr
                                                                    ]
                                                                      .carrousel[0]
                                                                      .url,
                                                                    alt: "Image",
                                                                  },
                                                                  on: {
                                                                    error:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.getMetaOgImage(
                                                                          data[
                                                                            indextr
                                                                          ]
                                                                            .unshimmed_url,
                                                                          `meta-image-${indextr}`,
                                                                          indextr
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.lastPage.network ==
                                                          "linkedin" &&
                                                        [
                                                          "NATIVE_DOCUMENT",
                                                        ].includes(
                                                          data[indextr].type
                                                        ) &&
                                                        data[indextr]
                                                          .document &&
                                                        data[indextr].document
                                                          .downloadUrl
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("pdf", {
                                                                  attrs: {
                                                                    src: data[
                                                                      indextr
                                                                    ].document
                                                                      .downloadUrl,
                                                                    page: 1,
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        (data[indextr]
                                                          .attachment_url &&
                                                          data[indextr]
                                                            .attachment_url !==
                                                            "") ||
                                                        (_vm.lastPage.network ==
                                                          "linkedin" &&
                                                          [
                                                            "NATIVE_DOCUMENT",
                                                            "VIDEO",
                                                            "MULTI-IMAGE",
                                                          ].includes(
                                                            data[indextr].type
                                                          ))
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "txt-wrapper",
                                                              },
                                                              [
                                                                data[
                                                                  indextr
                                                                ].message.replace(
                                                                  /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                  ""
                                                                )
                                                                  ? _c("p", [
                                                                      _vm._v(
                                                                        "\n                      " +
                                                                          _vm._s(
                                                                            data[
                                                                              indextr
                                                                            ]
                                                                              .message
                                                                              ? _vm.textTruncat(
                                                                                  data[
                                                                                    indextr
                                                                                  ].message
                                                                                    .replace(
                                                                                      /[^\s]{25,}/,
                                                                                      ""
                                                                                    )
                                                                                    .replace(
                                                                                      /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                                      ""
                                                                                    ),
                                                                                  100
                                                                                )
                                                                              : ""
                                                                          ) +
                                                                          "\n                    "
                                                                      ),
                                                                    ])
                                                                  : data[
                                                                      indextr
                                                                    ]
                                                                      .unshimmed_url
                                                                  ? _c(
                                                                      "p",
                                                                      {
                                                                        ref: `meta-title-${indextr}`,
                                                                        refInFor: true,
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getMetaOgTitle(
                                                                              data[
                                                                                indextr
                                                                              ]
                                                                                .unshimmed_url,
                                                                              `meta-title-${indextr}`,
                                                                              indextr
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "t-type",
                                                    attrs: {
                                                      data: data[indextr].type,
                                                    },
                                                  },
                                                  [
                                                    data[indextr].type ==
                                                      "photo" ||
                                                    data[indextr].type ==
                                                      "IMAGE" ||
                                                    data[indextr].type ===
                                                      "RICH"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_photo"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                        "MULTI-IMAGE"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_multi_images"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                          "video" ||
                                                        data[indextr].type ==
                                                          "VIDEO"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_video"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                          "snippet" ||
                                                        data[indextr].type ===
                                                          "ARTICLE"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_snippet"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                          "text" ||
                                                        data[indextr].type ==
                                                          "NONE"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_text"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                        "tweet"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_tweet"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                        "tweet_image"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_tweet_image"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                        "tweet_video"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_tweet_video"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                        "tweet_animated_gif"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_tweet_animated_gif"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                        "quoted"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_quote"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ==
                                                        "quote_image"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_quote_image"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ===
                                                        "quote_video"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_quote_video"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ===
                                                        "quote_animated_gif"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_quote_animated_gif"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ===
                                                        "CAROUSEL_ALBUM"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_CAROUSEL_ALBUM"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ===
                                                          "NONE" ||
                                                        data[indextr].type ===
                                                          "none" ||
                                                        data[indextr].type ===
                                                          "URN_REFERENCE" ||
                                                        data[indextr].type ===
                                                          ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_NONE"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ===
                                                        "NATIVE_DOCUMENT"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_NATIVE_DOCUMENT"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ===
                                                        "LIVE_VIDEO"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_LIVE_VIDEO"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : data[indextr].type ===
                                                        "CAROUSEL"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.type_CAROUSEL"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              data: data[
                                                                indextr
                                                              ].type,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  data[indextr]
                                                                    .type
                                                                ) +
                                                                "\n                "
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "t-imp",
                                                    attrs: {
                                                      data:
                                                        data[indextr]
                                                          .post_impressions ||
                                                        data[indextr]
                                                          .impressions,
                                                    },
                                                  },
                                                  [
                                                    data[indextr].type ===
                                                      "video" &&
                                                    data[indextr]
                                                      .video_view_count
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .video_view_count
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ])
                                                      : (_vm.lastPage.network ==
                                                          "instagram" &&
                                                          data[indextr]
                                                            .post_impressions ===
                                                            null) ||
                                                        data[indextr]
                                                          .post_impressions ===
                                                          undefined ||
                                                        data[indextr]
                                                          .post_impressions == 0
                                                      ? _c("span", [
                                                          _vm._v("0"),
                                                        ])
                                                      : data[indextr]
                                                          .post_impressions ===
                                                          null ||
                                                        data[indextr]
                                                          .post_impressions ===
                                                          undefined
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.$t(
                                                                "dash.table.no.data"
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v("N/A"),
                                                            ]),
                                                          ]
                                                        )
                                                      : data[indextr]
                                                          .reach_impression !==
                                                          null &&
                                                        data[indextr]
                                                          .reach_impression !==
                                                          undefined
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text:
                                                                data[
                                                                  indextr
                                                                ].reach_impression.toLocaleString(
                                                                  _vm.$i18n
                                                                    .locale,
                                                                  {
                                                                    maximumFractionDigits: 2,
                                                                  }
                                                                ) + "%",
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_impressions ||
                                                                        data[
                                                                          indextr
                                                                        ]
                                                                          .impressions
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .post_impressions ||
                                                                    data[
                                                                      indextr
                                                                    ]
                                                                      .impressions
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ]),
                                                    _vm._v(
                                                      "\n                 \n                "
                                                    ),
                                                    _vm.lastPage.network ==
                                                      "linkedin" &&
                                                    data[indextr]
                                                      .post_impressions_unique !==
                                                      null &&
                                                    data[indextr]
                                                      .post_impressions_unique !==
                                                      undefined
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.$t(
                                                                "dash.reporting.impression_unique"
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "\n                    (" +
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_impressions_unique
                                                                    )
                                                                  ) +
                                                                  ")\n                  "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _vm.lastPage.network !==
                                                  "instagram" &&
                                                _vm.lastPage.network !==
                                                  "tiktok"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-clc",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .link_clicks,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .total_clicks
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .total_clicks
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                              _c("br"),
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    `(${_vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .link_clicks
                                                                    )})`
                                                                  ) +
                                                                  "\n                "
                                                              ),
                                                            ])
                                                          : data[indextr]
                                                              .link_clicks !==
                                                              null &&
                                                            data[indextr]
                                                              .link_clicks !==
                                                              undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .link_clicks
                                                                    )
                                                                  ) +
                                                                  "\n                "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ==
                                                "pinterest"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-clc",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .reach_save,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .reach_save !==
                                                          null &&
                                                        data[indextr]
                                                          .reach_save !==
                                                          undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .reach_save
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ==
                                                "pinterest"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-clc",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .reach_outboundclicks,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .reach_outboundclicks !==
                                                          null &&
                                                        data[indextr]
                                                          .reach_outboundclicks !==
                                                          undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .reach_outboundclicks
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network !==
                                                  "twitter" &&
                                                _vm.lastPage.network !=
                                                  "pinterest"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-com",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .comments_count,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .comments_count !==
                                                          null &&
                                                        data[indextr]
                                                          .comments_count !==
                                                          undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .comments_count
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                [
                                                  "facebook",
                                                  "linkedin",
                                                  "tiktok",
                                                ].includes(_vm.lastPage.network)
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-ptg",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .shares_count,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .shares_count
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                "facebook"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-rea",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .post_reactions,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/angry.svg"),
                                                                    alt: "Angry",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .anger
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/haha.svg"),
                                                                    alt: "Haha",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .haha
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/like.svg"),
                                                                    alt: "Like",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .like
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/love.svg"),
                                                                    alt: "Love",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .love
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/sad.svg"),
                                                                    alt: "Sad",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .sad
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/wow.svg"),
                                                                    alt: "Wow",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .wow
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "sum",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.total_reactions"
                                                                ) +
                                                                  " " +
                                                                  _vm.numberSpacing(
                                                                    data[
                                                                      indextr
                                                                    ]
                                                                      .post_reactions[0]
                                                                      .sum
                                                                  )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                  "linkedin" &&
                                                data[indextr].post_reactions
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-rea",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .post_reactions,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon icon-linkedin",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/linkedin-curious.png"),
                                                                    alt: "MAYBE",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .MAYBE
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon icon-linkedin",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/linkedin-celebrate.png"),
                                                                    alt: "PRAISE",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .PRAISE
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon icon-linkedin",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/linkedin-like.png"),
                                                                    alt: "LIKE",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .LIKE
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon icon-linkedin",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/linkedin-love.png"),
                                                                    alt: "EMPATHY",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .EMPATHY
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon icon-linkedin",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/linkedin-insightful.png"),
                                                                    alt: "INTEREST",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .INTEREST
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon icon-linkedin",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("../../../assets/img/reporting_icons/linkedin-support.png"),
                                                                    alt: "APPRECIATION",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .post_reactions[0]
                                                                        .value
                                                                        .APPRECIATION
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "sum",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.reporting.total_reactions"
                                                                ) +
                                                                  " " +
                                                                  _vm.numberSpacing(
                                                                    data[
                                                                      indextr
                                                                    ]
                                                                      .post_reactions[0]
                                                                      .sum
                                                                  )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.lastPage.network ===
                                                    "linkedin"
                                                  ? _c(
                                                      "vs-td",
                                                      [
                                                        _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.$t(
                                                                "dash.table.no.data"
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v("N/A"),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                "twitter"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-tw-rt",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .retweet_count,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              data[indextr]
                                                                .retweet_count
                                                            ) +
                                                            "\n              "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                  "twitter" ||
                                                _vm.lastPage.network ===
                                                  "instagram" ||
                                                _vm.lastPage.network ===
                                                  "tiktok"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-tw-like",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .like_count,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .like_count !==
                                                          null &&
                                                        data[indextr]
                                                          .like_count !==
                                                          undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    data[
                                                                      indextr
                                                                    ].like_count
                                                                  ) +
                                                                  "\n                "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                "tiktok"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-time_watched",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .time_watched,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .time_watched !==
                                                          null &&
                                                        data[indextr]
                                                          .time_watched !==
                                                          undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    _vm.humanizeTime(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .time_watched *
                                                                        1000
                                                                    )
                                                                  ) +
                                                                  "\n                "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                "tiktok"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-video_per_duration",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .video_per_duration,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .video_per_duration !==
                                                          null &&
                                                        data[indextr]
                                                          .video_per_duration !==
                                                          undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    _vm.humanizeTime(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .video_per_duration *
                                                                        1000
                                                                    )
                                                                  ) +
                                                                  "\n                "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                "tiktok"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-viewer",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .viewer,
                                                        },
                                                      },
                                                      [
                                                        data[indextr].viewer !==
                                                          null &&
                                                        data[indextr].viewer !==
                                                          undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ].viewer
                                                                    )
                                                                  ) +
                                                                  "\n                "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                "tiktok"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-video_finish_rate",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .video_finish_rate,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .video_finish_rate !==
                                                          null &&
                                                        data[indextr]
                                                          .video_finish_rate !==
                                                          undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    (
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .video_finish_rate *
                                                                      100
                                                                    ).toLocaleString(
                                                                      _vm.$i18n
                                                                        .locale,
                                                                      {
                                                                        maximumFractionDigits: 2,
                                                                      }
                                                                    )
                                                                  ) +
                                                                  "%\n                "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                "tiktok"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-video_new_follower",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .video_new_follower,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .video_new_follower !==
                                                          null &&
                                                        data[indextr]
                                                          .video_new_follower !==
                                                          undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    _vm.numberSpacing(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .video_new_follower
                                                                    )
                                                                  ) +
                                                                  "\n                "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                "twitter"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-tw-reply",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .reply_count,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              data[indextr]
                                                                .reply_count
                                                            ) +
                                                            "\n              "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network ===
                                                "twitter"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-tw-quote",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .quote_count,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              data[indextr]
                                                                .quote_count
                                                            ) +
                                                            "\n              "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.lastPage.network !=
                                                "pinterest"
                                                  ? _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-eng",
                                                        attrs: {
                                                          data:
                                                            data[indextr]
                                                              .reach_engagement ||
                                                            (data[indextr]
                                                              .like_count *
                                                              100) /
                                                              data[indextr]
                                                                .impressions,
                                                        },
                                                      },
                                                      [
                                                        data[indextr]
                                                          .reach_engagement !==
                                                        undefined
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    data[
                                                                      indextr
                                                                    ]
                                                                      .reach_engagement !==
                                                                      null
                                                                      ? data[
                                                                          indextr
                                                                        ].reach_engagement.toLocaleString(
                                                                          _vm
                                                                            .$i18n
                                                                            .locale,
                                                                          {
                                                                            maximumFractionDigits: 2,
                                                                          }
                                                                        )
                                                                      : (
                                                                          (data[
                                                                            indextr
                                                                          ]
                                                                            .like_count *
                                                                            100) /
                                                                          data[
                                                                            indextr
                                                                          ]
                                                                            .impressions
                                                                        ).toLocaleString(
                                                                          _vm
                                                                            .$i18n
                                                                            .locale,
                                                                          {
                                                                            maximumFractionDigits: 2,
                                                                          }
                                                                        )
                                                                  ) +
                                                                  "%\n                "
                                                              ),
                                                            ])
                                                          : _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    "dash.table.no.data"
                                                                  ),
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("N/A"),
                                                                ]),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          })
                                        : undefined
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("div", [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.reporting.section.posts.title"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "exportRep" },
                                    [
                                      _vm.pageStats
                                        ? _c(
                                            "vs-button",
                                            {
                                              staticClass: "btn-img",
                                              attrs: {
                                                color: "#2F1937",
                                                size: "small",
                                                "vs-type": "filled",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.popupActivo3 = true
                                                },
                                              },
                                            },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.button.exportPosts"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/icon_export.svg"),
                                                  alt: "unlock",
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "vs-popup",
                                        {
                                          attrs: {
                                            title: "Export",
                                            active: _vm.popupActivo3,
                                          },
                                          on: {
                                            "update:active": function ($event) {
                                              _vm.popupActivo3 = $event
                                            },
                                          },
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.export.selectformat"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]),
                                          _vm.checkLock("conciergerie")
                                            ? [
                                                [
                                                  "facebook",
                                                  "instagram",
                                                  "linkedin",
                                                  "tiktok",
                                                ].includes(_vm.lastPage.network)
                                                  ? _c(
                                                      "vs-button",
                                                      {
                                                        staticClass:
                                                          "btnFormat",
                                                        attrs: {
                                                          disabled:
                                                            !_vm.pageStats ||
                                                            _vm.updateCountDayLoader !=
                                                              null ||
                                                            !(
                                                              _vm.pageStats &&
                                                              _vm.pageStats
                                                                .page &&
                                                              _vm.pageStats.page
                                                                .previous_period
                                                            ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.getPDF()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      pdf\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                [
                                                  "facebook",
                                                  "instagram",
                                                  "linkedin",
                                                  "tiktok",
                                                ].includes(_vm.lastPage.network)
                                                  ? _c(
                                                      "vs-button",
                                                      {
                                                        staticClass:
                                                          "btnFormat",
                                                        staticStyle: {
                                                          "margin-top": "10px",
                                                          "margin-right":
                                                            "10px",
                                                          "margin-left": "10px",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            !_vm.pageStats ||
                                                            _vm.updateCountDayLoader !=
                                                              null,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.getExportApiUrl()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      api\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            : [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.plan.active_conciergerie_to_get_features.content_export_reporting"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    [
                                                      "facebook",
                                                      "instagram",
                                                      "linkedin",
                                                      "tiktok",
                                                    ].includes(
                                                      _vm.lastPage.network
                                                    )
                                                      ? _c(
                                                          "vs-button",
                                                          {
                                                            staticClass:
                                                              "btnFormat",
                                                            attrs: {
                                                              disabled:
                                                                !_vm.pageStats ||
                                                                _vm.updateCountDayLoader !=
                                                                  null,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.goToSettings()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        pdf\n                      "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.plan.active_conciergerie_to_get_features.content_export_reporting"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    [
                                                      "facebook",
                                                      "instagram",
                                                      "linkedin",
                                                      "tiktok",
                                                    ].includes(
                                                      _vm.lastPage.network
                                                    )
                                                      ? _c(
                                                          "vs-button",
                                                          {
                                                            staticClass:
                                                              "btnFormat",
                                                            staticStyle: {
                                                              "margin-top":
                                                                "10px",
                                                              "margin-right":
                                                                "10px",
                                                              "margin-left":
                                                                "10px",
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                !_vm.pageStats ||
                                                                _vm.updateCountDayLoader !=
                                                                  null,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.goToSettings()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        api\n                      "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                          _vm._l(
                                            _vm.formats,
                                            function (format) {
                                              return _c(
                                                "vs-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.pageStats &&
                                                        _vm.pageStats.page
                                                          .nb_posts > 0,
                                                      expression:
                                                        "pageStats && pageStats.page.nb_posts > 0",
                                                    },
                                                  ],
                                                  key: `export-${format.value}`,
                                                  staticClass: "btnFormat",
                                                  staticStyle: {
                                                    "margin-top": "10px",
                                                    "margin-right": "10px",
                                                    "margin-left": "10px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.exportData(
                                                        format.value,
                                                        "posts"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(format.value) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                              _c(
                                "template",
                                { slot: "thead" },
                                [
                                  _c(
                                    "vs-th",
                                    { staticClass: "t-id" },
                                    [
                                      _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.$t(
                                              "dash.reporting.header_id"
                                            ),
                                          },
                                        },
                                        [_c("span")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vs-th",
                                    {
                                      staticClass: "t-date",
                                      attrs: { sortKey: "created_time" },
                                    },
                                    [
                                      _vm._v(
                                        " \n              " +
                                          _vm._s(
                                            _vm.capitalize(
                                              _vm.$t("dash.table.title.date")
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                      _c("span", { staticClass: "sort-th" }, [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  expand_less\n                "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  expand_more\n                "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "vs-th",
                                    {
                                      staticClass: "t-msg",
                                      attrs: { sortKey: "message" },
                                    },
                                    [
                                      _vm._v(
                                        " \n              " +
                                          _vm._s(
                                            _vm.capitalize(
                                              _vm.$t("dash.table.title.content")
                                            )
                                          ) +
                                          " \n              "
                                      ),
                                      _c("span", { staticClass: "sort-th" }, [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  expand_less\n                "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  expand_more\n                "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("vs-th", { staticClass: "t-type" }, [
                                    _vm._v(
                                      "\n              Type\n            "
                                    ),
                                  ]),
                                  _c(
                                    "vs-th",
                                    {
                                      staticClass: "t-imp",
                                      attrs: { sortKey: "post_impressions" },
                                    },
                                    [
                                      _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.$t(
                                              "dash.reporting.header_impression"
                                            ),
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.reporting.impression"
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("span", { staticClass: "sort-th" }, [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  expand_less\n                "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  expand_more\n                "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm.lastPage.network !== "instagram" &&
                                  _vm.lastPage.network !== "tiktok"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-clc",
                                          attrs: { sortKey: "link_clicks" },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  `dash.reporting.header_click${
                                                    _vm.lastPage.network ===
                                                    "facebook"
                                                      ? ".fb"
                                                      : ""
                                                  }`
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        `dash.reporting.clic`
                                                      )
                                                    ) +
                                                    " \n              "
                                                ),
                                              ]),
                                              _vm.lastPage.network ===
                                              "facebook"
                                                ? _c("span", [
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            `dash.reporting.clic.fb`
                                                          )
                                                        ) +
                                                        " \n              "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network !== "twitter" &&
                                  _vm.lastPage.network !== "pinterest"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-com",
                                          attrs: { sortKey: "comments_count" },
                                        },
                                        [
                                          _vm._v(
                                            " \n              Commentaires\n              "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  ["facebook", "linkedin", "tiktok"].includes(
                                    _vm.lastPage.network
                                  )
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-ptg",
                                          attrs: { sortKey: "shares_count" },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_share"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " \n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.label.fb.shares"
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "facebook" ||
                                  _vm.lastPage.network === "linkedin"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-rea",
                                          attrs: {
                                            sortKey: "post_reactions_sum",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " \n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.reporting.reaction"
                                                )
                                              ) +
                                              " \n               "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "twitter"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-tw-rt",
                                          attrs: { sortKey: "retweet_count" },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_retweet"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " \n              Retweet\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "twitter" ||
                                  _vm.lastPage.network === "instagram" ||
                                  _vm.lastPage.network === "tiktok"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-tw-like",
                                          attrs: { sortKey: "like_count" },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_like"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n              Like\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "tiktok"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-time_watched",
                                          attrs: { sortKey: "time_watched" },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_video_time_watched"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.reporting.video_time_watched"
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "tiktok"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-video_per_duration",
                                          attrs: {
                                            sortKey: "video_per_duration",
                                          },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_video_time_watched_avg"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.reporting.video_time_watched_avg"
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "tiktok"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-viewer",
                                          attrs: { sortKey: "viewer" },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_video_viewer"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.reporting.video_viewer"
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "tiktok"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-video_finish_rate",
                                          attrs: {
                                            sortKey: "video_finish_rate",
                                          },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_video_finish_rate"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.reporting.video_finish_rate"
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "tiktok"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-video_new_follower",
                                          attrs: {
                                            sortKey: "video_new_follower",
                                          },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_video_new_follower"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.reporting.video_new_follower"
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "twitter"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-tw-reply",
                                          attrs: { sortKey: "reply_count" },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_reply"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n              Reply\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network === "twitter"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-tw-quote",
                                          attrs: { sortKey: "quote_count" },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_quote"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n              Quote\n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network != "pinterest"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-eng",
                                          attrs: {
                                            sortKey: "reach_engagement",
                                          },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_engamement"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " \n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.reporting.engagemment"
                                                      )
                                                    ) +
                                                    " \n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network == "pinterest"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-eng",
                                          attrs: { sortKey: "reach_save" },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_save"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " \n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.reporting.save"
                                                      )
                                                    ) +
                                                    " \n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.lastPage.network == "pinterest"
                                    ? _c(
                                        "vs-th",
                                        {
                                          staticClass: "t-eng",
                                          attrs: {
                                            sortKey: "reach_outboundclicks",
                                          },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.header_outboundclicks"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " \n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.reporting.outboundclick"
                                                      )
                                                    ) +
                                                    " \n              "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-th" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_less\n                "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  expand_more\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _vm.pageStats &&
                          [
                            "linkedin",
                            "instagram",
                            "facebook",
                            "tiktok",
                          ].includes(_vm.lastPage.network)
                            ? _c("div", { staticClass: "section-graph" }, [
                                _c("div", [
                                  _c("ul", { staticClass: "bar" }, [
                                    _c(
                                      "li",
                                      { staticClass: "small" },
                                      [
                                        _c("componentGraph", {
                                          key: "typePosts_graph",
                                          staticClass: "graph",
                                          attrs: {
                                            data: _vm.graphData
                                              .filter((g) =>
                                                ["typePosts_graph"].includes(
                                                  g.name
                                                )
                                              )
                                              .slice(0, 10),
                                            state: [
                                              "0",
                                              "1",
                                              "2",
                                              "3",
                                              "4",
                                              "5",
                                              "6",
                                            ],
                                            labels: _vm.graphData
                                              .find((g) =>
                                                ["typePosts_graph"].includes(
                                                  g.name
                                                )
                                              )
                                              .labels.slice(0, 10),
                                            lang: _vm.$i18n.locale,
                                            section: "typePosts_graph",
                                            size: _vm.sizeHorizontalGraph,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "small" },
                                      [
                                        _c("componentGraph", {
                                          key: "typePosts_engagement_graph",
                                          staticClass: "graph",
                                          attrs: {
                                            data: _vm.graphData
                                              .filter((g) =>
                                                [
                                                  "typePosts_engagement_graph",
                                                ].includes(g.name)
                                              )
                                              .slice(0, 10),
                                            state: [
                                              "0",
                                              "1",
                                              "2",
                                              "3",
                                              "4",
                                              "5",
                                              "6",
                                            ],
                                            labels: _vm.graphData
                                              .find((g) =>
                                                [
                                                  "typePosts_engagement_graph",
                                                ].includes(g.name)
                                              )
                                              .labels.slice(0, 10),
                                            lang: _vm.$i18n.locale,
                                            section:
                                              "typePosts_engagement_graph",
                                            size: _vm.sizeHorizontalGraph,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "small" },
                                      [
                                        _c("componentGraph", {
                                          key: "dayPosts_graph",
                                          staticClass: "graph",
                                          attrs: {
                                            data: _vm.graphData
                                              .filter((g) =>
                                                ["dayPosts_graph"].includes(
                                                  g.name
                                                )
                                              )
                                              .slice(0, 10),
                                            state: [
                                              "0",
                                              "1",
                                              "2",
                                              "3",
                                              "4",
                                              "5",
                                              "6",
                                            ],
                                            labels: _vm.graphData
                                              .find((g) =>
                                                ["dayPosts_graph"].includes(
                                                  g.name
                                                )
                                              )
                                              .labels.slice(0, 10),
                                            lang: _vm.$i18n.locale,
                                            section: "dayPosts_graph",
                                            size: _vm.sizeHorizontalGraph,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "small" },
                                      [
                                        _c("componentGraph", {
                                          key: "dayPosts_engagement_graph",
                                          staticClass: "graph",
                                          attrs: {
                                            data: _vm.graphData
                                              .filter((g) =>
                                                [
                                                  "dayPosts_engagement_graph",
                                                ].includes(g.name)
                                              )
                                              .slice(0, 10),
                                            state: [
                                              "0",
                                              "1",
                                              "2",
                                              "3",
                                              "4",
                                              "5",
                                              "6",
                                            ],
                                            labels: _vm.graphData
                                              .find((g) =>
                                                [
                                                  "dayPosts_engagement_graph",
                                                ].includes(g.name)
                                              )
                                              .labels.slice(0, 10),
                                            lang: _vm.$i18n.locale,
                                            section:
                                              "dayPosts_engagement_graph",
                                            size: _vm.sizeHorizontalGraph,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm.pageStats &&
                          _vm.postList &&
                          _vm.postList.length &&
                          _vm.postList.filter((p) => p.type == "VIDEO")
                            .length &&
                          _vm.lastPage.network === "linkedin"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "posts table-wrapper linkedin-video",
                                },
                                [
                                  _c(
                                    "vs-table",
                                    {
                                      staticClass: "content-table",
                                      attrs: {
                                        hoverFlat: true,
                                        search: "",
                                        data: _vm.postList.filter(
                                          (p) => p.type == "VIDEO"
                                        ),
                                        "max-items": "20",
                                        pagination: "",
                                        noDataText: _vm.$t("dash.noDataText"),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ data }) {
                                              return data
                                                ? _vm._l(
                                                    data,
                                                    function (tr, indextr) {
                                                      return _c(
                                                        "vs-tr",
                                                        {
                                                          key: `data-posts-${indextr}`,
                                                        },
                                                        [
                                                          _c(
                                                            "vs-td",
                                                            {
                                                              staticClass:
                                                                "t-id",
                                                              attrs: {
                                                                data: data[
                                                                  indextr
                                                                ].id,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        return _vm.openLink(
                                                                          data[
                                                                            indextr
                                                                          ]
                                                                            .permalink_url ||
                                                                            data[
                                                                              indextr
                                                                            ]
                                                                              .permalink
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "#" +
                                                                      _vm._s(
                                                                        data[
                                                                          indextr
                                                                        ].id
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "vs-td",
                                                            {
                                                              staticClass:
                                                                "t-date",
                                                              attrs: {
                                                                data:
                                                                  data[indextr]
                                                                    .created_time ||
                                                                  data[indextr]
                                                                    .timestamp,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    _vm.formatDate(
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .created_time ||
                                                                        data[
                                                                          indextr
                                                                        ]
                                                                          .timestamp
                                                                    )
                                                                  ) +
                                                                  "\n                "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "vs-td",
                                                            {
                                                              staticClass:
                                                                "t-msg",
                                                              attrs: {
                                                                data: data[
                                                                  indextr
                                                                ].message,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "cell-msg",
                                                                },
                                                                [
                                                                  !data[indextr]
                                                                    .attachment_url ||
                                                                  data[indextr]
                                                                    .attachment_url ===
                                                                    ""
                                                                    ? _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "only-text",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                      " +
                                                                              _vm._s(
                                                                                data[
                                                                                  indextr
                                                                                ]
                                                                                  .message
                                                                                  ? _vm.textTruncat(
                                                                                      data[
                                                                                        indextr
                                                                                      ].message
                                                                                        .replace(
                                                                                          /[^\s]{25,}/,
                                                                                          ""
                                                                                        )
                                                                                        .replace(
                                                                                          /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                                          ""
                                                                                        ),
                                                                                      100
                                                                                    )
                                                                                  : ""
                                                                              ) +
                                                                              "\n                      "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  data[indextr]
                                                                    .attachment_url &&
                                                                  data[indextr]
                                                                    .attachment_url !==
                                                                    ""
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "thumb-wrapper",
                                                                        },
                                                                        [
                                                                          _vm
                                                                            .lastPage
                                                                            .network ==
                                                                            "instagram" &&
                                                                          [
                                                                            "video",
                                                                            "VIDEO",
                                                                          ].includes(
                                                                            data[
                                                                              indextr
                                                                            ]
                                                                              .type
                                                                          )
                                                                            ? _c(
                                                                                "video",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      src: data[
                                                                                        indextr
                                                                                      ]
                                                                                        .attachment_url,
                                                                                    },
                                                                                }
                                                                              )
                                                                            : _vm
                                                                                .lastPage
                                                                                .network ==
                                                                                "instagram" &&
                                                                              [
                                                                                "story",
                                                                                "Story",
                                                                              ].includes(
                                                                                data[
                                                                                  indextr
                                                                                ]
                                                                                  .type
                                                                              ) &&
                                                                              data[
                                                                                indextr
                                                                              ].attachment_url.includes(
                                                                                ".mp4"
                                                                              )
                                                                            ? _c(
                                                                                "video",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      src: data[
                                                                                        indextr
                                                                                      ]
                                                                                        .attachment_url,
                                                                                    },
                                                                                }
                                                                              )
                                                                            : _c(
                                                                                "img",
                                                                                {
                                                                                  ref: `meta-image-${indextr}`,
                                                                                  refInFor: true,
                                                                                  staticClass:
                                                                                    "table-img",
                                                                                  attrs:
                                                                                    {
                                                                                      src: data[
                                                                                        indextr
                                                                                      ]
                                                                                        .attachment_url,
                                                                                      alt: "Image",
                                                                                    },
                                                                                  on: {
                                                                                    error:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.getMetaOgImage(
                                                                                          data[
                                                                                            indextr
                                                                                          ]
                                                                                            .unshimmed_url,
                                                                                          `meta-image-${indextr}`,
                                                                                          indextr
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                }
                                                                              ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  data[indextr]
                                                                    .attachment_url &&
                                                                  data[indextr]
                                                                    .attachment_url !==
                                                                    ""
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "txt-wrapper",
                                                                        },
                                                                        [
                                                                          data[
                                                                            indextr
                                                                          ].message.replace(
                                                                            /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                            ""
                                                                          )
                                                                            ? _c(
                                                                                "p",
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                        " +
                                                                                      _vm._s(
                                                                                        data[
                                                                                          indextr
                                                                                        ]
                                                                                          .message
                                                                                          ? _vm.textTruncat(
                                                                                              data[
                                                                                                indextr
                                                                                              ].message
                                                                                                .replace(
                                                                                                  /[^\s]{25,}/,
                                                                                                  ""
                                                                                                )
                                                                                                .replace(
                                                                                                  /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                                                  ""
                                                                                                ),
                                                                                              100
                                                                                            )
                                                                                          : ""
                                                                                      ) +
                                                                                      "\n                      "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : data[
                                                                                indextr
                                                                              ]
                                                                                .unshimmed_url
                                                                            ? _c(
                                                                                "p",
                                                                                {
                                                                                  ref: `meta-title-${indextr}`,
                                                                                  refInFor: true,
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.getMetaOgTitle(
                                                                                        data[
                                                                                          indextr
                                                                                        ]
                                                                                          .unshimmed_url,
                                                                                        `meta-title-${indextr}`,
                                                                                        indextr
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "vs-td",
                                                            {
                                                              staticClass:
                                                                "t-video_view_count",
                                                              attrs: {
                                                                data: data[
                                                                  indextr
                                                                ].video_view,
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      _vm.numberSpacing(
                                                                        data[
                                                                          indextr
                                                                        ]
                                                                          .video_view
                                                                      )
                                                                    ) +
                                                                    "\n                  "
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "vs-td",
                                                            {
                                                              staticClass:
                                                                "t-video_time_watched",
                                                              attrs: {
                                                                data: _vm.humanizeTime(
                                                                  data[indextr]
                                                                    .time_watched
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      _vm.humanizeTime(
                                                                        data[
                                                                          indextr
                                                                        ]
                                                                          .time_watched
                                                                      )
                                                                    ) +
                                                                    "\n                  "
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "vs-td",
                                                            {
                                                              staticClass:
                                                                "t-video_time_watched_avg",
                                                              attrs: {
                                                                data: _vm.humanizeTime(
                                                                  data[indextr]
                                                                    .time_watched /
                                                                    data[
                                                                      indextr
                                                                    ].video_view
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      _vm.humanizeTime(
                                                                        data[
                                                                          indextr
                                                                        ]
                                                                          .time_watched /
                                                                          data[
                                                                            indextr
                                                                          ]
                                                                            .video_view
                                                                      )
                                                                    ) +
                                                                    "\n                  "
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "vs-td",
                                                            {
                                                              staticClass:
                                                                "t-video_viewer",
                                                              attrs: {
                                                                data: data[
                                                                  indextr
                                                                ].viewer,
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      _vm.numberSpacing(
                                                                        data[
                                                                          indextr
                                                                        ].viewer
                                                                      )
                                                                    ) +
                                                                    "\n                  "
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "vs-td",
                                                            {
                                                              staticClass:
                                                                "t-imp",
                                                              attrs: {
                                                                data:
                                                                  data[indextr]
                                                                    .post_impressions ||
                                                                  data[indextr]
                                                                    .impressions,
                                                              },
                                                            },
                                                            [
                                                              data[indextr]
                                                                .type ===
                                                                "video" &&
                                                              data[indextr]
                                                                .video_view_count
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                    " +
                                                                        _vm._s(
                                                                          _vm.numberSpacing(
                                                                            data[
                                                                              indextr
                                                                            ]
                                                                              .video_view_count
                                                                          )
                                                                        ) +
                                                                        "\n                  "
                                                                    ),
                                                                  ])
                                                                : (_vm.lastPage
                                                                    .network ==
                                                                    "instagram" &&
                                                                    data[
                                                                      indextr
                                                                    ]
                                                                      .post_impressions ===
                                                                      null) ||
                                                                  data[indextr]
                                                                    .post_impressions ===
                                                                    undefined ||
                                                                  data[indextr]
                                                                    .post_impressions ==
                                                                    0
                                                                ? _c("span", [
                                                                    _vm._v("0"),
                                                                  ])
                                                                : data[indextr]
                                                                    .post_impressions ===
                                                                    null ||
                                                                  data[indextr]
                                                                    .post_impressions ===
                                                                    undefined
                                                                ? _c(
                                                                    "Tooltip",
                                                                    {
                                                                      attrs: {
                                                                        text: _vm.$t(
                                                                          "dash.table.no.data"
                                                                        ),
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "N/A"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : data[indextr]
                                                                    .reach_impression !==
                                                                    null &&
                                                                  data[indextr]
                                                                    .reach_impression !==
                                                                    undefined
                                                                ? _c(
                                                                    "Tooltip",
                                                                    {
                                                                      attrs: {
                                                                        text:
                                                                          data[
                                                                            indextr
                                                                          ].reach_impression.toLocaleString(
                                                                            _vm
                                                                              .$i18n
                                                                              .locale,
                                                                            {
                                                                              maximumFractionDigits: 2,
                                                                            }
                                                                          ) +
                                                                          "%",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                      " +
                                                                              _vm._s(
                                                                                _vm.numberSpacing(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .post_impressions ||
                                                                                    data[
                                                                                      indextr
                                                                                    ]
                                                                                      .impressions
                                                                                )
                                                                              ) +
                                                                              "\n                    "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      "\n                    " +
                                                                        _vm._s(
                                                                          _vm.numberSpacing(
                                                                            data[
                                                                              indextr
                                                                            ]
                                                                              .post_impressions ||
                                                                              data[
                                                                                indextr
                                                                              ]
                                                                                .impressions
                                                                          )
                                                                        ) +
                                                                        "\n                  "
                                                                    ),
                                                                  ]),
                                                              _vm._v(
                                                                "\n                   \n                  "
                                                              ),
                                                              data[indextr]
                                                                .post_impressions_unique !==
                                                                null &&
                                                              data[indextr]
                                                                .post_impressions_unique !==
                                                                undefined
                                                                ? _c(
                                                                    "Tooltip",
                                                                    {
                                                                      attrs: {
                                                                        text: _vm.$t(
                                                                          "dash.reporting.impression_unique"
                                                                        ),
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                      (" +
                                                                              _vm._s(
                                                                                _vm.numberSpacing(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .post_impressions_unique
                                                                                )
                                                                              ) +
                                                                              ")\n                    "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                          _vm.lastPage
                                                            .network !==
                                                            "instagram" &&
                                                          _vm.lastPage
                                                            .network !==
                                                            "tiktok"
                                                            ? _c(
                                                                "vs-td",
                                                                {
                                                                  staticClass:
                                                                    "t-clc",
                                                                  attrs: {
                                                                    data: data[
                                                                      indextr
                                                                    ]
                                                                      .link_clicks,
                                                                  },
                                                                },
                                                                [
                                                                  data[indextr]
                                                                    .total_clicks
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                    " +
                                                                              _vm._s(
                                                                                _vm.numberSpacing(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .total_clicks
                                                                                )
                                                                              ) +
                                                                              "\n                    "
                                                                          ),
                                                                          _c(
                                                                            "br"
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                    " +
                                                                              _vm._s(
                                                                                `(${_vm.numberSpacing(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .link_clicks
                                                                                )})`
                                                                              ) +
                                                                              "\n                  "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : data[
                                                                        indextr
                                                                      ]
                                                                        .link_clicks !==
                                                                        null &&
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .link_clicks !==
                                                                        undefined
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                    " +
                                                                              _vm._s(
                                                                                _vm.numberSpacing(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .link_clicks
                                                                                )
                                                                              ) +
                                                                              "\n                  "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "Tooltip",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              text: _vm.$t(
                                                                                "dash.table.no.data"
                                                                              ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "N/A"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm.lastPage
                                                            .network !==
                                                            "twitter" &&
                                                          _vm.lastPage
                                                            .network !=
                                                            "pinterest"
                                                            ? _c(
                                                                "vs-td",
                                                                {
                                                                  staticClass:
                                                                    "t-com",
                                                                  attrs: {
                                                                    data: data[
                                                                      indextr
                                                                    ]
                                                                      .comments_count,
                                                                  },
                                                                },
                                                                [
                                                                  data[indextr]
                                                                    .comments_count !==
                                                                    null &&
                                                                  data[indextr]
                                                                    .comments_count !==
                                                                    undefined
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                    " +
                                                                              _vm._s(
                                                                                _vm.numberSpacing(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .comments_count
                                                                                )
                                                                              ) +
                                                                              "\n                  "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "Tooltip",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              text: _vm.$t(
                                                                                "dash.table.no.data"
                                                                              ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "N/A"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          [
                                                            "facebook",
                                                            "linkedin",
                                                            "tiktok",
                                                          ].includes(
                                                            _vm.lastPage.network
                                                          )
                                                            ? _c(
                                                                "vs-td",
                                                                {
                                                                  staticClass:
                                                                    "t-ptg",
                                                                  attrs: {
                                                                    data: data[
                                                                      indextr
                                                                    ]
                                                                      .shares_count,
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "\n                    " +
                                                                        _vm._s(
                                                                          _vm.numberSpacing(
                                                                            data[
                                                                              indextr
                                                                            ]
                                                                              .shares_count
                                                                          )
                                                                        ) +
                                                                        "\n                  "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm.lastPage
                                                            .network !=
                                                          "pinterest"
                                                            ? _c(
                                                                "vs-td",
                                                                {
                                                                  staticClass:
                                                                    "t-eng",
                                                                  attrs: {
                                                                    data:
                                                                      data[
                                                                        indextr
                                                                      ]
                                                                        .reach_engagement ||
                                                                      (data[
                                                                        indextr
                                                                      ]
                                                                        .like_count *
                                                                        100) /
                                                                        data[
                                                                          indextr
                                                                        ]
                                                                          .impressions,
                                                                  },
                                                                },
                                                                [
                                                                  data[indextr]
                                                                    .reach_engagement !==
                                                                  undefined
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                    " +
                                                                              _vm._s(
                                                                                data[
                                                                                  indextr
                                                                                ]
                                                                                  .reach_engagement !==
                                                                                  null
                                                                                  ? data[
                                                                                      indextr
                                                                                    ].reach_engagement.toLocaleString(
                                                                                      _vm
                                                                                        .$i18n
                                                                                        .locale,
                                                                                      {
                                                                                        maximumFractionDigits: 2,
                                                                                      }
                                                                                    )
                                                                                  : (
                                                                                      (data[
                                                                                        indextr
                                                                                      ]
                                                                                        .like_count *
                                                                                        100) /
                                                                                      data[
                                                                                        indextr
                                                                                      ]
                                                                                        .impressions
                                                                                    ).toLocaleString(
                                                                                      _vm
                                                                                        .$i18n
                                                                                        .locale,
                                                                                      {
                                                                                        maximumFractionDigits: 2,
                                                                                      }
                                                                                    )
                                                                              ) +
                                                                              "%\n                  "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "Tooltip",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              text: _vm.$t(
                                                                                "dash.table.no.data"
                                                                              ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "N/A"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                : undefined
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("template", { slot: "header" }, [
                                        _c("div", [
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.reporting.section.videos-list.title"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c(
                                        "template",
                                        { slot: "thead" },
                                        [
                                          _c(
                                            "vs-th",
                                            { staticClass: "t-id" },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.$t(
                                                      "dash.reporting.header_id"
                                                    ),
                                                  },
                                                },
                                                [_c("span")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vs-th",
                                            {
                                              staticClass: "t-date",
                                              attrs: {
                                                sortKey: "created_time",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " \n                " +
                                                  _vm._s(
                                                    _vm.capitalize(
                                                      _vm.$t(
                                                        "dash.table.title.date"
                                                      )
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "sort-th" },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_less\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_more\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "vs-th",
                                            {
                                              staticClass: "t-msg",
                                              attrs: { sortKey: "message" },
                                            },
                                            [
                                              _vm._v(
                                                " \n                " +
                                                  _vm._s(
                                                    _vm.capitalize(
                                                      _vm.$t(
                                                        "dash.table.title.content"
                                                      )
                                                    )
                                                  ) +
                                                  " \n                "
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "sort-th" },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_less\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_more\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "vs-th",
                                            {
                                              staticClass: "t-video_view_count",
                                              attrs: {
                                                sortKey: "video_view_count",
                                              },
                                            },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.$t(
                                                      "dash.reporting.header_video_view_count"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.reporting.video_view_count"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "sort-th" },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_less\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_more\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vs-th",
                                            {
                                              staticClass:
                                                "t-video_time_watched",
                                              attrs: {
                                                sortKey: "video_time_watched",
                                              },
                                            },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.$t(
                                                      "dash.reporting.header_video_time_watched"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.reporting.video_time_watched"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "sort-th" },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_less\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_more\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vs-th",
                                            {
                                              staticClass:
                                                "t-video_time_watched_avg",
                                              attrs: {
                                                sortKey:
                                                  "video_time_watched_avg",
                                              },
                                            },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.$t(
                                                      "dash.reporting.header_video_time_watched_avg"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.reporting.video_time_watched_avg"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "sort-th" },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_less\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_more\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vs-th",
                                            {
                                              staticClass: "t-video_viewer",
                                              attrs: {
                                                sortKey: "video_viewer",
                                              },
                                            },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.$t(
                                                      "dash.reporting.header_video_viewer"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.reporting.video_viewer"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "sort-th" },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_less\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_more\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vs-th",
                                            {
                                              staticClass: "t-imp",
                                              attrs: {
                                                sortKey: "post_impressions",
                                              },
                                            },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.$t(
                                                      "dash.reporting.header_impression"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.reporting.impression"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "sort-th" },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_less\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    expand_more\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm.lastPage.network !==
                                            "instagram" &&
                                          _vm.lastPage.network !== "tiktok"
                                            ? _c(
                                                "vs-th",
                                                {
                                                  staticClass: "t-clc",
                                                  attrs: {
                                                    sortKey: "link_clicks",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: _vm.$t(
                                                          `dash.reporting.header_click${
                                                            _vm.lastPage
                                                              .network ===
                                                            "facebook"
                                                              ? ".fb"
                                                              : ""
                                                          }`
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                `dash.reporting.clic`
                                                              )
                                                            ) +
                                                            " \n                "
                                                        ),
                                                      ]),
                                                      _vm.lastPage.network ===
                                                      "facebook"
                                                        ? _c("span", [
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    `dash.reporting.clic.fb`
                                                                  )
                                                                ) +
                                                                " \n                "
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "sort-th" },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    expand_less\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    expand_more\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.lastPage.network !== "twitter" &&
                                          _vm.lastPage.network !== "pinterest"
                                            ? _c(
                                                "vs-th",
                                                {
                                                  staticClass: "t-com",
                                                  attrs: {
                                                    sortKey: "comments_count",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " \n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.reporting.comment"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "sort-th" },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    expand_less\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    expand_more\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          [
                                            "facebook",
                                            "linkedin",
                                            "tiktok",
                                          ].includes(_vm.lastPage.network)
                                            ? _c(
                                                "vs-th",
                                                {
                                                  staticClass: "t-ptg",
                                                  attrs: {
                                                    sortKey: "shares_count",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: _vm.$t(
                                                          "dash.reporting.header_share"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " \n                " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.label.fb.shares"
                                                              )
                                                            ) +
                                                            "\n                "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "sort-th" },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    expand_less\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    expand_more\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.lastPage.network != "pinterest"
                                            ? _c(
                                                "vs-th",
                                                {
                                                  staticClass: "t-eng",
                                                  attrs: {
                                                    sortKey: "reach_engagement",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: _vm.$t(
                                                          "dash.reporting.header_engamement"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " \n                " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.reporting.engagemment"
                                                              )
                                                            ) +
                                                            " \n                "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "sort-th" },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    expand_less\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    expand_more\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.pageStats &&
                  _vm.pageStats.page &&
                  _vm.pageStats.postsPercentLoader == 100 &&
                  _vm.lastPage.network === "instagram" &&
                  _vm.postList.filter((p) => p.type == "Story").length
                    ? _c("div", { staticClass: "section-graph stories" }, [
                        _c(
                          "div",
                          { staticClass: "posts table-wrapper" },
                          [
                            _c(
                              "vs-table",
                              {
                                staticClass: "content-table",
                                attrs: {
                                  hoverFlat: true,
                                  search: "",
                                  data: _vm.postList.filter(
                                    (p) => p.type == "Story"
                                  ),
                                  "max-items": "20",
                                  pagination: "",
                                  noDataText: _vm.$t("dash.noDataText"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ data }) {
                                        return data
                                          ? _vm._l(
                                              data,
                                              function (tr, indextr) {
                                                return _c(
                                                  "vs-tr",
                                                  {
                                                    key: `data-posts-${indextr}`,
                                                  },
                                                  [
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-id",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .id,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.openLink(
                                                                  data[indextr]
                                                                    .permalink_url ||
                                                                    data[
                                                                      indextr
                                                                    ].permalink
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "#" +
                                                                _vm._s(
                                                                  data[indextr]
                                                                    .id
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-date",
                                                        attrs: {
                                                          data:
                                                            data[indextr]
                                                              .created_time ||
                                                            data[indextr]
                                                              .timestamp,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                data[indextr]
                                                                  .created_time ||
                                                                  data[indextr]
                                                                    .timestamp
                                                              )
                                                            ) +
                                                            "\n                "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-msg",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .message,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cell-msg",
                                                          },
                                                          [
                                                            !data[indextr]
                                                              .attachment_url ||
                                                            data[indextr]
                                                              .attachment_url ===
                                                              ""
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "only-text",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                      " +
                                                                        _vm._s(
                                                                          data[
                                                                            indextr
                                                                          ]
                                                                            .message
                                                                            ? _vm.textTruncat(
                                                                                data[
                                                                                  indextr
                                                                                ].message
                                                                                  .replace(
                                                                                    /[^\s]{25,}/,
                                                                                    ""
                                                                                  )
                                                                                  .replace(
                                                                                    /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                                    ""
                                                                                  ),
                                                                                100
                                                                              )
                                                                            : ""
                                                                        ) +
                                                                        "\n                      "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            data[indextr]
                                                              .attachment_url &&
                                                            data[indextr]
                                                              .attachment_url !==
                                                              ""
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "thumb-wrapper",
                                                                  },
                                                                  [
                                                                    _vm.lastPage
                                                                      .network ==
                                                                      "instagram" &&
                                                                    [
                                                                      "video",
                                                                      "VIDEO",
                                                                    ].includes(
                                                                      data[
                                                                        indextr
                                                                      ].type
                                                                    )
                                                                      ? _c(
                                                                          "video",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: data[
                                                                                  indextr
                                                                                ]
                                                                                  .attachment_url,
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm
                                                                          .lastPage
                                                                          .network ==
                                                                          "instagram" &&
                                                                        [
                                                                          "story",
                                                                          "Story",
                                                                        ].includes(
                                                                          data[
                                                                            indextr
                                                                          ].type
                                                                        ) &&
                                                                        data[
                                                                          indextr
                                                                        ].attachment_url.includes(
                                                                          ".mp4"
                                                                        )
                                                                      ? _c(
                                                                          "video",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: data[
                                                                                  indextr
                                                                                ]
                                                                                  .attachment_url,
                                                                              },
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "img",
                                                                          {
                                                                            ref: `meta-image-${indextr}`,
                                                                            refInFor: true,
                                                                            staticClass:
                                                                              "table-img",
                                                                            attrs:
                                                                              {
                                                                                src: data[
                                                                                  indextr
                                                                                ]
                                                                                  .attachment_url,
                                                                                alt: "Image",
                                                                              },
                                                                            on: {
                                                                              error:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.getMetaOgImage(
                                                                                    data[
                                                                                      indextr
                                                                                    ]
                                                                                      .unshimmed_url,
                                                                                    `meta-image-${indextr}`,
                                                                                    indextr
                                                                                  )
                                                                                },
                                                                            },
                                                                          }
                                                                        ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            data[indextr]
                                                              .attachment_url &&
                                                            data[indextr]
                                                              .attachment_url !==
                                                              ""
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "txt-wrapper",
                                                                  },
                                                                  [
                                                                    data[
                                                                      indextr
                                                                    ].message.replace(
                                                                      /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                      ""
                                                                    )
                                                                      ? _c(
                                                                          "p",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                        " +
                                                                                _vm._s(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .message
                                                                                    ? _vm.textTruncat(
                                                                                        data[
                                                                                          indextr
                                                                                        ].message
                                                                                          .replace(
                                                                                            /[^\s]{25,}/,
                                                                                            ""
                                                                                          )
                                                                                          .replace(
                                                                                            /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                                            ""
                                                                                          ),
                                                                                        100
                                                                                      )
                                                                                    : ""
                                                                                ) +
                                                                                "\n                      "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : data[
                                                                          indextr
                                                                        ]
                                                                          .unshimmed_url
                                                                      ? _c(
                                                                          "p",
                                                                          {
                                                                            ref: `meta-title-${indextr}`,
                                                                            refInFor: true,
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.getMetaOgTitle(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .unshimmed_url,
                                                                                  `meta-title-${indextr}`,
                                                                                  indextr
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-post_impressions",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .post_impressions,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .post_impressions
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-replies",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .replies,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .replies
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-shares",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .shares,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .shares
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-total_interactions",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .total_interactions,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .total_interactions
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-navigation",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .navigation,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .navigation
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-profile_visits",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .profile_visits,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .profile_visits
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-profile_activity",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .profile_activity,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .profile_activity
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-follows",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .follows,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .follows
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          : undefined
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c("div", [
                                    _c("h3", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.reporting.section.story-list.title"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c(
                                  "template",
                                  { slot: "thead" },
                                  [
                                    _c(
                                      "vs-th",
                                      { staticClass: "t-id" },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_id"
                                              ),
                                            },
                                          },
                                          [_c("span")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-date",
                                        attrs: { sortKey: "created_time" },
                                      },
                                      [
                                        _vm._v(
                                          " \n                " +
                                            _vm._s(
                                              _vm.capitalize(
                                                _vm.$t("dash.table.title.date")
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-msg",
                                        attrs: { sortKey: "message" },
                                      },
                                      [
                                        _vm._v(
                                          " \n                " +
                                            _vm._s(
                                              _vm.capitalize(
                                                _vm.$t(
                                                  "dash.table.title.content"
                                                )
                                              )
                                            ) +
                                            " \n                "
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-post_impressions",
                                        attrs: { sortKey: "post_impressions" },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_story_impressions"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.impressions"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-replies",
                                        attrs: { sortKey: "replies" },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_story_replies"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.replies"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-shares",
                                        attrs: { sortKey: "shares" },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_story_shares"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.shares"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-total_interactions",
                                        attrs: {
                                          sortKey: "total_interactions",
                                        },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_story_total_interactions"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.total_interactions"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-navigation",
                                        attrs: { sortKey: "navigation" },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_story_navigation"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.navigation"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-profile_visits",
                                        attrs: { sortKey: "profile_visits" },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_story_profile_visits"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.profile_visits"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-profile_activity",
                                        attrs: { sortKey: "profile_activity" },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_story_profile_activity"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.profile_activity"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-follows",
                                        attrs: { sortKey: "follows" },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_story_follows"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.follows"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.pageStats &&
                  _vm.pageStats.page &&
                  _vm.pageStats.postsPercentLoader == 100 &&
                  _vm.lastPage.network === "facebook" &&
                  !_vm.lastPage.isGroup &&
                  _vm.graphData.filter((g) =>
                    [
                      "video_views",
                      "video_views_paid",
                      "video_views_organic",
                      "video_views_autoplayed",
                      "video_views_click_to_play",
                      "video_views_unique",
                      "video_repeat_views",
                      "video_complete_views_30s",
                      "video_view_time",
                    ].includes(g.name)
                  ).length > 1
                    ? _c("div", { staticClass: "section-graph videos" }, [
                        _c("div", { staticClass: "section-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("dash.reporting.section.videos.title")
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "section-subtitle" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("dash.reporting.section.videos.subtitle")
                            )
                          ),
                        ]),
                        _c(
                          "div",
                          [
                            _c("div", { staticClass: "informations" }, [
                              _vm.pageStats && !_vm.lastPage.isGroup
                                ? _c(
                                    "div",
                                    { staticClass: "main-numbers" },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-eye",
                                      }),
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("dash.label.fb.video_views")
                                          )
                                        ),
                                      ]),
                                      _c("img", {
                                        staticClass: "icon imp-ico",
                                        attrs: {
                                          src: require("../../../assets/img/reporting_icons/impression.svg"),
                                          alt: "",
                                        },
                                      }),
                                      _vm.graphData.find(
                                        (g) => g.name == "video_views"
                                      ) === null
                                        ? _c("p", [_vm._v("N/A")])
                                        : _vm.graphData
                                            .find(
                                              (g) => g.name == "video_views"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name == "video_views"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("M")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm.graphData
                                            .find(
                                              (g) => g.name == "video_views"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name == "video_views"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("k")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name == "video_views"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm.activeReportingV2 &&
                                      !_vm.pageStats.page.previous_period &&
                                      _vm.lastPage.network == "facebook"
                                        ? _c(
                                            "div",
                                            { staticClass: "compare wait" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/status-waiting.gif"),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm.pageStats.page.previous_period &&
                                          _vm.pageStats.page.previous_period
                                            .page_video_views
                                        ? _c(
                                            "div",
                                            { staticClass: "compare" },
                                            [
                                              _vm.graphData
                                                .find(
                                                  (g) => g.name == "video_views"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) <
                                              _vm.pageStats.page.previous_period.page_video_views
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_down",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "negative",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "-" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  100 -
                                                                    (_vm.graphData
                                                                      .find(
                                                                        (g) =>
                                                                          g.name ==
                                                                          "video_views"
                                                                      )
                                                                      .data.reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) /
                                                                      _vm.pageStats.page.previous_period.page_video_views
                                                                        .map(
                                                                          (v) =>
                                                                            v.total
                                                                        )
                                                                        .reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        )) *
                                                                      100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right negative",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) => g.name == "video_views"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) != 0 &&
                                              _vm.graphData
                                                .find(
                                                  (g) => g.name == "video_views"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) ==
                                                _vm.pageStats.page.previous_period.page_video_views
                                                  .map((v) => v.total)
                                                  .reduce(
                                                    (prev, curr) => prev + curr
                                                  )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_flat",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) => g.name == "video_views"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) >
                                              _vm.pageStats.page.previous_period.page_video_views
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_up",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm.pageStats.page.previous_period.page_video_views
                                                        .map((v) => v.total)
                                                        .reduce(
                                                          (prev, curr) =>
                                                            prev + curr
                                                        ) > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "positive",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    _vm.formatPercentageChange(
                                                                      (_vm.graphData
                                                                        .find(
                                                                          (g) =>
                                                                            g.name ==
                                                                            "video_views"
                                                                        )
                                                                        .data.reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        ) /
                                                                        _vm.pageStats.page.previous_period.page_video_views
                                                                          .map(
                                                                            (
                                                                              v
                                                                            ) =>
                                                                              v.total
                                                                          )
                                                                          .reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          )) *
                                                                        100 -
                                                                        100
                                                                    )
                                                                  ) +
                                                                  "%"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right positive",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(-45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : !_vm.lastPage.isGroup
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.pageStats && !_vm.lastPage.isGroup
                                ? _c(
                                    "div",
                                    { staticClass: "main-numbers" },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-eye",
                                      }),
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.label.fb.video_views_paid"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("img", {
                                        staticClass: "icon imp-ico",
                                        attrs: {
                                          src: require("../../../assets/img/reporting_icons/impression.svg"),
                                          alt: "",
                                        },
                                      }),
                                      _vm.graphData.find(
                                        (g) => g.name == "video_views_paid"
                                      ) === null
                                        ? _c("p", [_vm._v("N/A")])
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name == "video_views_paid"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_paid"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_paid"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("M")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name == "video_views_paid"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_paid"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_paid"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("k")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_paid"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm.activeReportingV2 &&
                                      !_vm.pageStats.page.previous_period &&
                                      _vm.lastPage.network == "facebook"
                                        ? _c(
                                            "div",
                                            { staticClass: "compare wait" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/status-waiting.gif"),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm.pageStats.page.previous_period &&
                                          _vm.pageStats.page.previous_period
                                            .page_video_views_paid
                                        ? _c(
                                            "div",
                                            { staticClass: "compare" },
                                            [
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name == "video_views_paid"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) <
                                              _vm.pageStats.page.previous_period.page_video_views_paid
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_down",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_paid
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "negative",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "-" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  100 -
                                                                    (_vm.graphData
                                                                      .find(
                                                                        (g) =>
                                                                          g.name ==
                                                                          "video_views_paid"
                                                                      )
                                                                      .data.reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) /
                                                                      _vm.pageStats.page.previous_period.page_video_views_paid
                                                                        .map(
                                                                          (v) =>
                                                                            v.total
                                                                        )
                                                                        .reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        )) *
                                                                      100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right negative",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name == "video_views_paid"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) != 0 &&
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name == "video_views_paid"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) ==
                                                _vm.pageStats.page.previous_period.page_video_views_paid
                                                  .map((v) => v.total)
                                                  .reduce(
                                                    (prev, curr) => prev + curr
                                                  )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_flat",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_paid
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name == "video_views_paid"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) >
                                              _vm.pageStats.page.previous_period.page_video_views_paid
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_up",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_paid
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm.pageStats.page.previous_period.page_video_views_paid
                                                        .map((v) => v.total)
                                                        .reduce(
                                                          (prev, curr) =>
                                                            prev + curr
                                                        ) > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "positive",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    _vm.formatPercentageChange(
                                                                      (_vm.graphData
                                                                        .find(
                                                                          (g) =>
                                                                            g.name ==
                                                                            "video_views_paid"
                                                                        )
                                                                        .data.reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        ) /
                                                                        _vm.pageStats.page.previous_period.page_video_views_paid
                                                                          .map(
                                                                            (
                                                                              v
                                                                            ) =>
                                                                              v.total
                                                                          )
                                                                          .reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          )) *
                                                                        100 -
                                                                        100
                                                                    )
                                                                  ) +
                                                                  "%"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right positive",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(-45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : !_vm.lastPage.isGroup
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.pageStats && !_vm.lastPage.isGroup
                                ? _c(
                                    "div",
                                    { staticClass: "main-numbers" },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-eye",
                                      }),
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.label.fb.video_views_organic"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("img", {
                                        staticClass: "icon imp-ico",
                                        attrs: {
                                          src: require("../../../assets/img/reporting_icons/impression.svg"),
                                          alt: "",
                                        },
                                      }),
                                      _vm.graphData.find(
                                        (g) => g.name == "video_views_organic"
                                      ) === null
                                        ? _c("p", [_vm._v("N/A")])
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name == "video_views_organic"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_organic"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_organic"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("M")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name == "video_views_organic"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_organic"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_organic"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("k")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_organic"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm.activeReportingV2 &&
                                      !_vm.pageStats.page.previous_period &&
                                      _vm.lastPage.network == "facebook"
                                        ? _c(
                                            "div",
                                            { staticClass: "compare wait" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/status-waiting.gif"),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm.pageStats.page.previous_period &&
                                          _vm.pageStats.page.previous_period
                                            .page_video_views_organic
                                        ? _c(
                                            "div",
                                            { staticClass: "compare" },
                                            [
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_organic"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) <
                                              _vm.pageStats.page.previous_period.page_video_views_organic
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_down",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_organic
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "negative",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "-" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  100 -
                                                                    (_vm.graphData
                                                                      .find(
                                                                        (g) =>
                                                                          g.name ==
                                                                          "video_views_organic"
                                                                      )
                                                                      .data.reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) /
                                                                      _vm.pageStats.page.previous_period.page_video_views_organic
                                                                        .map(
                                                                          (v) =>
                                                                            v.total
                                                                        )
                                                                        .reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        )) *
                                                                      100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right negative",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_organic"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) != 0 &&
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_organic"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) ==
                                                _vm.pageStats.page.previous_period.page_video_views_organic
                                                  .map((v) => v.total)
                                                  .reduce(
                                                    (prev, curr) => prev + curr
                                                  )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_flat",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_organic
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_organic"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) >
                                              _vm.pageStats.page.previous_period.page_video_views_organic
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_up",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_organic
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm.pageStats.page.previous_period.page_video_views_organic
                                                        .map((v) => v.total)
                                                        .reduce(
                                                          (prev, curr) =>
                                                            prev + curr
                                                        ) > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "positive",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    _vm.formatPercentageChange(
                                                                      (_vm.graphData
                                                                        .find(
                                                                          (g) =>
                                                                            g.name ==
                                                                            "video_views_organic"
                                                                        )
                                                                        .data.reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        ) /
                                                                        _vm.pageStats.page.previous_period.page_video_views_organic
                                                                          .map(
                                                                            (
                                                                              v
                                                                            ) =>
                                                                              v.total
                                                                          )
                                                                          .reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          )) *
                                                                        100 -
                                                                        100
                                                                    )
                                                                  ) +
                                                                  "%"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right positive",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(-45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : !_vm.lastPage.isGroup
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.pageStats && !_vm.lastPage.isGroup
                                ? _c(
                                    "div",
                                    { staticClass: "main-numbers" },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-eye",
                                      }),
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.label.fb.video_views_autoplayed"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("img", {
                                        staticClass: "icon imp-ico",
                                        attrs: {
                                          src: require("../../../assets/img/reporting_icons/impression.svg"),
                                          alt: "",
                                        },
                                      }),
                                      _vm.graphData.find(
                                        (g) =>
                                          g.name == "video_views_autoplayed"
                                      ) === null
                                        ? _c("p", [_vm._v("N/A")])
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name ==
                                                "video_views_autoplayed"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_autoplayed"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_autoplayed"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("M")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name ==
                                                "video_views_autoplayed"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_autoplayed"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_autoplayed"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("k")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_autoplayed"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm.activeReportingV2 &&
                                      !_vm.pageStats.page.previous_period &&
                                      _vm.lastPage.network == "facebook"
                                        ? _c(
                                            "div",
                                            { staticClass: "compare wait" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/status-waiting.gif"),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm.pageStats.page.previous_period &&
                                          _vm.pageStats.page.previous_period
                                            .page_video_views_autoplayed
                                        ? _c(
                                            "div",
                                            { staticClass: "compare" },
                                            [
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_autoplayed"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) <
                                              _vm.pageStats.page.previous_period.page_video_views_autoplayed
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_down",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_autoplayed
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "negative",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "-" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  100 -
                                                                    (_vm.graphData
                                                                      .find(
                                                                        (g) =>
                                                                          g.name ==
                                                                          "video_views_autoplayed"
                                                                      )
                                                                      .data.reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) /
                                                                      _vm.pageStats.page.previous_period.page_video_views_autoplayed
                                                                        .map(
                                                                          (v) =>
                                                                            v.total
                                                                        )
                                                                        .reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        )) *
                                                                      100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right negative",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_autoplayed"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) != 0 &&
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_autoplayed"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) ==
                                                _vm.pageStats.page.previous_period.page_video_views_autoplayed
                                                  .map((v) => v.total)
                                                  .reduce(
                                                    (prev, curr) => prev + curr
                                                  )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_flat",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_autoplayed
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_autoplayed"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) >
                                              _vm.pageStats.page.previous_period.page_video_views_autoplayed
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_up",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_autoplayed
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm.pageStats.page.previous_period.page_video_views_autoplayed
                                                        .map((v) => v.total)
                                                        .reduce(
                                                          (prev, curr) =>
                                                            prev + curr
                                                        )
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "positive",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    _vm.formatPercentageChange(
                                                                      (_vm.graphData
                                                                        .find(
                                                                          (g) =>
                                                                            g.name ==
                                                                            "video_views_autoplayed"
                                                                        )
                                                                        .data.reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        ) /
                                                                        _vm.pageStats.page.previous_period.page_video_views_autoplayed
                                                                          .map(
                                                                            (
                                                                              v
                                                                            ) =>
                                                                              v.total
                                                                          )
                                                                          .reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          )) *
                                                                        100 -
                                                                        100
                                                                    )
                                                                  ) +
                                                                  "%"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right positive",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(-45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : !_vm.lastPage.isGroup
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.pageStats && !_vm.lastPage.isGroup
                                ? _c(
                                    "div",
                                    { staticClass: "main-numbers" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-solid fa-arrow-pointer",
                                      }),
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.label.fb.video_views_click_to_play"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("img", {
                                        staticClass: "icon imp-ico",
                                        attrs: {
                                          src: require("../../../assets/img/reporting_icons/impression.svg"),
                                          alt: "",
                                        },
                                      }),
                                      _vm.graphData.find(
                                        (g) =>
                                          g.name == "video_views_click_to_play"
                                      ) === null
                                        ? _c("p", [_vm._v("N/A")])
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name ==
                                                "video_views_click_to_play"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_click_to_play"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_click_to_play"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("M")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name ==
                                                "video_views_click_to_play"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_click_to_play"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_click_to_play"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("k")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_click_to_play"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm.activeReportingV2 &&
                                      !_vm.pageStats.page.previous_period &&
                                      _vm.lastPage.network == "facebook"
                                        ? _c(
                                            "div",
                                            { staticClass: "compare wait" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/status-waiting.gif"),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm.pageStats.page.previous_period &&
                                          _vm.pageStats.page.previous_period
                                            .page_video_views_click_to_play
                                        ? _c(
                                            "div",
                                            { staticClass: "compare" },
                                            [
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_click_to_play"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) <
                                              _vm.pageStats.page.previous_period.page_video_views_click_to_play
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_down",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_click_to_play
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "negative",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "-" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  100 -
                                                                    (_vm.graphData
                                                                      .find(
                                                                        (g) =>
                                                                          g.name ==
                                                                          "video_views_click_to_play"
                                                                      )
                                                                      .data.reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) /
                                                                      _vm.pageStats.page.previous_period.page_video_views_click_to_play
                                                                        .map(
                                                                          (v) =>
                                                                            v.total
                                                                        )
                                                                        .reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        )) *
                                                                      100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right negative",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_click_to_play"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) != 0 &&
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_click_to_play"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) ==
                                                _vm.pageStats.page.previous_period.page_video_views_click_to_play
                                                  .map((v) => v.total)
                                                  .reduce(
                                                    (prev, curr) => prev + curr
                                                  )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_flat",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_click_to_play
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_click_to_play"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) >
                                              _vm.pageStats.page.previous_period.page_video_views_click_to_play
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_up",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_click_to_play
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm.pageStats.page.previous_period.page_video_views_click_to_play
                                                        .map((v) => v.total)
                                                        .reduce(
                                                          (prev, curr) =>
                                                            prev + curr
                                                        ) > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "positive",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    _vm.formatPercentageChange(
                                                                      (_vm.graphData
                                                                        .find(
                                                                          (g) =>
                                                                            g.name ==
                                                                            "video_views_click_to_play"
                                                                        )
                                                                        .data.reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        ) /
                                                                        _vm.pageStats.page.previous_period.page_video_views_click_to_play
                                                                          .map(
                                                                            (
                                                                              v
                                                                            ) =>
                                                                              v.total
                                                                          )
                                                                          .reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          )) *
                                                                        100 -
                                                                        100
                                                                    )
                                                                  ) +
                                                                  "%"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right positive",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(-45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : !_vm.lastPage.isGroup
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.pageStats && !_vm.lastPage.isGroup
                                ? _c(
                                    "div",
                                    { staticClass: "main-numbers" },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-repeat",
                                      }),
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.label.fb.video_views_unique"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("img", {
                                        staticClass: "icon imp-ico",
                                        attrs: {
                                          src: require("../../../assets/img/reporting_icons/impression.svg"),
                                          alt: "",
                                        },
                                      }),
                                      _vm.graphData.find(
                                        (g) => g.name == "video_views_unique"
                                      ) === null
                                        ? _c("p", [_vm._v("N/A")])
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name == "video_views_unique"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_unique"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_unique"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("M")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name == "video_views_unique"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_unique"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_views_unique"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("k")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_views_unique"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm.activeReportingV2 &&
                                      !_vm.pageStats.page.previous_period &&
                                      _vm.lastPage.network == "facebook"
                                        ? _c(
                                            "div",
                                            { staticClass: "compare wait" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/status-waiting.gif"),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm.pageStats.page.previous_period &&
                                          _vm.pageStats.page.previous_period
                                            .page_video_views_unique
                                        ? _c(
                                            "div",
                                            { staticClass: "compare" },
                                            [
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_unique"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) <
                                              _vm.pageStats.page.previous_period.page_video_views_unique
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_down",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_unique
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "negative",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "-" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  100 -
                                                                    (_vm.graphData
                                                                      .find(
                                                                        (g) =>
                                                                          g.name ==
                                                                          "video_views_unique"
                                                                      )
                                                                      .data.reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) /
                                                                      _vm.pageStats.page.previous_period.page_video_views_unique
                                                                        .map(
                                                                          (v) =>
                                                                            v.total
                                                                        )
                                                                        .reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        )) *
                                                                      100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right negative",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_unique"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) != 0 &&
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_unique"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) ==
                                                _vm.pageStats.page.previous_period.page_video_views_unique
                                                  .map((v) => v.total)
                                                  .reduce(
                                                    (prev, curr) => prev + curr
                                                  )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_flat",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_unique
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_views_unique"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) >
                                              _vm.pageStats.page.previous_period.page_video_views_unique
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_up",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_views_unique
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm.pageStats.page.previous_period.page_video_views_unique
                                                        .map((v) => v.total)
                                                        .reduce(
                                                          (prev, curr) =>
                                                            prev + curr
                                                        ) > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "positive",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    _vm.formatPercentageChange(
                                                                      (_vm.graphData
                                                                        .find(
                                                                          (g) =>
                                                                            g.name ==
                                                                            "video_views_unique"
                                                                        )
                                                                        .data.reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        ) /
                                                                        _vm.pageStats.page.previous_period.page_video_views_unique
                                                                          .map(
                                                                            (
                                                                              v
                                                                            ) =>
                                                                              v.total
                                                                          )
                                                                          .reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          )) *
                                                                        100 -
                                                                        100
                                                                    )
                                                                  ) +
                                                                  "%"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right positive",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(-45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : !_vm.lastPage.isGroup
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.pageStats && !_vm.lastPage.isGroup
                                ? _c(
                                    "div",
                                    { staticClass: "main-numbers" },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-repeat",
                                      }),
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.label.fb.video_repeat_views"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("img", {
                                        staticClass: "icon imp-ico",
                                        attrs: {
                                          src: require("../../../assets/img/reporting_icons/impression.svg"),
                                          alt: "",
                                        },
                                      }),
                                      _vm.graphData.find(
                                        (g) => g.name == "video_repeat_views"
                                      ) === null
                                        ? _c("p", [_vm._v("N/A")])
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name == "video_repeat_views"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_repeat_views"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_repeat_views"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("M")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name == "video_repeat_views"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_repeat_views"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_repeat_views"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("k")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_repeat_views"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm.activeReportingV2 &&
                                      !_vm.pageStats.page.previous_period &&
                                      _vm.lastPage.network == "facebook"
                                        ? _c(
                                            "div",
                                            { staticClass: "compare wait" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/status-waiting.gif"),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm.pageStats.page.previous_period &&
                                          _vm.pageStats.page.previous_period
                                            .page_video_repeat_views
                                        ? _c(
                                            "div",
                                            { staticClass: "compare" },
                                            [
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_repeat_views"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) <
                                              _vm.pageStats.page.previous_period.page_video_repeat_views
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_down",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_repeat_views
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "negative",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "-" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  100 -
                                                                    (_vm.graphData
                                                                      .find(
                                                                        (g) =>
                                                                          g.name ==
                                                                          "video_repeat_views"
                                                                      )
                                                                      .data.reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) /
                                                                      _vm.pageStats.page.previous_period.page_video_repeat_views
                                                                        .map(
                                                                          (v) =>
                                                                            v.total
                                                                        )
                                                                        .reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        )) *
                                                                      100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right negative",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_repeat_views"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) != 0 &&
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_repeat_views"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) ==
                                                _vm.pageStats.page.previous_period.page_video_repeat_views
                                                  .map((v) => v.total)
                                                  .reduce(
                                                    (prev, curr) => prev + curr
                                                  )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_flat",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_repeat_views
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_repeat_views"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) >
                                              _vm.pageStats.page.previous_period.page_video_repeat_views
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_up",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_repeat_views
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm.pageStats.page.previous_period.page_video_repeat_views
                                                        .map((v) => v.total)
                                                        .reduce(
                                                          (prev, curr) =>
                                                            prev + curr
                                                        ) > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "positive",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    _vm.formatPercentageChange(
                                                                      (_vm.graphData
                                                                        .find(
                                                                          (g) =>
                                                                            g.name ==
                                                                            "video_repeat_views"
                                                                        )
                                                                        .data.reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        ) /
                                                                        _vm.pageStats.page.previous_period.page_video_repeat_views
                                                                          .map(
                                                                            (
                                                                              v
                                                                            ) =>
                                                                              v.total
                                                                          )
                                                                          .reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          )) *
                                                                        100 -
                                                                        100
                                                                    )
                                                                  ) +
                                                                  "%"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right positive",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(-45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : !_vm.lastPage.isGroup
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.pageStats && !_vm.lastPage.isGroup
                                ? _c(
                                    "div",
                                    { staticClass: "main-numbers" },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-repeat",
                                      }),
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.label.fb.video_complete_views_30s"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("img", {
                                        staticClass: "icon imp-ico",
                                        attrs: {
                                          src: require("../../../assets/img/reporting_icons/impression.svg"),
                                          alt: "",
                                        },
                                      }),
                                      _vm.graphData.find(
                                        (g) =>
                                          g.name == "video_complete_views_30s"
                                      ) === null
                                        ? _c("p", [_vm._v("N/A")])
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name ==
                                                "video_complete_views_30s"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_complete_views_30s"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_complete_views_30s"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("M")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm.graphData
                                            .find(
                                              (g) =>
                                                g.name ==
                                                "video_complete_views_30s"
                                            )
                                            .data.reduce(
                                              (prev, curr) => prev + curr
                                            ) >= 1000
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_complete_views_30s"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "big-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.numberSpacing(
                                                        Number(
                                                          _vm.graphData
                                                            .find(
                                                              (g) =>
                                                                g.name ==
                                                                "video_complete_views_30s"
                                                            )
                                                            .data.reduce(
                                                              (prev, curr) =>
                                                                prev + curr
                                                            ) / 1000
                                                        ).toLocaleString(
                                                          _vm.$i18n.locale,
                                                          {
                                                            maximumFractionDigits: 1,
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "percent" },
                                                    [_vm._v("k")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.numberSpacing(
                                                  _vm.graphData
                                                    .find(
                                                      (g) =>
                                                        g.name ==
                                                        "video_complete_views_30s"
                                                    )
                                                    .data.reduce(
                                                      (prev, curr) =>
                                                        prev + curr
                                                    )
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm.activeReportingV2 &&
                                      !_vm.pageStats.page.previous_period &&
                                      _vm.lastPage.network == "facebook"
                                        ? _c(
                                            "div",
                                            { staticClass: "compare wait" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/status-waiting.gif"),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm.pageStats.page.previous_period &&
                                          _vm.pageStats.page.previous_period
                                            .page_video_complete_views_30s
                                        ? _c(
                                            "div",
                                            { staticClass: "compare" },
                                            [
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_complete_views_30s"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) <
                                              _vm.pageStats.page.previous_period.page_video_complete_views_30s
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_down",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_complete_views_30s
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "negative",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "-" +
                                                              _vm._s(
                                                                _vm.formatPercentageChange(
                                                                  100 -
                                                                    (_vm.graphData
                                                                      .find(
                                                                        (g) =>
                                                                          g.name ==
                                                                          "video_complete_views_30s"
                                                                      )
                                                                      .data.reduce(
                                                                        (
                                                                          prev,
                                                                          curr
                                                                        ) =>
                                                                          prev +
                                                                          curr
                                                                      ) /
                                                                      _vm.pageStats.page.previous_period.page_video_complete_views_30s
                                                                        .map(
                                                                          (v) =>
                                                                            v.total
                                                                        )
                                                                        .reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        )) *
                                                                      100
                                                                )
                                                              ) +
                                                              "%"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right negative",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_complete_views_30s"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) != 0 &&
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_complete_views_30s"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) ==
                                                _vm.pageStats.page.previous_period.page_video_complete_views_30s
                                                  .map((v) => v.total)
                                                  .reduce(
                                                    (prev, curr) => prev + curr
                                                  )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_flat",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_complete_views_30s
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.graphData
                                                .find(
                                                  (g) =>
                                                    g.name ==
                                                    "video_complete_views_30s"
                                                )
                                                .data.reduce(
                                                  (prev, curr) => prev + curr
                                                ) >
                                              _vm.pageStats.page.previous_period.page_video_complete_views_30s
                                                .map((v) => v.total)
                                                .reduce(
                                                  (prev, curr) => prev + curr
                                                )
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass:
                                                        "trending_up",
                                                      attrs: {
                                                        text:
                                                          _vm.$t(
                                                            "dash.reporting.previous_period"
                                                          ) +
                                                          " (" +
                                                          _vm.$t(
                                                            "dash.reporting.from"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .start,
                                                            false
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "dash.reporting.to"
                                                          ) +
                                                          " " +
                                                          _vm.formatDate(
                                                            _vm
                                                              .getPreviousPeriod
                                                              .end,
                                                            false
                                                          ) +
                                                          ") : " +
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page.previous_period.page_video_complete_views_30s
                                                              .map(
                                                                (v) => v.total
                                                              )
                                                              .reduce(
                                                                (prev, curr) =>
                                                                  prev + curr
                                                              )
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm.pageStats.page.previous_period.page_video_complete_views_30s
                                                        .map((v) => v.total)
                                                        .reduce(
                                                          (prev, curr) =>
                                                            prev + curr
                                                        ) > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "positive",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    _vm.formatPercentageChange(
                                                                      (_vm.graphData
                                                                        .find(
                                                                          (g) =>
                                                                            g.name ==
                                                                            "video_complete_views_30s"
                                                                        )
                                                                        .data.reduce(
                                                                          (
                                                                            prev,
                                                                            curr
                                                                          ) =>
                                                                            prev +
                                                                            curr
                                                                        ) /
                                                                        _vm.pageStats.page.previous_period.page_video_complete_views_30s
                                                                          .map(
                                                                            (
                                                                              v
                                                                            ) =>
                                                                              v.total
                                                                          )
                                                                          .reduce(
                                                                            (
                                                                              prev,
                                                                              curr
                                                                            ) =>
                                                                              prev +
                                                                              curr
                                                                          )) *
                                                                        100 -
                                                                        100
                                                                    )
                                                                  ) +
                                                                  "%"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("trending_up")]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right positive",
                                                        staticStyle: {
                                                          transform:
                                                            "rotate(-45deg)",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : !_vm.lastPage.isGroup
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/content_loader/reporting_info_numbers.svg"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                            ]),
                            _c("componentGraph", {
                              key: "videos",
                              staticClass: "graph",
                              attrs: {
                                data: _vm.graphData.filter((g) =>
                                  [
                                    "video_views",
                                    "video_views_paid",
                                    "video_views_organic",
                                    "video_views_autoplayed",
                                    "video_views_click_to_play",
                                    "video_views_unique",
                                    "video_repeat_views",
                                    "video_complete_views_30s",
                                    "video_view_time",
                                  ].includes(g.name)
                                ),
                                state: _vm.graphShowedVideos,
                                labels: _vm.graphLabels,
                                lang: _vm.$i18n.locale,
                                section: "videos",
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "graph-choice" },
                              _vm._l(
                                _vm.graphNetwork.filter((g) =>
                                  [
                                    "video_views",
                                    "video_views_paid",
                                    "video_views_organic",
                                    "video_views_autoplayed",
                                    "video_views_click_to_play",
                                    "video_views_unique",
                                    "video_repeat_views",
                                    "video_complete_views_30s",
                                    "video_view_time",
                                  ].includes(g.name)
                                ),
                                function (item, idx) {
                                  return _c(
                                    "Tooltip",
                                    {
                                      key: `graph-select-impressions-${idx}`,
                                      attrs: {
                                        text: item.description,
                                        position: "bottom",
                                      },
                                    },
                                    [
                                      _c(
                                        "vs-checkbox",
                                        {
                                          staticClass: "check",
                                          attrs: {
                                            color: item.color,
                                            "vs-value": `${idx}`,
                                          },
                                          model: {
                                            value: _vm.graphShowedVideos,
                                            callback: function ($$v) {
                                              _vm.graphShowedVideos = $$v
                                            },
                                            expression: "graphShowedVideos",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(item.text) +
                                              " \n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "posts table-wrapper" },
                          [
                            _c(
                              "vs-table",
                              {
                                staticClass: "content-table",
                                attrs: {
                                  hoverFlat: true,
                                  search: "",
                                  data: _vm.postList.filter(
                                    (p) => p.type == "video"
                                  ),
                                  "max-items": "20",
                                  pagination: "",
                                  noDataText: _vm.$t("dash.noDataText"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ data }) {
                                        return data
                                          ? _vm._l(
                                              data,
                                              function (tr, indextr) {
                                                return _c(
                                                  "vs-tr",
                                                  {
                                                    key: `data-posts-${indextr}`,
                                                  },
                                                  [
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-id",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .id,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.openLink(
                                                                  data[indextr]
                                                                    .permalink_url ||
                                                                    data[
                                                                      indextr
                                                                    ].permalink
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "#" +
                                                                _vm._s(
                                                                  data[indextr]
                                                                    .id
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-date",
                                                        attrs: {
                                                          data:
                                                            data[indextr]
                                                              .created_time ||
                                                            data[indextr]
                                                              .timestamp,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                data[indextr]
                                                                  .created_time ||
                                                                  data[indextr]
                                                                    .timestamp
                                                              )
                                                            ) +
                                                            "\n                "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass: "t-msg",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .message,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cell-msg",
                                                          },
                                                          [
                                                            !data[indextr]
                                                              .attachment_url ||
                                                            data[indextr]
                                                              .attachment_url ===
                                                              ""
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "only-text",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                      " +
                                                                        _vm._s(
                                                                          data[
                                                                            indextr
                                                                          ]
                                                                            .message
                                                                            ? _vm.textTruncat(
                                                                                data[
                                                                                  indextr
                                                                                ].message
                                                                                  .replace(
                                                                                    /[^\s]{25,}/,
                                                                                    ""
                                                                                  )
                                                                                  .replace(
                                                                                    /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                                    ""
                                                                                  ),
                                                                                100
                                                                              )
                                                                            : ""
                                                                        ) +
                                                                        "\n                      "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            data[indextr]
                                                              .attachment_url &&
                                                            data[indextr]
                                                              .attachment_url !==
                                                              ""
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "thumb-wrapper",
                                                                  },
                                                                  [
                                                                    _vm.lastPage
                                                                      .network ==
                                                                      "instagram" &&
                                                                    [
                                                                      "video",
                                                                      "VIDEO",
                                                                    ].includes(
                                                                      data[
                                                                        indextr
                                                                      ].type
                                                                    )
                                                                      ? _c(
                                                                          "video",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: data[
                                                                                  indextr
                                                                                ]
                                                                                  .attachment_url,
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm
                                                                          .lastPage
                                                                          .network ==
                                                                          "instagram" &&
                                                                        [
                                                                          "story",
                                                                          "Story",
                                                                        ].includes(
                                                                          data[
                                                                            indextr
                                                                          ].type
                                                                        ) &&
                                                                        data[
                                                                          indextr
                                                                        ].attachment_url.includes(
                                                                          ".mp4"
                                                                        )
                                                                      ? _c(
                                                                          "video",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: data[
                                                                                  indextr
                                                                                ]
                                                                                  .attachment_url,
                                                                              },
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "img",
                                                                          {
                                                                            ref: `meta-image-${indextr}`,
                                                                            refInFor: true,
                                                                            staticClass:
                                                                              "table-img",
                                                                            attrs:
                                                                              {
                                                                                src: data[
                                                                                  indextr
                                                                                ]
                                                                                  .attachment_url,
                                                                                alt: "Image",
                                                                              },
                                                                            on: {
                                                                              error:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.getMetaOgImage(
                                                                                    data[
                                                                                      indextr
                                                                                    ]
                                                                                      .unshimmed_url,
                                                                                    `meta-image-${indextr}`,
                                                                                    indextr
                                                                                  )
                                                                                },
                                                                            },
                                                                          }
                                                                        ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            data[indextr]
                                                              .attachment_url &&
                                                            data[indextr]
                                                              .attachment_url !==
                                                              ""
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "txt-wrapper",
                                                                  },
                                                                  [
                                                                    data[
                                                                      indextr
                                                                    ].message.replace(
                                                                      /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                      ""
                                                                    )
                                                                      ? _c(
                                                                          "p",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                        " +
                                                                                _vm._s(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .message
                                                                                    ? _vm.textTruncat(
                                                                                        data[
                                                                                          indextr
                                                                                        ].message
                                                                                          .replace(
                                                                                            /[^\s]{25,}/,
                                                                                            ""
                                                                                          )
                                                                                          .replace(
                                                                                            /[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                                                                            ""
                                                                                          ),
                                                                                        100
                                                                                      )
                                                                                    : ""
                                                                                ) +
                                                                                "\n                      "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : data[
                                                                          indextr
                                                                        ]
                                                                          .unshimmed_url
                                                                      ? _c(
                                                                          "p",
                                                                          {
                                                                            ref: `meta-title-${indextr}`,
                                                                            refInFor: true,
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.getMetaOgTitle(
                                                                                  data[
                                                                                    indextr
                                                                                  ]
                                                                                    .unshimmed_url,
                                                                                  `meta-title-${indextr}`,
                                                                                  indextr
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-video_view_count",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .video_view_count,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .video_view_count
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-video_view_count_15s",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .video_view_count_15s,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .video_view_count_15s
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-video_view_count_organic",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .video_view_count_organic,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .video_view_count_organic
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-video_view_count_paid",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .video_view_count_paid,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .video_view_count_paid
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-video_view_count_sound_on",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .video_view_count_sound_on,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .video_view_count_sound_on
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-td",
                                                      {
                                                        staticClass:
                                                          "t-video_view_time",
                                                        attrs: {
                                                          data: data[indextr]
                                                            .video_view_time,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.numberSpacing(
                                                                  data[indextr]
                                                                    .video_view_time
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          : undefined
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c("div", [
                                    _c("h3", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.reporting.section.videos-list.title"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c(
                                  "template",
                                  { slot: "thead" },
                                  [
                                    _c(
                                      "vs-th",
                                      { staticClass: "t-id" },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_id"
                                              ),
                                            },
                                          },
                                          [_c("span")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-date",
                                        attrs: { sortKey: "created_time" },
                                      },
                                      [
                                        _vm._v(
                                          " \n                " +
                                            _vm._s(
                                              _vm.capitalize(
                                                _vm.$t("dash.table.title.date")
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-msg",
                                        attrs: { sortKey: "message" },
                                      },
                                      [
                                        _vm._v(
                                          " \n                " +
                                            _vm._s(
                                              _vm.capitalize(
                                                _vm.$t(
                                                  "dash.table.title.content"
                                                )
                                              )
                                            ) +
                                            " \n                "
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-video_view_count",
                                        attrs: { sortKey: "video_view_count" },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_video_view_count"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.video_view_count"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-video_view_count_15s",
                                        attrs: {
                                          sortKey: "video_view_count_15s",
                                        },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_video_view_count_15s"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.video_view_count_15s"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass:
                                          "t-video_view_count_organic",
                                        attrs: {
                                          sortKey: "video_view_count_organic",
                                        },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_video_view_count_organic"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.video_view_count_organic"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-video_view_count_paid",
                                        attrs: {
                                          sortKey: "video_view_count_paid",
                                        },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_video_view_count_paid"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.video_view_count_paid"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass:
                                          "t-video_view_count_sound_on",
                                        attrs: {
                                          sortKey: "video_view_count_sound_on",
                                        },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_video_view_count_sound_on"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.video_view_count_sound_on"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        staticClass: "t-video_view_time",
                                        attrs: { sortKey: "video_view_time" },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.reporting.header_video_view_time"
                                              ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.video_view_time"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", { staticClass: "sort-th" }, [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_less\n                  "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    expand_more\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.pageStats &&
                  ((_vm.lastPage.network === "facebook" &&
                    !_vm.lastPage.isGroup &&
                    _vm.pageStats.postsPercentLoader == 100 &&
                    _vm.pageStats.page) ||
                    _vm.lastPage.network !== "facebook" ||
                    _vm.lastPage.isGroup) &&
                  _vm.pageStats.page.optimalTimes &&
                  _vm.pageStats.page.optimalTimes.optimalTimeSlots &&
                  !_vm.lastPage.isGroup &&
                  _vm.postList.length
                    ? _c(
                        "div",
                        { staticClass: "planning optimal-posts" },
                        [
                          _c("component-optimal-posts-planning", {
                            attrs: {
                              interaction: false,
                              network: this.lastPage.network,
                              optimalTimes: this.pageStats.page.optimalTimes,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.pageStats &&
                  _vm.pageStats.page &&
                  _vm.pageStats.postsPercentLoader == 100 &&
                  _vm.pageStats.page.concurrences &&
                  (["facebook", "instagram", "linkedin"].includes(
                    _vm.lastPage.network
                  ) ||
                    (_vm.lastPage.network === "tiktok" &&
                      _vm.checkConciergerie(_vm.lastPage))) &&
                  !_vm.lastPage.isGroup
                    ? _c("div", { staticClass: "section-graph concurrences" }, [
                        _c("div", { staticClass: "section-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "dash.reporting.section.concurrences.title"
                              )
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "section-subtitle" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "dash.reporting.section.concurrences.subtitle"
                              )
                            )
                          ),
                        ]),
                        !_vm.hideAddConcurrent
                          ? _c(
                              "div",
                              { staticClass: "add-concurrent" },
                              [
                                _c("vs-input", {
                                  staticClass: "inputx mention",
                                  attrs: {
                                    "vs-size": "large",
                                    type: "text",
                                    name: "mention",
                                    icon: "+",
                                    placeholder: _vm.$t(
                                      `dash.reporting.concurrent_name_placeholder${
                                        _vm.currentPage.network == "facebook" ||
                                        ([
                                          "linkedin",
                                          "instagram",
                                          "tiktok",
                                        ].includes(_vm.currentPage.network) &&
                                          _vm.currentPage.story_config &&
                                          _vm.currentPage.story_config.created)
                                          ? ""
                                          : "_url_" + _vm.currentPage.network
                                      }`
                                    ),
                                    "data-qa": "form-bot-add-mention",
                                    autocomplete: "off",
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                    },
                                    focus: function ($event) {
                                      return _vm.showSearchConcurrent()
                                    },
                                    keyup: function ($event) {
                                      return _vm.searchConcurrent()
                                    },
                                  },
                                  model: {
                                    value: _vm.concurrent,
                                    callback: function ($$v) {
                                      _vm.concurrent = $$v
                                    },
                                    expression: "concurrent",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.openSearchConcurrent &&
                                          _vm.concurrent &&
                                          _vm.concurrent.length >= 2 &&
                                          _vm.searchConcurrentResult &&
                                          _vm.searchConcurrentResult.length ==
                                            0,
                                        expression:
                                          "openSearchConcurrent && concurrent && concurrent.length >= 2 && searchConcurrentResult && searchConcurrentResult.length == 0",
                                      },
                                    ],
                                    staticClass: "mentions-load",
                                  },
                                  [
                                    _c("component-loader", {
                                      attrs: {
                                        progress: 90,
                                        unlimitedProgress: true,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.openSearchConcurrent &&
                                          _vm.concurrent &&
                                          _vm.concurrent.length >= 2 &&
                                          _vm.searchConcurrentResult &&
                                          _vm.searchConcurrentResult.length,
                                        expression:
                                          "openSearchConcurrent && concurrent && concurrent.length >= 2 && searchConcurrentResult && searchConcurrentResult.length",
                                      },
                                    ],
                                    staticClass: "mentions-close",
                                    on: {
                                      click: function ($event) {
                                        return _vm.closeSearchConcurrent()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("dash.button.close")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.openSearchConcurrent &&
                                          _vm.concurrent &&
                                          _vm.concurrent.length >= 2 &&
                                          _vm.searchConcurrentResult &&
                                          _vm.searchConcurrentResult.length,
                                        expression:
                                          "openSearchConcurrent && concurrent && concurrent.length >= 2 && searchConcurrentResult && searchConcurrentResult.length",
                                      },
                                    ],
                                    key: `search-concurrent`,
                                    staticClass: "auto-mentions row box",
                                    class: _vm.currentPage.network,
                                    attrs: {
                                      "data-qa":
                                        "form-bot-select-auto-mentions",
                                    },
                                  },
                                  [
                                    _c(
                                      "ul",
                                      _vm._l(
                                        _vm.searchConcurrentResult,
                                        function (mention, index) {
                                          return _c(
                                            "li",
                                            { key: `list-concurrent-${index}` },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.addConcurrent(
                                                        mention
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  mention.image
                                                    ? _c("img", {
                                                        staticClass: "image",
                                                        attrs: {
                                                          alt: mention.name,
                                                          src: mention.image,
                                                        },
                                                      })
                                                    : _c("span", {
                                                        staticClass: "image",
                                                      }),
                                                  _c(
                                                    "div",
                                                    { staticClass: "content" },
                                                    [
                                                      _c(
                                                        "p",
                                                        { staticClass: "name" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(mention.name)
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.currentPage.network ==
                                                      "twitter"
                                                        ? _c("img", {
                                                            attrs: {
                                                              alt: "verified account",
                                                              src: require("../../../assets/img/validated-twitter.png"),
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm.currentPage.network ==
                                                      "facebook"
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "screen_name id",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  mention.id
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "screen_name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "@" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .currentPage
                                                                      .network ==
                                                                      "twitter"
                                                                      ? mention.screen_name
                                                                      : _vm
                                                                          .currentPage
                                                                          .network ==
                                                                        "instagram"
                                                                      ? mention.id ||
                                                                        mention.name
                                                                      : mention.name
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                      [
                                                        "twitter",
                                                        "linkedin",
                                                      ].includes(
                                                        _vm.currentPage.network
                                                      )
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "description",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  mention.description
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.pageStats.page && _vm.pageStats.page.concurrences
                          ? _c(
                              "ul",
                              { staticClass: "concurrents-list" },
                              [
                                _c("li", { staticClass: "head" }, [
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "dash.reporting.section.concurrences.list.head.name"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "follower_count sortable",
                                      class: {
                                        active:
                                          _vm.concurrentSortKey ===
                                          "follower_count",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.sortConcurrents(
                                            "follower_count"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "dash.reporting.section.concurrences.list.head.follower_count"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "sort-indicator" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.concurrentSortKey ===
                                                "follower_count"
                                                ? _vm.concurrentSortDir ===
                                                  "desc"
                                                  ? "↓"
                                                  : "↑"
                                                : "↕"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm.currentPage.network == "tiktok"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "follower_variation sortable",
                                          class: {
                                            active:
                                              _vm.concurrentSortKey ===
                                              "follower_variation",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.sortConcurrents(
                                                "follower_variation"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.reporting.section.concurrences.list.head.follower_variation"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-indicator" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.concurrentSortKey ===
                                                    "follower_variation"
                                                    ? _vm.concurrentSortDir ===
                                                      "desc"
                                                      ? "↓"
                                                      : "↑"
                                                    : "↕"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "posts_count sortable",
                                      class: {
                                        active:
                                          _vm.concurrentSortKey ===
                                          "posts_count",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.sortConcurrents(
                                            "posts_count"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "dash.reporting.section.concurrences.list.head.posts_count"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "sort-indicator" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.concurrentSortKey ===
                                                "posts_count"
                                                ? _vm.concurrentSortDir ===
                                                  "desc"
                                                  ? "↓"
                                                  : "↑"
                                                : "↕"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm.currentPage.network != "tiktok"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "like_count sortable",
                                          class: {
                                            active:
                                              _vm.concurrentSortKey ===
                                              "like_count",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.sortConcurrents(
                                                "like_count"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  `dash.reporting.section.concurrences.list.head.like_count${
                                                    _vm.currentPage.network ==
                                                    "linkedin"
                                                      ? "_reactions"
                                                      : ""
                                                  }`
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-indicator" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.concurrentSortKey ===
                                                    "like_count"
                                                    ? _vm.concurrentSortDir ===
                                                      "desc"
                                                      ? "↓"
                                                      : "↑"
                                                    : "↕"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network == "tiktok"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "likes_count sortable",
                                          class: {
                                            active:
                                              _vm.concurrentSortKey ===
                                              "likes_count",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.sortConcurrents(
                                                "likes_count"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.reporting.section.concurrences.list.head.likes_count"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-indicator" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.concurrentSortKey ===
                                                    "likes_count"
                                                    ? _vm.concurrentSortDir ===
                                                      "desc"
                                                      ? "↓"
                                                      : "↑"
                                                    : "↕"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network == "facebook"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "shares_count sortable",
                                          class: {
                                            active:
                                              _vm.concurrentSortKey ===
                                              "shares_count",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.sortConcurrents(
                                                "shares_count"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.reporting.section.concurrences.list.head.shares_count"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-indicator" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.concurrentSortKey ===
                                                    "shares_count"
                                                    ? _vm.concurrentSortDir ===
                                                      "desc"
                                                      ? "↓"
                                                      : "↑"
                                                    : "↕"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network != "tiktok"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "comments_count sortable",
                                          class: {
                                            active:
                                              _vm.concurrentSortKey ===
                                              "comments_count",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.sortConcurrents(
                                                "comments_count"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.reporting.section.concurrences.list.head.comments_count"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-indicator" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.concurrentSortKey ===
                                                    "comments_count"
                                                    ? _vm.concurrentSortDir ===
                                                      "desc"
                                                      ? "↓"
                                                      : "↑"
                                                    : "↕"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network == "facebook"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "reactions_count sortable",
                                          class: {
                                            active:
                                              _vm.concurrentSortKey ===
                                              "reactions_count",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.sortConcurrents(
                                                "reactions_count"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.reporting.section.concurrences.list.head.reactions_count"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-indicator" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.concurrentSortKey ===
                                                    "reactions_count"
                                                    ? _vm.concurrentSortDir ===
                                                      "desc"
                                                      ? "↓"
                                                      : "↑"
                                                    : "↕"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network != "tiktok"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "engagement sortable",
                                          class: {
                                            active:
                                              _vm.concurrentSortKey ===
                                              "engagement",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.sortConcurrents(
                                                "engagement"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.reporting.concurrent.engagement"
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.reporting.section.concurrences.list.head.engagement"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "sort-indicator" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.concurrentSortKey ===
                                                    "engagement"
                                                    ? _vm.concurrentSortDir ===
                                                      "desc"
                                                      ? "↓"
                                                      : "↑"
                                                    : "↕"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _c("li", [
                                  _c(
                                    "div",
                                    { staticClass: "name no-action" },
                                    [
                                      _c(
                                        "Tooltip",
                                        { attrs: { text: _vm.lastPage.name } },
                                        [
                                          _vm.lastPage.avatar
                                            ? _c("img", {
                                                staticClass: "avatar",
                                                attrs: {
                                                  src: _vm.lastPage.avatar,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.lastPage.name) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "follower_count" },
                                    [
                                      _vm.currentPage.network == "facebook" &&
                                      _vm.graphData.find(
                                        (g) => g.name == "page_follows"
                                      )
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.graphData.find(
                                                    (g) =>
                                                      g.name == "page_follows"
                                                  ).data[
                                                    _vm.graphData.find(
                                                      (g) =>
                                                        g.name == "page_follows"
                                                    ).data.length - 1
                                                  ]
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.unityArround(
                                                      _vm.graphData.find(
                                                        (g) =>
                                                          g.name ==
                                                          "page_follows"
                                                      ).data[
                                                        _vm.graphData.find(
                                                          (g) =>
                                                            g.name ==
                                                            "page_follows"
                                                        ).data.length - 1
                                                      ]
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : [
                                            "instagram",
                                            "linkedin",
                                            "tiktok",
                                          ].includes(_vm.currentPage.network) &&
                                          _vm.pageStats.page.page_fans
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.pageStats.page.page_fans
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.unityArround(
                                                      _vm.pageStats.page
                                                        .page_fans
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : [
                                            _vm._v(
                                              "\n                N/A\n              "
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm.currentPage.network == "tiktok"
                                    ? _c(
                                        "div",
                                        { staticClass: "follower_variation" },
                                        [
                                          _vm.pageStats.page.page_follows &&
                                          _vm.pageStats.page.page_follows
                                            .length > 1
                                            ? [
                                                _c(
                                                  "span",
                                                  {
                                                    class: {
                                                      positive:
                                                        _vm.pageStats.page
                                                          .page_follows[
                                                          _vm.pageStats.page
                                                            .page_follows
                                                            .length - 1
                                                        ].total -
                                                          _vm.pageStats.page
                                                            .page_follows[0]
                                                            .total >
                                                        0,
                                                      negative:
                                                        _vm.pageStats.page
                                                          .page_follows[
                                                          _vm.pageStats.page
                                                            .page_follows
                                                            .length - 1
                                                        ].total -
                                                          _vm.pageStats.page
                                                            .page_follows[0]
                                                            .total <
                                                        0,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.pageStats.page
                                                            .page_follows[
                                                            _vm.pageStats.page
                                                              .page_follows
                                                              .length - 1
                                                          ].total -
                                                            _vm.pageStats.page
                                                              .page_follows[0]
                                                              .total >
                                                            0
                                                            ? "+"
                                                            : ""
                                                        ) +
                                                        _vm._s(
                                                          _vm.numberSpacing(
                                                            _vm.pageStats.page
                                                              .page_follows[
                                                              _vm.pageStats.page
                                                                .page_follows
                                                                .length - 1
                                                            ].total -
                                                              _vm.pageStats.page
                                                                .page_follows[0]
                                                                .total
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                N/A\n              "
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "posts_count" },
                                    [
                                      _vm.pageStats.posts &&
                                      Array.isArray(_vm.pageStats.posts) &&
                                      _vm.pageStats.posts.length
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.numberSpacing(
                                                  _vm.pageStats.posts.length
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.unityArround(
                                                      _vm.pageStats.posts.length
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.pageStats.posts
                                                    ? 0
                                                    : "N/A"
                                                ) +
                                                "\n              "
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm.currentPage.network != "tiktok"
                                    ? _c(
                                        "div",
                                        { staticClass: "like_count" },
                                        [
                                          _vm.currentPage.network ==
                                            "facebook" &&
                                          _vm.pageStats.posts &&
                                          Array.isArray(_vm.pageStats.posts) &&
                                          _vm.pageStats.posts.length
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.numberSpacing(
                                                      _vm.pageStats.posts.reduce(
                                                        (previous, current) =>
                                                          previous +
                                                          current
                                                            .post_reactions[0]
                                                            .value.like,
                                                        0
                                                      )
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.unityArround(
                                                          _vm.pageStats.posts.reduce(
                                                            (
                                                              previous,
                                                              current
                                                            ) =>
                                                              previous +
                                                              current
                                                                .post_reactions[0]
                                                                .value.like,
                                                            0
                                                          )
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm.currentPage.network ==
                                                "instagram" &&
                                              _vm.pageStats.posts &&
                                              Array.isArray(
                                                _vm.pageStats.posts
                                              ) &&
                                              _vm.pageStats.posts.length
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.numberSpacing(
                                                      _vm.pageStats.posts.reduce(
                                                        (previous, current) =>
                                                          previous +
                                                          (typeof current.like_count ==
                                                          "number"
                                                            ? current.like_count
                                                            : 0),
                                                        0
                                                      )
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.unityArround(
                                                          _vm.pageStats.posts.reduce(
                                                            (
                                                              previous,
                                                              current
                                                            ) =>
                                                              previous +
                                                              (typeof current.like_count ==
                                                              "number"
                                                                ? current.like_count
                                                                : 0),
                                                            0
                                                          )
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm.currentPage.network ==
                                                "linkedin" &&
                                              _vm.pageStats.posts &&
                                              Array.isArray(
                                                _vm.pageStats.posts
                                              ) &&
                                              _vm.pageStats.posts.length
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.numberSpacing(
                                                      _vm.pageStats.posts.reduce(
                                                        (previous, current) =>
                                                          previous +
                                                          current.reactions_count,
                                                        0
                                                      )
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.unityArround(
                                                          _vm.pageStats.posts.reduce(
                                                            (
                                                              previous,
                                                              current
                                                            ) =>
                                                              previous +
                                                              current
                                                                .post_reactions[0]
                                                                .sum,
                                                            0
                                                          )
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.pageStats.posts
                                                        ? 0
                                                        : "N/A"
                                                    ) +
                                                    "\n              "
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network == "tiktok"
                                    ? _c(
                                        "div",
                                        { staticClass: "likes_count" },
                                        [
                                          _vm.pageStats.page.page_likes
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.numberSpacing(
                                                      _vm.pageStats.page
                                                        .page_likes
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.unityArround(
                                                          _vm.pageStats.page
                                                            .page_likes
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : [
                                                _vm._v(
                                                  "\n                N/A\n              "
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network == "facebook"
                                    ? _c(
                                        "div",
                                        { staticClass: "shares_count" },
                                        [
                                          _vm.pageStats.posts &&
                                          Array.isArray(_vm.pageStats.posts) &&
                                          _vm.pageStats.posts.length
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.numberSpacing(
                                                      _vm.pageStats.posts.reduce(
                                                        (previous, current) =>
                                                          previous +
                                                          current.shares_count,
                                                        0
                                                      )
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.unityArround(
                                                          _vm.pageStats.posts.reduce(
                                                            (
                                                              previous,
                                                              current
                                                            ) =>
                                                              previous +
                                                              current.shares_count,
                                                            0
                                                          )
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.pageStats.posts
                                                        ? 0
                                                        : "N/A"
                                                    ) +
                                                    "\n              "
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network != "tiktok"
                                    ? _c(
                                        "div",
                                        { staticClass: "comments_count" },
                                        [
                                          _vm.pageStats.posts &&
                                          Array.isArray(_vm.pageStats.posts) &&
                                          _vm.pageStats.posts.length
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.numberSpacing(
                                                      _vm.pageStats.posts.reduce(
                                                        (previous, current) =>
                                                          previous +
                                                          (typeof current.comments_count ==
                                                          "number"
                                                            ? current.comments_count
                                                            : 0),
                                                        0
                                                      )
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.unityArround(
                                                          _vm.pageStats.posts.reduce(
                                                            (
                                                              previous,
                                                              current
                                                            ) =>
                                                              previous +
                                                              (typeof current.comments_count ==
                                                              "number"
                                                                ? current.comments_count
                                                                : 0),
                                                            0
                                                          )
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.pageStats.posts
                                                        ? 0
                                                        : "N/A"
                                                    ) +
                                                    "\n              "
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network == "facebook"
                                    ? _c(
                                        "div",
                                        { staticClass: "reactions_count" },
                                        [
                                          _vm.pageStats.posts &&
                                          Array.isArray(_vm.pageStats.posts) &&
                                          _vm.pageStats.posts.length
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.numberSpacing(
                                                      _vm.pageStats.posts.reduce(
                                                        (previous, current) =>
                                                          previous +
                                                          current.post_reactions_sum,
                                                        0
                                                      )
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.unityArround(
                                                          _vm.pageStats.posts.reduce(
                                                            (
                                                              previous,
                                                              current
                                                            ) =>
                                                              previous +
                                                              current.post_reactions_sum,
                                                            0
                                                          )
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.pageStats.posts
                                                        ? 0
                                                        : "N/A"
                                                    ) +
                                                    "\n              "
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.currentPage.network == "facebook"
                                    ? _c("div", { staticClass: "engagement" }, [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.pageStats.posts &&
                                                Array.isArray(
                                                  _vm.pageStats.posts
                                                ) &&
                                                _vm.pageStats.posts.length
                                                ? _vm.unityArround(
                                                    (
                                                      (1000 *
                                                        _vm.pageStats.posts.reduce(
                                                          (previous, current) =>
                                                            previous +
                                                            current.shares_count +
                                                            current.comments_count +
                                                            current.post_reactions_sum,
                                                          0
                                                        )) /
                                                      _vm.pageStats.posts
                                                        .length /
                                                      _vm.graphData.find(
                                                        (g) =>
                                                          g.name ==
                                                          "page_follows"
                                                      ).data[
                                                        _vm.graphData.find(
                                                          (g) =>
                                                            g.name ==
                                                            "page_follows"
                                                        ).data.length - 1
                                                      ]
                                                    ).toFixed(1)
                                                  )
                                                : "N/A"
                                            ) +
                                            "\n            "
                                        ),
                                      ])
                                    : _vm.currentPage.network != "tiktok"
                                    ? _c("div", { staticClass: "engagement" }, [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.pageStats.posts &&
                                                Array.isArray(
                                                  _vm.pageStats.posts
                                                ) &&
                                                _vm.pageStats.posts.length
                                                ? _vm.unityArround(
                                                    (
                                                      (1000 *
                                                        _vm.pageStats.posts.reduce(
                                                          (previous, current) =>
                                                            previous +
                                                            (typeof current.comments_count ==
                                                            "number"
                                                              ? current.comments_count
                                                              : 0) +
                                                            (_vm.currentPage
                                                              .network ==
                                                            "instagram"
                                                              ? typeof current.like_count ==
                                                                "number"
                                                                ? current.like_count
                                                                : 0
                                                              : current
                                                                  .post_reactions[0]
                                                                  .sum),
                                                          0
                                                        )) /
                                                      _vm.pageStats.posts
                                                        .length /
                                                      _vm.pageStats.page
                                                        .page_fans
                                                    ).toFixed(1)
                                                  )
                                                : "N/A"
                                            ) +
                                            "\n            "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._l(
                                  _vm.sortedConcurrences,
                                  function (concurrentResult, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: `concurrent-${index}${
                                          _vm.hideAddConcurrent ? "-load" : ""
                                        }`,
                                      },
                                      [
                                        JSON.parse(
                                          _vm.localStorage.reportingConcurrences
                                        )
                                          .find(
                                            (c) => c.id == _vm.currentPage.id
                                          )
                                          .data.find((c) =>
                                            [
                                              c.id ? c.id.toString() : null,
                                              c.name,
                                            ].includes(
                                              concurrentResult.concurrent.toString()
                                            )
                                          )
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "name" },
                                                [
                                                  _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: JSON.parse(
                                                          _vm.localStorage
                                                            .reportingConcurrences
                                                        )
                                                          .find(
                                                            (c) =>
                                                              c.id ==
                                                              _vm.currentPage.id
                                                          )
                                                          .data.find((c) =>
                                                            [
                                                              c.id
                                                                ? c.id.toString()
                                                                : null,
                                                              c.name,
                                                            ].includes(
                                                              concurrentResult.concurrent.toString()
                                                            )
                                                          ).name,
                                                      },
                                                    },
                                                    [
                                                      concurrentResult.pagePicture &&
                                                      concurrentResult
                                                        .pagePicture.data &&
                                                      concurrentResult
                                                        .pagePicture.data.url
                                                        ? _c("img", {
                                                            staticClass:
                                                              "avatar",
                                                            attrs: {
                                                              src: concurrentResult
                                                                .pagePicture
                                                                .data.url,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            JSON.parse(
                                                              _vm.localStorage
                                                                .reportingConcurrences
                                                            )
                                                              .find(
                                                                (c) =>
                                                                  c.id ==
                                                                  _vm
                                                                    .currentPage
                                                                    .id
                                                              )
                                                              .data.find((c) =>
                                                                [
                                                                  c.id
                                                                    ? c.id.toString()
                                                                    : null,
                                                                  c.name,
                                                                ].includes(
                                                                  concurrentResult.concurrent.toString()
                                                                )
                                                              ).name
                                                          ) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  ),
                                                  !_vm.hideAddConcurrent
                                                    ? _c("img", {
                                                        staticClass: "refresh",
                                                        attrs: {
                                                          src: require("../../../assets/img/icon_refresh_reload.svg"),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.refreshConcurrent(
                                                              concurrentResult.concurrent
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _c("img", {
                                                    staticClass: "remove",
                                                    attrs: {
                                                      src: require("../../../assets/img/status-deleted.png"),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeConcurrent(
                                                          concurrentResult.concurrent
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm.currentPage.network ===
                                                    "tiktok" &&
                                                  (!concurrentResult.concurrentHistory ||
                                                    concurrentResult
                                                      .concurrentHistory
                                                      .length === 0)
                                                    ? _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.$t(
                                                              "dash.reporting.concurrent.live_data_warning"
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "live-data-warning",
                                                            },
                                                            [_vm._v("⚠️")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              concurrentResult.load
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "load-concurrent",
                                                    },
                                                    [
                                                      _c("component-loader", {
                                                        attrs: {
                                                          progress: 90,
                                                          unlimitedProgress: true,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "follower_count",
                                                },
                                                [
                                                  concurrentResult.pageFollowers
                                                    ? _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.numberSpacing(
                                                              concurrentResult.pageFollowers
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.unityArround(
                                                                  concurrentResult.pageFollowers
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : [
                                                        _vm._v(
                                                          "\n                  N/A\n                "
                                                        ),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _vm.currentPage.network ==
                                              "tiktok"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "follower_variation",
                                                    },
                                                    [
                                                      concurrentResult.pageFollowersVariation !==
                                                        null &&
                                                      concurrentResult.pageFollowersVariation !==
                                                        undefined
                                                        ? [
                                                            _c(
                                                              "span",
                                                              {
                                                                class: {
                                                                  positive:
                                                                    concurrentResult.pageFollowersVariation >
                                                                    0,
                                                                  negative:
                                                                    concurrentResult.pageFollowersVariation <
                                                                    0,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      concurrentResult.pageFollowersVariation >
                                                                        0
                                                                        ? "+"
                                                                        : ""
                                                                    ) +
                                                                    _vm._s(
                                                                      _vm.numberSpacing(
                                                                        concurrentResult.pageFollowersVariation
                                                                      )
                                                                    ) +
                                                                    "\n                  "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : [
                                                            _vm._v(
                                                              "\n                  N/A\n                "
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.currentPage.network !=
                                              "tiktok"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "posts_count",
                                                    },
                                                    [
                                                      concurrentResult.posts &&
                                                      Array.isArray(
                                                        concurrentResult.posts
                                                      ) &&
                                                      concurrentResult.posts
                                                        .length
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult
                                                                    .posts
                                                                    .length
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult
                                                                        .posts
                                                                        .length
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  concurrentResult.posts
                                                                    ? 0
                                                                    : "N/A"
                                                                ) +
                                                                "\n                "
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.currentPage.network ==
                                              "tiktok"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "posts_count",
                                                    },
                                                    [
                                                      concurrentResult.pagePostCount
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult.pagePostCount
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult.pagePostCount
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : [
                                                            _vm._v(
                                                              "\n                  N/A\n                "
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.currentPage.network !=
                                              "tiktok"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "like_count",
                                                    },
                                                    [
                                                      _vm.currentPage.network ==
                                                        "facebook" &&
                                                      concurrentResult.posts &&
                                                      Array.isArray(
                                                        concurrentResult.posts
                                                      ) &&
                                                      concurrentResult.posts
                                                        .length
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult.posts.reduce(
                                                                    (
                                                                      previous,
                                                                      current
                                                                    ) =>
                                                                      previous +
                                                                      (current &&
                                                                      current.likes
                                                                        ? current
                                                                            .likes
                                                                            .summary
                                                                            .total_count
                                                                        : 0),
                                                                    0
                                                                  )
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult.posts.reduce(
                                                                        (
                                                                          previous,
                                                                          current
                                                                        ) =>
                                                                          previous +
                                                                          (current &&
                                                                          current.likes
                                                                            ? current
                                                                                .likes
                                                                                .summary
                                                                                .total_count
                                                                            : 0),
                                                                        0
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm.currentPage
                                                            .network ==
                                                            "instagram" &&
                                                          concurrentResult.posts &&
                                                          Array.isArray(
                                                            concurrentResult.posts
                                                          ) &&
                                                          concurrentResult.posts
                                                            .length
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult.posts.reduce(
                                                                    (
                                                                      previous,
                                                                      current
                                                                    ) =>
                                                                      previous +
                                                                      current.like_count,
                                                                    0
                                                                  )
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult.posts.reduce(
                                                                        (
                                                                          previous,
                                                                          current
                                                                        ) =>
                                                                          previous +
                                                                          (current.like_count ||
                                                                            0),
                                                                        0
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm.currentPage
                                                            .network ==
                                                            "linkedin" &&
                                                          concurrentResult.posts &&
                                                          Array.isArray(
                                                            concurrentResult.posts
                                                          ) &&
                                                          concurrentResult.posts
                                                            .length
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult.posts.reduce(
                                                                    (
                                                                      previous,
                                                                      current
                                                                    ) =>
                                                                      previous +
                                                                      current.reactions_count,
                                                                    0
                                                                  )
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult.posts.reduce(
                                                                        (
                                                                          previous,
                                                                          current
                                                                        ) =>
                                                                          previous +
                                                                          current.reactions_count,
                                                                        0
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  concurrentResult.posts
                                                                    ? 0
                                                                    : "N/A"
                                                                ) +
                                                                "\n                "
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.currentPage.network ==
                                              "tiktok"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "likes_count",
                                                    },
                                                    [
                                                      concurrentResult.pageLikes
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult.pageLikes
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult.pageLikes
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : [
                                                            _vm._v(
                                                              "\n                  N/A\n                "
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.currentPage.network ==
                                              "facebook"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "shares_count",
                                                    },
                                                    [
                                                      concurrentResult.posts &&
                                                      Array.isArray(
                                                        concurrentResult.posts
                                                      ) &&
                                                      concurrentResult.posts
                                                        .length
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult.posts.reduce(
                                                                    (
                                                                      previous,
                                                                      current
                                                                    ) =>
                                                                      previous +
                                                                      (current &&
                                                                      current.shares
                                                                        ? current
                                                                            .shares
                                                                            .count
                                                                        : 0),
                                                                    0
                                                                  )
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult.posts.reduce(
                                                                        (
                                                                          previous,
                                                                          current
                                                                        ) =>
                                                                          previous +
                                                                          (current &&
                                                                          current.shares
                                                                            ? current
                                                                                .shares
                                                                                .count
                                                                            : 0),
                                                                        0
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  concurrentResult.posts
                                                                    ? 0
                                                                    : "N/A"
                                                                ) +
                                                                "\n                "
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.currentPage.network !=
                                              "tiktok"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "comments_count",
                                                    },
                                                    [
                                                      _vm.currentPage.network ==
                                                        "facebook" &&
                                                      concurrentResult.posts &&
                                                      Array.isArray(
                                                        concurrentResult.posts
                                                      ) &&
                                                      concurrentResult.posts
                                                        .length
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult.posts.reduce(
                                                                    (
                                                                      previous,
                                                                      current
                                                                    ) =>
                                                                      previous +
                                                                      current
                                                                        .comments
                                                                        .summary
                                                                        .total_count,
                                                                    0
                                                                  )
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult.posts.reduce(
                                                                        (
                                                                          previous,
                                                                          current
                                                                        ) =>
                                                                          previous +
                                                                          current
                                                                            .comments
                                                                            .summary
                                                                            .total_count,
                                                                        0
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : [
                                                            "instagram",
                                                            "linkedin",
                                                          ].includes(
                                                            _vm.currentPage
                                                              .network
                                                          ) &&
                                                          concurrentResult.posts &&
                                                          Array.isArray(
                                                            concurrentResult.posts
                                                          ) &&
                                                          concurrentResult.posts
                                                            .length
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult.posts.reduce(
                                                                    (
                                                                      previous,
                                                                      current
                                                                    ) =>
                                                                      previous +
                                                                      current.comments_count,
                                                                    0
                                                                  )
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult.posts.reduce(
                                                                        (
                                                                          previous,
                                                                          current
                                                                        ) =>
                                                                          previous +
                                                                          current.comments_count,
                                                                        0
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  concurrentResult.posts
                                                                    ? 0
                                                                    : "N/A"
                                                                ) +
                                                                "\n                "
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.currentPage.network ==
                                              "facebook"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "reactions_count",
                                                    },
                                                    [
                                                      concurrentResult.posts &&
                                                      Array.isArray(
                                                        concurrentResult.posts
                                                      ) &&
                                                      concurrentResult.posts
                                                        .length
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.numberSpacing(
                                                                  concurrentResult.posts.reduce(
                                                                    (
                                                                      previous,
                                                                      current
                                                                    ) =>
                                                                      previous +
                                                                      current
                                                                        .reactions
                                                                        .summary
                                                                        .total_count,
                                                                    0
                                                                  )
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.unityArround(
                                                                      concurrentResult.posts.reduce(
                                                                        (
                                                                          previous,
                                                                          current
                                                                        ) =>
                                                                          previous +
                                                                          current
                                                                            .reactions
                                                                            .summary
                                                                            .total_count,
                                                                        0
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  concurrentResult.posts
                                                                    ? 0
                                                                    : "N/A"
                                                                ) +
                                                                "\n                "
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.currentPage.network ==
                                              "facebook"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "engagement",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            concurrentResult.posts &&
                                                              Array.isArray(
                                                                concurrentResult.posts
                                                              ) &&
                                                              concurrentResult
                                                                .posts.length
                                                              ? _vm.unityArround(
                                                                  (
                                                                    (1000 *
                                                                      concurrentResult.posts.reduce(
                                                                        (
                                                                          previous,
                                                                          current
                                                                        ) =>
                                                                          previous +
                                                                          (current.shares
                                                                            ? current
                                                                                .shares
                                                                                .count
                                                                            : 0) +
                                                                          current
                                                                            .comments
                                                                            .summary
                                                                            .total_count +
                                                                          current
                                                                            .reactions
                                                                            .summary
                                                                            .total_count,
                                                                        0
                                                                      )) /
                                                                    concurrentResult
                                                                      .posts
                                                                      .length /
                                                                    concurrentResult.pageFollowers
                                                                  ).toFixed(1)
                                                                )
                                                              : concurrentResult.posts
                                                              ? 0
                                                              : "N/A"
                                                          ) +
                                                          "\n              "
                                                      ),
                                                    ]
                                                  )
                                                : _vm.currentPage.network !=
                                                  "tiktok"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "engagement",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            concurrentResult.posts &&
                                                              Array.isArray(
                                                                concurrentResult.posts
                                                              ) &&
                                                              concurrentResult
                                                                .posts.length
                                                              ? _vm.unityArround(
                                                                  (
                                                                    (1000 *
                                                                      concurrentResult.posts.reduce(
                                                                        (
                                                                          previous,
                                                                          current
                                                                        ) =>
                                                                          previous +
                                                                          current.comments_count +
                                                                          (_vm
                                                                            .currentPage
                                                                            .network ==
                                                                          "instagram"
                                                                            ? current.like_count ||
                                                                              0
                                                                            : current.reactions_count),
                                                                        0
                                                                      )) /
                                                                    concurrentResult
                                                                      .posts
                                                                      .length /
                                                                    concurrentResult.pageFollowers
                                                                  ).toFixed(1)
                                                                )
                                                              : concurrentResult.posts
                                                              ? 0
                                                              : "N/A"
                                                          ) +
                                                          "\n              "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm.showProgressiveLoad &&
                  !(
                    _vm.pageStats &&
                    _vm.pageStats.postsPercentLoader >= 0 &&
                    _vm.pageStats.postsPercentLoader <= 100
                  )
                    ? _c(
                        "div",
                        { staticClass: "progressive-load" },
                        [
                          _c("component-loader", {
                            attrs: { progress: 90, unlimitedProgress: true },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              )
            : _c("PrintPdf", {
                attrs: {
                  graphData: _vm.graphData,
                  pageStats: _vm.pageStats,
                  currentPage: _vm.currentPage,
                  getPreviousPeriod: _vm.getPreviousPeriod,
                  graphLabels: _vm.graphLabels,
                  dateStart: _vm.dateStart.getTime(),
                  dateEnd: _vm.dateEnd.getTime(),
                },
              }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }